webpackJsonp([1],{

/***/ "+QOj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1Sp5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4KD4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hot_q.e6eb22a.png";

/***/ }),

/***/ "5WOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bsxs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "K4jA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MEgf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: loading_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

/* eslint-disable */



/* harmony default export */ var App = ({
  name: 'app',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      transitionName: '',
      isloading: false,
      loadingText: ''
    };
  },

  created: function created() {},
  watch: {
    '$route': function $route(to, from) {
      if (to.path === '/') {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

/* eslint-disable */



/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      transitionName: '',
      isloading: false,
      loadingText: ''
    };
  },

  created: function created() {},
  watch: {
    '$route': function $route(to, from) {
      if (to.path === '/') {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df07dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isloading)?_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"child-view"}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(!_vm.isloading)?_c('transition',{attrs:{"name":_vm.transitionName}},[(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"child-view"}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('loading',{attrs:{"show":_vm.isloading,"text":_vm.loadingText}})],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("yy5e")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/common/common.js
var linkPatterns = [
// submitPattern 含class
[/\[link\s+submit=['"]+([^[\]'"]+)['"]+\s+class=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a id="submitLink" href="javascript:void(0);" class="$2 a-link">$3</a><span style="display:none;">$1</span>'],
// submitPattern
[/\[link\s+submit=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a id="submitLink" href="javascript:void(0);" class="a-link">$2</a><span style="display:none;">$1</span>'], [/\[link\s+submit=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a id="submitLink" href="javascript:void(0);" class="a-link">$2</a><span style="display:none;">$1</span>'],
// defalutPattern
[/\[link\](.*?)\[\/link\]/gi, '<a id="submitLink" href="javascript:void(0);" class="a-link">$1</a>'], [/<a id="submitLink".*?>.*?<\/a>/gi, function (p) {
    return p.replace(/(http|ftp|https)/gi, '$1_');
}],
// urlPattern
[/\[link\s+url=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="$1" target="_blank">$2</a>'], [/\[link\s+url=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="$1" target="_blank">$2</a>'],
// p4Pattern1
[/\[link\s+p4=['"]+([^[\]'"]+)['"]+\s+title=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$3</a>'], [/\[link\s+p4=([^\s[\]'"]+)\s+title=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$3</a>'],
// p4Pattern2
[/\[link\s+p4=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$2</a>'], [/\[link\s+p4=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi, '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$2</a>']];
var emoBoxlist = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极'];

var formatMsg = function formatMsg(content) {
    return content.replace(/\[[\u4E00-\u9FA5]{1,3}\]/gi, function (word) {
        var newWord = word.replace(/\[|\]/gi, '');
        var index = emoBoxlist.indexOf(newWord);
        return '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/' + index + '.gif" align="top">';
    });
};

/* harmony default export */ var common = ({
    // 表情列表
    emoBoxlist: emoBoxlist,
    // 判断是否为空
    isEmpty: function isEmpty(value) {
        var flag = false;
        if (value === null || value === 'null' || value === '' || value === undefined) {
            flag = true;
        }
        return flag;
    },

    formatMsg: formatMsg,
    // 格式化文本内容
    convertMsg: function convertMsg(body) {
        var htmlContent = body;
        var title = '';
        htmlContent = htmlContent.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
        htmlContent = htmlContent.replace(/\[href=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            var name = Regstr.match(/\[href=(.*?)\]/)[1];
            return '<a href="' + window.location.href + '" ' + '>' + name + '</a>';
        }).replace(/\[content=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            var name = Regstr.match(/\[content=(.*?)\]/)[1];
            return name;
        }).replace(/\[name=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            var name = Regstr.match(/\[name=(.*?)\]/)[1];
            title = name;
            return '';
        }).replace(/\[url=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            var name = Regstr.match(/\[url=(.*?)\]/)[1];
            return '<a href="' + name + '" target="_blank">' + title + '</a>';
        });
        for (var i = 0; i < linkPatterns.length; i++) {
            htmlContent = htmlContent.replace(linkPatterns[i][0], linkPatterns[i][1]);
        }
        htmlContent = formatMsg(htmlContent);
        return htmlContent;
    },
    getOpenId: function getOpenId() {
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4';
        s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    },
    getRandomAlphaNum: function getRandomAlphaNum(len) {
        var rdmString = '';
        for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2)) {}
        return rdmString.substr(0, len);
    },
    getUrlParams: function getUrlParams(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var url = location.search; // 获取url中"?"符后的字串
        var str = url.substr(1).match(reg);
        if (str != null) {
            return unescape(str[2]);
        }
        return null;
    },
    formatTime: function formatTime(fmt, date) {
        var ret = void 0;
        var opt = {
            'Y+': date.getFullYear().toString(), // 年
            'm+': (date.getMonth() + 1).toString(), // 月
            'd+': date.getDate().toString(), // 日
            'H+': date.getHours().toString(), // 时
            'M+': date.getMinutes().toString(), // 分
            'S+': date.getSeconds().toString() // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (var k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
            };
        };
        return fmt;
    }
});
// EXTERNAL MODULE: ./node_modules/sha1/sha1.js
var sha1 = __webpack_require__("uXeI");
var sha1_default = /*#__PURE__*/__webpack_require__.n(sha1);

// CONCATENATED MODULE: ./src/service/fetch.js




axios_default.a.defaults.timeout = 100000;
axios_default.a.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.baseURL = '/client_web_api';

console.log(new Date().valueOf());

// 请求拦截
axios_default.a.interceptors.request.use(function (config) {
  var nonce = common.getRandomAlphaNum(128);
  var curTime = new Date().valueOf();
  var AppSecret = 'fcd6dkhyyvmtbpui4seiggnqjm0bkxlj2rocnoflzw7usq5he9xa8r1zvtaw3p';
  // let AppSecret = 'd6dkhyyvmtbpui4seiggnqjm0bklzw7usq5he9xa8r1zvtaw3p';
  config.headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    nonce: nonce,
    curTime: curTime,
    checkSum: sha1_default()(AppSecret + nonce + curTime)
  };
  return config;
}, function (error) {
  Message.error({
    message: '加载超时'
  });
  return promise_default.a.reject(error);
});

function post(url, params) {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(url, params).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

function get(url, params) {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.get(url, { params: params }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}
// CONCATENATED MODULE: ./src/service/service.js
/* eslint-disable */


var env = "/client_web_api";
/*
 * 运单号分流接口
 */
var service_xiaoIStore = function xiaoIStore(waybillNo) {
  return get(env + '/xiaoI/store', { wayBillNo: waybillNo });
};
/**
 * C5电话分流服务接口
 * @param mobile
 */
var service_serchByMobile = function serchByMobile(mobile) {
  return get(env + '/c5Api/serchByMobile', { mobile: mobile });
};

/**
 * 机器人聊天
 * @param data
 * @returns {*}
 */
var service_xiaoIChat = function xiaoIChat(data) {
  return post(env + '/xiaoI/chat', data);
};

/**
 * 创建会话
 * @param data
 * @returns {*}
 */
var service_sessionCreate = function sessionCreate(data) {
  return post(env + '/auth', data);
};

/**
 * 拉取消息数据
 * @param data
 * @returns {*}
 */
// export const pullMessage = (data) => post(`${env}/message/pull', data);

/**
 * 会话状态发送图片消息
 * @param data
 * @returns {*}
 */
var service_postImgMessage = function postImgMessage(data) {
  return post(env + '/message/post/image', data);
};

/**
 *  会话状态发送文本消息
 * @param data
 * @returns {*}
 */
// export const postMessage = (data) => post(`${env}/message/post', data);

/**
 * 判断是否在会话
 * @param data
 * @returns {*}
 */
var service_getSession = function getSession(data) {
  return post(env + '/session/get', data);
};

/**
 * 缓存历史记录
 * @param data
 * @returns {*}
 */
var service_getHistoryMsg = function getHistoryMsg(data) {
  return post(env + '/message/historyMsg', data);
};

/**
 * 缓存客户历史记录
 * @param data
 * @returns {*}
 */
var service_cacheHistory = function cacheHistory(data) {
  return post(env + '/message/cacheHistory', data);
};

/**
 * 获取验证码Id
 * @param data
 * @returns {*}
 */
var service_getCaptchaId = function getCaptchaId(data) {
  return post(env + '/captcha/getId', data);
};
/**
 * 获取验证码图片流接口.
 * @param data
 * @returns {*}
 */
var service_getCaptchaPictureFlow = function getCaptchaPictureFlow(data) {
  return post(env + '/captcha/getPictureFlow', data);
};
/**
 * 验证验证码
 * @param data
 * @returns {*}
 */
var service_verifyCaptcha = function verifyCaptcha(data) {
  return post(env + '/captcha/verify', data);
};

/**
 * 获取快速渠道link
 * @param data
 * @returns {*}
 */
var service_getLink = function getLink(data) {
  return post(env + '/v1/online/fastTrackEntrance/getLink', data);
};
/**
 * 小I机器人服务
 * @param data
 * @returns {*}
 */
var service_xiaoChat = function xiaoChat(data) {
  return post(env + '/v1/online/robot/chat', data);
};
/**
 * 查询会话状态
 * @param data
 * @returns {*}
 */
var service_getStatus = function getStatus(data) {
  return post(env + '/v1/online/session/getStatus', data);
};

/**
 * 获取我寄的运单列表
 * @param data
 * @returns {*}
 */
var service_getMySendList = function getMySendList(data) {
  return post(env + '/v1/online/order/senderlist', data);
};

/**
 * 获取我收的运单列表
 * @param data
 * @returns {*}
 */
var service_getMyReceiveList = function getMyReceiveList(data) {
  return post(env + '/v1/online/order/receiverlist', data);
};

/**
 * 发送消息
 * @param data
 * @returns {*}
 */
var service_postMessage = function postMessage(data) {
  return post(env + '/v1/online/message/post', data);
};

/**
 * 接收消息
 * @param data
 * @returns {*}
 */
var service_pullMessage = function pullMessage(data) {
  return post(env + '/v1/online/message/pull', data);
};

/**
 * 获取历史消息
 * @param data
 * @returns {*}
 */
var service_getHistory = function getHistory(data) {
  return post(env + '/v1/online/message/historyMsg', data);
};

/**
 * 会话关闭
 * @param data
 * @returns {*}
 */
var service_closeSession = function closeSession(data) {
  return post(env + '/v1/online/session/close', data);
};

/**
 * 会话授权
 * @param data
 * @returns {*}
 */
var service_authSession = function authSession(data) {
  return post(env + '/v1/online/auth', data);
};

/**
 * 人工追踪
 * @param data
 * @returns {*}
 */
var service_trackManual = function trackManual(data) {
  return post(env + '/v1/online/manual', data);
};

/**
 * 快速通道计数
 * @param data
 * @returns {*}
 */
var service_fastTrackEntranceCount = function fastTrackEntranceCount(data) {
  return post(env + '/v1/online/fastTrackEntrance/count', data);
};
// CONCATENATED MODULE: ./src/common/publicConstant.js
// 正则表达式
var constant = {
    waybillNoRegular: function waybillNoRegular() {
        return (/^[A-Za-z0-9]{10,13}$|^[6-9][0-9]{17}$|^[Dd]{2}[8-9][0-9]{15}$|^(Y|y)[0-9]{12}$|^(G|g)8[0-9]{16}$|^(M|m)[0-9]{14}$|^(Y|y)(T|t)[0-9a-zA-Z]{13}$/
        );
    },
    mobileRegular: function mobileRegular() {
        return (/^1\d{10}$/
        );
    },
    orderNoRegular: function orderNoRegular() {
        return (/^(TW|tw)[0-9]{13}$|^(TW|tw)[0-9]{12}[A-Za-z]{1}$|^(TW|tw)[A-Za-z0-9]{13}$|^(BG|bg)[0-9]{13}$|^(FS|fs)[0-9]{19}$|^(SL101LST|sl101lst)[0-9]{19}$|^(ST|st)[0-9]{16}$|^(WJD|wjd)[0-9]{9}$|^(d|D)[0-9]{10,11}$|^(WOSP|wosp)[0-9]{12}(FRA|fra)$|^[A-Za-z]{2}[0-9]{14}$/
        );
    },
    verifyCaptcha: function verifyCaptcha() {
        return (/^[0-9a-zA-Z]{6}$/g
        );
    }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var views_index = ({
  name: "index",
  data: function data() {
    return {
      imgMaxSize: false, //是否大尺寸图片
      billShow: true, //是否显示运单框
      phoneShow: false, //是否显示电话框
      swiperIndex: 1, //默认收件人
      swiperSlect: 'yundan',
      siteCode: '999999',
      router: '',
      vipCode: '', //海外客户编码
      parameters: {
        waybillNo: '',
        mobile: ''
      },
      //图片链接
      imgs: {
        dreceiver: __webpack_require__("o0NM"),
        receiver: __webpack_require__("+QOj"),
        dsender: __webpack_require__("K4jA"),
        sender: __webpack_require__("gmhV"),
        dother: __webpack_require__("vqWB"),
        other: __webpack_require__("Bsxs")
      },
      flag: false,
      platform: '',
      openid: '',
      isFirstStep: true,
      source: '',
      showDialog: false
    };
  },

  created: function created() {
    this.autoSize(); //自适应大小
    if (this.getUrlParams("flag") !== 'null') {
      var flag = this.getUrlParams("flag");
      if (flag === 'true') {
        this.flag = true;
      } else {
        this.flag = false;
      }
    }
    this.platform = this.getUrlParams("platform");
    if (this.getUrlParams("waybillNo") !== null && this.getUrlParams("waybillNo") !== "null" && this.getUrlParams("waybillNo") !== "") {
      this.parameters.waybillNo = this.getUrlParams("waybillNo");
    }
    if (this.getUrlParams("nodeCode") !== null && this.getUrlParams("nodeCode") !== "null" && this.getUrlParams("nodeCode") !== "") {
      this.siteCode = this.getUrlParams("nodeCode");
    }
    var source = this.getUrlParams("source");
    if (source !== null && source !== "null" && source !== "" && source !== 'undefined' && source !== undefined) {
      this.source = source;
    }
    if (this.getUrlParams("openid") !== null) {
      this.openid = this.getUrlParams("openid");
      window.localStorage.setItem("openid", this.getUrlParams("openid")); //openid
    } else {
      var openId = window.localStorage.getItem("openid");
      if (openId !== 'null' && openId !== 'undefined' && openId !== '' && openId !== null && openId !== undefined) {
        this.openid = openId;
      } else {
        this.getOpenId();
      }
    }
    window.localStorage.setItem("flag", this.flag); //是否小I已服务
    window.localStorage.setItem("platform", this.platform); //平台
    window.localStorage.setItem("openid", this.openid); //客户标志
    window.localStorage.setItem("source", this.source); //数据来源
    if (this.openid !== 'null' && this.openid !== null && this.openid !== 'undefined') {
      //this.getSession();  //这里校验客户是否存在
    }
  },
  methods: {
    //屏幕自适应大小
    autoSize: function autoSize() {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width > 320) {
        this.imgMaxSize = true;
      }
    },
    //客户类型选项卡
    imgClick: function imgClick(type) {
      this.swiperIndex = type;
      window.localStorage.setItem("customerType", this.swiperIndex); //客户类型
      console.log(this.swiperIndex);
    },

    //运单号或电话选中
    tabClick: function tabClick(e, type) {
      this.swiperSlect = type;
      if (type === "yundan") {
        this.billShow = true;
        this.phoneShow = false;
      } else {
        this.billShow = false;
        this.phoneShow = true;
      }
    },
    //本地创建openid
    getOpenId: function getOpenId() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      this.openid = uuid;
    },
    getUrlParams: function getUrlParams(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var url = location.search; // 获取url中"?"符后的字串
      var str = url.substr(1).match(reg);
      if (str != null) {
        return unescape(str[2]);
      }
      return null;
    },

    //异步会话状态
    getSession: function getSession() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data, res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};

                data.platform = _this.platform;
                data.openid = _this.openid;
                _context.next = 5;
                return service_getSession(data);

              case 5:
                res = _context.sent;

                if (res.status === 0) {
                  if (res.data.stage !== "auto" && res.data.stage !== "offline") {
                    _this.$router.push({
                      name: "chat"
                    });
                  }
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //进入聊天会话
    goToChat: function goToChat() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var timerFlag, _timerFlag, reg, _timerFlag2, result, mobileReg, _timerFlag3;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.swiperSlect === 'yundan')) {
                  _context2.next = 7;
                  break;
                }

                if (!(_this2.parameters.waybillNo === '')) {
                  _context2.next = 5;
                  break;
                }

                timerFlag = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '请填写<label style="color: #EDAA35">运单号</label>哦', timerFlag);
                return _context2.abrupt('return');

              case 5:
                _context2.next = 11;
                break;

              case 7:
                if (!(_this2.parameters.mobile === '')) {
                  _context2.next = 11;
                  break;
                }

                _timerFlag = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '请填写<label style="color: #EDAA35">手机号</label>哦', _timerFlag);
                return _context2.abrupt('return');

              case 11:
                if (!(_this2.parameters.waybillNo !== '')) {
                  _context2.next = 29;
                  break;
                }

                reg = constant.waybillNoRegular();

                if (reg.test(_this2.parameters.waybillNo)) {
                  _context2.next = 17;
                  break;
                }

                _timerFlag2 = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '<label style="color: #EDAA35">运单号</label>不正确，请重新填写', _timerFlag2);
                return _context2.abrupt('return');

              case 17:
                _this2.router = '单号分流-无信息';

                if (!(_this2.source !== null && _this2.source !== "null" && _this2.source !== "" && _this2.source !== 'undefined' && _this2.source !== undefined)) {
                  _context2.next = 23;
                  break;
                }

                _this2.siteCode = "999995";
                _this2.router = "蛟龙购单号";
                _context2.next = 27;
                break;

              case 23:
                _context2.next = 25;
                return service_xiaoIStore(_this2.parameters.waybillNo);

              case 25:
                result = _context2.sent;

                if (result.status === 0) {
                  _this2.siteCode = result.data.storeCode;
                  _this2.router = result.data.router;
                  _this2.vipCode = result.data.vipCode;
                }

              case 27:
                _this2.cacheParams();
                _this2.$router.push({
                  name: "chat2"
                });

              case 29:
                if (!(_this2.parameters.mobile !== '')) {
                  _context2.next = 39;
                  break;
                }

                mobileReg = constant.mobileRegular();

                if (mobileReg.test(_this2.parameters.mobile)) {
                  _context2.next = 35;
                  break;
                }

                _timerFlag3 = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '<label style="color: #EDAA35">手机号</label>格式不正确，请重新填写', _timerFlag3);
                return _context2.abrupt('return');

              case 35:
                _this2.router = '电话分流';
                _this2.siteCode = '999999';
                _this2.cacheParams();
                _this2.$router.push({
                  name: "chat"
                });

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    //无单咨询进入在线
    noSingleToChat: function noSingleToChat() {
      //无单咨询判断客户身份类型
      if (this.swiperIndex < 1) {
        var timerFlag = this.warnTimeOut(3000);
        this.warnPart('操作提示', '咨询前，需要选择您的<label style="color: #EDAA35">咨询角色</label>哦', timerFlag);
        return;
      }
      this.parameters.waybillNo = '';
      this.router = '无单咨询分流';
      this.cacheParams();
      console.log("客户类型：" + this.swiperIndex);
      this.$router.push({
        name: "chat"
      });
    },

    //缓存数据
    cacheParams: function cacheParams() {
      window.localStorage.setItem("siteCode", this.siteCode); //网点编码
      window.localStorage.setItem("mobile", this.parameters.mobile); //手机号
      window.localStorage.setItem("router", this.router); //路由
      window.localStorage.setItem("waybillNo", this.parameters.waybillNo); //运单号
      window.localStorage.setItem("vipCode", this.vipCode); //海外客户编码
      window.localStorage.setItem("customerType", this.swiperIndex); //客户类型
    },

    // 提示框
    warnPart: function warnPart(title, content, timerFlag) {
      this.$vux.alert.show({
        title: title,
        content: content,
        buttonText: "知道了",
        maskZIndex: 100,
        onHide: function onHide() {
          window.clearTimeout(timerFlag);
        }
      });
    },

    // 错误提示定时器
    warnTimeOut: function warnTimeOut(times) {
      var _this3 = this;

      var timerFlag = window.setTimeout(function () {
        _this3.$vux.alert.hide();
      }, times);
      return timerFlag;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_views_index = ({
  name: "index",
  data: function data() {
    return {
      imgMaxSize: false, //是否大尺寸图片
      billShow: true, //是否显示运单框
      phoneShow: false, //是否显示电话框
      swiperIndex: 1, //默认收件人
      swiperSlect: 'yundan',
      siteCode: '999999',
      router: '',
      vipCode: '', //海外客户编码
      parameters: {
        waybillNo: '',
        mobile: ''
      },
      //图片链接
      imgs: {
        dreceiver: __webpack_require__("o0NM"),
        receiver: __webpack_require__("+QOj"),
        dsender: __webpack_require__("K4jA"),
        sender: __webpack_require__("gmhV"),
        dother: __webpack_require__("vqWB"),
        other: __webpack_require__("Bsxs")
      },
      flag: false,
      platform: '',
      openid: '',
      isFirstStep: true,
      source: '',
      showDialog: false
    };
  },

  created: function created() {
    this.autoSize(); //自适应大小
    if (this.getUrlParams("flag") !== 'null') {
      var flag = this.getUrlParams("flag");
      if (flag === 'true') {
        this.flag = true;
      } else {
        this.flag = false;
      }
    }
    this.platform = this.getUrlParams("platform");
    if (this.getUrlParams("waybillNo") !== null && this.getUrlParams("waybillNo") !== "null" && this.getUrlParams("waybillNo") !== "") {
      this.parameters.waybillNo = this.getUrlParams("waybillNo");
    }
    if (this.getUrlParams("nodeCode") !== null && this.getUrlParams("nodeCode") !== "null" && this.getUrlParams("nodeCode") !== "") {
      this.siteCode = this.getUrlParams("nodeCode");
    }
    var source = this.getUrlParams("source");
    if (source !== null && source !== "null" && source !== "" && source !== 'undefined' && source !== undefined) {
      this.source = source;
    }
    if (this.getUrlParams("openid") !== null) {
      this.openid = this.getUrlParams("openid");
      window.localStorage.setItem("openid", this.getUrlParams("openid")); //openid
    } else {
      var openId = window.localStorage.getItem("openid");
      if (openId !== 'null' && openId !== 'undefined' && openId !== '' && openId !== null && openId !== undefined) {
        this.openid = openId;
      } else {
        this.getOpenId();
      }
    }
    window.localStorage.setItem("flag", this.flag); //是否小I已服务
    window.localStorage.setItem("platform", this.platform); //平台
    window.localStorage.setItem("openid", this.openid); //客户标志
    window.localStorage.setItem("source", this.source); //数据来源
    if (this.openid !== 'null' && this.openid !== null && this.openid !== 'undefined') {
      //this.getSession();  //这里校验客户是否存在
    }
  },
  methods: {
    //屏幕自适应大小
    autoSize: function autoSize() {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width > 320) {
        this.imgMaxSize = true;
      }
    },
    //客户类型选项卡
    imgClick: function imgClick(type) {
      this.swiperIndex = type;
      window.localStorage.setItem("customerType", this.swiperIndex); //客户类型
      console.log(this.swiperIndex);
    },

    //运单号或电话选中
    tabClick: function tabClick(e, type) {
      this.swiperSlect = type;
      if (type === "yundan") {
        this.billShow = true;
        this.phoneShow = false;
      } else {
        this.billShow = false;
        this.phoneShow = true;
      }
    },
    //本地创建openid
    getOpenId: function getOpenId() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      this.openid = uuid;
    },
    getUrlParams: function getUrlParams(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var url = location.search; // 获取url中"?"符后的字串
      var str = url.substr(1).match(reg);
      if (str != null) {
        return unescape(str[2]);
      }
      return null;
    },

    //异步会话状态
    getSession: function getSession() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data, res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};

                data.platform = _this.platform;
                data.openid = _this.openid;
                _context.next = 5;
                return service_getSession(data);

              case 5:
                res = _context.sent;

                if (res.status === 0) {
                  if (res.data.stage !== "auto" && res.data.stage !== "offline") {
                    _this.$router.push({
                      name: "chat"
                    });
                  }
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //进入聊天会话
    goToChat: function goToChat() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var timerFlag, _timerFlag, reg, _timerFlag2, result, mobileReg, _timerFlag3;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.swiperSlect === 'yundan')) {
                  _context2.next = 7;
                  break;
                }

                if (!(_this2.parameters.waybillNo === '')) {
                  _context2.next = 5;
                  break;
                }

                timerFlag = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '请填写<label style="color: #EDAA35">运单号</label>哦', timerFlag);
                return _context2.abrupt('return');

              case 5:
                _context2.next = 11;
                break;

              case 7:
                if (!(_this2.parameters.mobile === '')) {
                  _context2.next = 11;
                  break;
                }

                _timerFlag = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '请填写<label style="color: #EDAA35">手机号</label>哦', _timerFlag);
                return _context2.abrupt('return');

              case 11:
                if (!(_this2.parameters.waybillNo !== '')) {
                  _context2.next = 29;
                  break;
                }

                reg = constant.waybillNoRegular();

                if (reg.test(_this2.parameters.waybillNo)) {
                  _context2.next = 17;
                  break;
                }

                _timerFlag2 = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '<label style="color: #EDAA35">运单号</label>不正确，请重新填写', _timerFlag2);
                return _context2.abrupt('return');

              case 17:
                _this2.router = '单号分流-无信息';

                if (!(_this2.source !== null && _this2.source !== "null" && _this2.source !== "" && _this2.source !== 'undefined' && _this2.source !== undefined)) {
                  _context2.next = 23;
                  break;
                }

                _this2.siteCode = "999995";
                _this2.router = "蛟龙购单号";
                _context2.next = 27;
                break;

              case 23:
                _context2.next = 25;
                return service_xiaoIStore(_this2.parameters.waybillNo);

              case 25:
                result = _context2.sent;

                if (result.status === 0) {
                  _this2.siteCode = result.data.storeCode;
                  _this2.router = result.data.router;
                  _this2.vipCode = result.data.vipCode;
                }

              case 27:
                _this2.cacheParams();
                _this2.$router.push({
                  name: "chat2"
                });

              case 29:
                if (!(_this2.parameters.mobile !== '')) {
                  _context2.next = 39;
                  break;
                }

                mobileReg = constant.mobileRegular();

                if (mobileReg.test(_this2.parameters.mobile)) {
                  _context2.next = 35;
                  break;
                }

                _timerFlag3 = _this2.warnTimeOut(3000);

                _this2.warnPart('操作提示', '<label style="color: #EDAA35">手机号</label>格式不正确，请重新填写', _timerFlag3);
                return _context2.abrupt('return');

              case 35:
                _this2.router = '电话分流';
                _this2.siteCode = '999999';
                _this2.cacheParams();
                _this2.$router.push({
                  name: "chat"
                });

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    //无单咨询进入在线
    noSingleToChat: function noSingleToChat() {
      //无单咨询判断客户身份类型
      if (this.swiperIndex < 1) {
        var timerFlag = this.warnTimeOut(3000);
        this.warnPart('操作提示', '咨询前，需要选择您的<label style="color: #EDAA35">咨询角色</label>哦', timerFlag);
        return;
      }
      this.parameters.waybillNo = '';
      this.router = '无单咨询分流';
      this.cacheParams();
      console.log("客户类型：" + this.swiperIndex);
      this.$router.push({
        name: "chat"
      });
    },

    //缓存数据
    cacheParams: function cacheParams() {
      window.localStorage.setItem("siteCode", this.siteCode); //网点编码
      window.localStorage.setItem("mobile", this.parameters.mobile); //手机号
      window.localStorage.setItem("router", this.router); //路由
      window.localStorage.setItem("waybillNo", this.parameters.waybillNo); //运单号
      window.localStorage.setItem("vipCode", this.vipCode); //海外客户编码
      window.localStorage.setItem("customerType", this.swiperIndex); //客户类型
    },

    // 提示框
    warnPart: function warnPart(title, content, timerFlag) {
      this.$vux.alert.show({
        title: title,
        content: content,
        buttonText: "知道了",
        maskZIndex: 100,
        onHide: function onHide() {
          window.clearTimeout(timerFlag);
        }
      });
    },

    // 错误提示定时器
    warnTimeOut: function warnTimeOut(times) {
      var _this3 = this;

      var timerFlag = window.setTimeout(function () {
        _this3.$vux.alert.hide();
      }, times);
      return timerFlag;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f140e26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
var index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-index"},[_c('div',{staticClass:"index"},[_c('div',[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('div',{staticClass:"tab-swiper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.billShow),expression:"billShow"}]},[_c('div',{staticClass:"vux-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parameters.waybillNo),expression:"parameters.waybillNo"}],attrs:{"type":"text","placeholder":"请输入运单号"},domProps:{"value":(_vm.parameters.waybillNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.parameters, "waybillNo", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"identity-div"},[_c('span',{attrs:{"id":"receiver"},on:{"click":function($event){return _vm.imgClick(1)}}},[_c('img',{class:{'maxImg':_vm.imgMaxSize},attrs:{"src":_vm.swiperIndex==1?_vm.imgs.receiver:_vm.imgs.dreceiver}})]),_vm._v(" "),_c('span',{attrs:{"id":"sender"},on:{"click":function($event){return _vm.imgClick(2)}}},[_c('img',{class:{'maxImg':_vm.imgMaxSize},attrs:{"src":_vm.swiperIndex==2?_vm.imgs.sender:_vm.imgs.dsender}})]),_vm._v(" "),_c('span',{attrs:{"id":"other"},on:{"click":function($event){return _vm.imgClick(3)}}},[_c('img',{class:{'maxImg':_vm.imgMaxSize},attrs:{"src":_vm.swiperIndex==3?_vm.imgs.other:_vm.imgs.dother}})])])]),_vm._v(" "),_c('hr',{staticClass:"hr"}),_vm._v(" "),_c('div',{staticClass:"btn-div"},[_c('div',{staticClass:"btn",attrs:{"type":"button","value":"进入人工客服"},on:{"click":_vm.goToChat}},[_vm._v("进入人工客服")])]),_vm._v(" "),_c('div',{staticClass:"footer",staticStyle:{"display":"none"}},[_c('span',{staticClass:"span",on:{"click":_vm.noSingleToChat}},[_vm._v("没有订单？点击这里咨询>>")])])])])}
var index_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"identity-title-div"},[_c('div',{staticClass:"title-line"}),_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v("请选择"),_c('label',{staticClass:"label-title"},[_vm._v("身份")])])])}]
var index_esExports = { render: index_render, staticRenderFns: index_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_index = (index_esExports);
// CONCATENATED MODULE: ./src/views/index/index.vue
function index_injectStyle (ssrContext) {
  __webpack_require__("ksc/")
}
var index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var index___vue_template_functional__ = false
/* styles */
var index___vue_styles__ = index_injectStyle
/* scopeId */
var index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var index___vue_module_identifier__ = null
var index_Component = index_normalizeComponent(
  selectortype_script_index_0_src_views_index,
  selectortype_template_index_0_src_views_index,
  index___vue_template_functional__,
  index___vue_styles__,
  index___vue_scopeId__,
  index___vue_module_identifier__
)

/* harmony default export */ var src_views_index = (index_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/yto-rate/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var yto_rate = ({
    name: 'YtoRate',
    data: function data() {
        return {
            currentValue: 0,
            length: 5
        };
    },

    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    mounted: function mounted() {
        this.currentValue = this.value;
    },

    methods: {
        setValue: function setValue(value) {
            this.currentValue = value, this.$emit('change', value);
        },
        getIcon: function getIcon(index) {
            return 'static/img/chat/star_' + (index <= this.currentValue ? 'on' : 'off') + '.png';
        }
    },
    watch: {
        value: function value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.currentValue = newValue;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/yto-rate/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_yto_rate = ({
    name: 'YtoRate',
    data: function data() {
        return {
            currentValue: 0,
            length: 5
        };
    },

    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    mounted: function mounted() {
        this.currentValue = this.value;
    },

    methods: {
        setValue: function setValue(value) {
            this.currentValue = value, this.$emit('change', value);
        },
        getIcon: function getIcon(index) {
            return 'static/img/chat/star_' + (index <= this.currentValue ? 'on' : 'off') + '.png';
        }
    },
    watch: {
        value: function value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.currentValue = newValue;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6f35bb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yto-rate/index.vue
var yto_rate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yto-rate"},_vm._l((_vm.length),function(index){return _c('div',{key:index,staticClass:"rate-item",on:{"click":function($event){return _vm.setValue(index)}}},[_c('img',{staticClass:"yto-rate-icon",attrs:{"src":_vm.getIcon(index)}})])}),0)}
var yto_rate_staticRenderFns = []
var yto_rate_esExports = { render: yto_rate_render, staticRenderFns: yto_rate_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_yto_rate = (yto_rate_esExports);
// CONCATENATED MODULE: ./src/components/yto-rate/index.vue
function yto_rate_injectStyle (ssrContext) {
  __webpack_require__("1Sp5")
}
var yto_rate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var yto_rate___vue_template_functional__ = false
/* styles */
var yto_rate___vue_styles__ = yto_rate_injectStyle
/* scopeId */
var yto_rate___vue_scopeId__ = "data-v-f6f35bb2"
/* moduleIdentifier (server only) */
var yto_rate___vue_module_identifier__ = null
var yto_rate_Component = yto_rate_normalizeComponent(
  components_yto_rate,
  selectortype_template_index_0_src_components_yto_rate,
  yto_rate___vue_template_functional__,
  yto_rate___vue_styles__,
  yto_rate___vue_scopeId__,
  yto_rate___vue_module_identifier__
)

/* harmony default export */ var src_components_yto_rate = (yto_rate_Component.exports);

// CONCATENATED MODULE: ./src/service/dingding.js
/* eslint-disable */


var dingding_env = "/onlineChannelApi";
var robot = "/onlineRobotApi";

// 热点问题及欢迎语
var dingding_getWelcomeMessage = function getWelcomeMessage(data) {
  return post(dingding_env + '/online/config/getWelcomeMessage', data);
};
// 快捷入口
var dingding_getQuickLinkUrl = function getQuickLinkUrl(data) {
  return post(dingding_env + '/online/config/getQuickLinkUrl', data);
};
// 我收到的订单接口
var dingding_getMyReceiveList = function getMyReceiveList(data) {
  return post(dingding_env + '/online/order/receiverlist', data);
};
// 我寄出的订单接口
var dingding_getMySendList = function getMySendList(data) {
  return post(dingding_env + '/online/order/senderlist', data);
};
// 机器人采纳回传接口
var dingding_robotAdopt = function robotAdopt(data) {
  return post(robot + '/robot/adopt', data);
};
// 机器人呼叫应答
var dingding_robotCall = function robotCall(data) {
  return post(robot + '/robot/call', data);
};
// 机器人聊天内容
var dingding_robotMessageList = function robotMessageList(data) {
  return post(robot + '/robot/messageList', data);
};
// 在线智能机器人接口
var dingding_robotOnlineChat = function robotOnlineChat(data) {
  return post(robot + '/robot/onlineChat', data);
};
// 发送验证码
var dingding_sendVerify = function sendVerify(data) {
  return post(robot + '/verify/send', data);
};
// 校验验证码
var dingding_checkVerify = function checkVerify(data) {
  return post(robot + '/verify/check', data);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/waybillItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var waybillItem = ({
    name: 'online-waybill-item',
    props: ['item', 'type'],
    computed: {
        createTime: function createTime() {
            return common.formatTime('YYYY-mm-dd HH:MM', new Date(this.item.createTime));
        }
    },
    methods: {
        // 发送消息
        sendMessage: function sendMessage() {
            this.$emit('sendMessage');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/waybillItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var chat_waybillItem = ({
    name: 'online-waybill-item',
    props: ['item', 'type'],
    computed: {
        createTime: function createTime() {
            return common.formatTime('YYYY-mm-dd HH:MM', new Date(this.item.createTime));
        }
    },
    methods: {
        // 发送消息
        sendMessage: function sendMessage() {
            this.$emit('sendMessage');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350066b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/waybillItem.vue
var waybillItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waybill-item",on:{"click":_vm.sendMessage}},[_c('div',{staticClass:"basic-info flx-row-be"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.type === "SEND" ? (_vm.item.mailNo ? '运单号' : '订单号') : '运单号')+"\n            "+_vm._s(_vm.type === "SEND" ? (_vm.item.mailNo ? _vm.item.mailNo : _vm.item.orderNo ) : _vm.item.mailNo))]),_vm._v(" "),_c('span',[_vm._v("下单时间: "+_vm._s(_vm.createTime))])]),_vm._v(" "),_c('div',{staticClass:"send-info flx-row align-column-ce"},[_c('div',{staticClass:"address-container"},[_c('div',{staticClass:"address-name"},[_vm._v(_vm._s(_vm.item.senderProvinceName))]),_vm._v(" "),_c('div',{staticClass:"address-info"},[_vm._v(_vm._s(_vm.item.senderName))])]),_vm._v(" "),_c('div',{staticClass:"address-arrow-container flx-col-ce"},[_c('img',{staticClass:"arrow",attrs:{"src":"static/img/chat/ico_sender.png","alt":"箭头"}}),_vm._v(" "),_c('div',{staticClass:"address-status"},[_vm._v(_vm._s(_vm.item.statusName))])]),_vm._v(" "),_c('div',{staticClass:"address-container"},[_c('div',{staticClass:"address-name"},[_vm._v(_vm._s(_vm.item.receiverProvinceName))]),_vm._v(" "),_c('div',{staticClass:"address-info"},[_vm._v(_vm._s(_vm.item.receiverName))])])])])}
var waybillItem_staticRenderFns = []
var waybillItem_esExports = { render: waybillItem_render, staticRenderFns: waybillItem_staticRenderFns }
/* harmony default export */ var views_chat_waybillItem = (waybillItem_esExports);
// CONCATENATED MODULE: ./src/views/chat/waybillItem.vue
function waybillItem_injectStyle (ssrContext) {
  __webpack_require__("PCAH")
}
var waybillItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waybillItem___vue_template_functional__ = false
/* styles */
var waybillItem___vue_styles__ = waybillItem_injectStyle
/* scopeId */
var waybillItem___vue_scopeId__ = "data-v-350066b9"
/* moduleIdentifier (server only) */
var waybillItem___vue_module_identifier__ = null
var waybillItem_Component = waybillItem_normalizeComponent(
  chat_waybillItem,
  views_chat_waybillItem,
  waybillItem___vue_template_functional__,
  waybillItem___vue_styles__,
  waybillItem___vue_scopeId__,
  waybillItem___vue_module_identifier__
)

/* harmony default export */ var src_views_chat_waybillItem = (waybillItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/waybillnosList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var waybillnosList = ({
    name: 'online-waybillNo-list',
    components: {
        waybillItem: src_views_chat_waybillItem
    },
    data: function data() {
        return {
            currentTab: 'RECEIVE', // 我寄的 - 'SEND', wo'shou 'RECEIVE'
            senderList: [],
            senderListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            },
            receiveList: [],
            receiveListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            }
        };
    },

    methods: {
        init: function init() {
            this.openid = window.localStorage.getItem('openid');
            this.source = window.localStorage.getItem('source');
            this.userid = window.localStorage.getItem('userid');
            this.changeTab(this.currentTab);
            this.initScroll();
        },

        // 上拉加载方法
        initScroll: function initScroll() {
            var _this = this;

            this.$nextTick(function () {
                // 我发送的
                var scrollDom = document.getElementById('sender-list');
                scrollDom.onscroll = function () {
                    var scrollTop = scrollDom.scrollTop;
                    var clientHeight = scrollDom.clientHeight;
                    var scrollHeight = scrollDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.senderListPagination.hasNext) {
                            _this.senderListPagination.pageNo += 1;
                            _this.getSendList();
                        }
                    }
                };
                // 我收到的
                var scrollReceiveDom = document.getElementById('receive-list');
                scrollReceiveDom.onscroll = function () {
                    var scrollTop = scrollReceiveDom.scrollTop;
                    var clientHeight = scrollReceiveDom.clientHeight;
                    var scrollHeight = scrollReceiveDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.receiveListPagination.hasNext) {
                            _this.receiveListPagination.pageNo += 1;
                            _this.getReceiveList();
                        }
                    }
                };
            });
        },

        // 下拉刷新
        refresh: function refresh() {
            // TODO
        },
        sendMessage: function sendMessage(item) {
            if (this.currentTab === 'SEND') {
                this.$emit('sendMessage', item.mailNo ? item.mailNo : item.orderNo);
            } else {
                this.$emit('sendMessage', item.mailNo);
            }
            this.$emit('close');
        },

        // 切换tab
        changeTab: function changeTab(type) {
            this.currentTab = type;
            if (type === 'SEND') {
                this.getSendList();
            } else {
                this.getReceiveList();
            }
        },

        // 关闭当前窗口
        close: function close() {
            this.$emit('close');
        },


        // 手动收入订单
        goSetOrder: function goSetOrder() {
            this.$emit('goSetOrder');
        },


        // 我寄的
        getSendList: function getSendList() {
            var _this2 = this;

            if (!this.userid) {
                return;
            }
            dingding_getMySendList({
                // userid: "1330437178689974274",
                userid: this.userid,
                source: this.source,
                pageNo: this.senderListPagination.pageNo,
                limit: this.senderListPagination.limit
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items;
                    var list = _this2.senderList;
                    if (_this2.senderListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this2.senderList = list;
                    _this2.senderListPagination = {
                        pageNo: result.pageNo,
                        limit: result.limit,
                        total: result.total,
                        hasNext: result.pageNo * result.limit < result.total
                    };
                } else {
                    _this2.senderList = [];
                    _this2.senderListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        },


        // 我收的
        getReceiveList: function getReceiveList() {
            var _this3 = this;

            if (!this.userid) {
                return;
            }
            service_getMyReceiveList({
                // userid: ":task:" + this.openid,
                // userid: "1331881598127812609",
                userid: this.userid,
                pageNo: this.receiveListPagination.pageNo,
                limit: this.receiveListPagination.limit,
                source: this.source
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items.map(function (item) {
                        return extends_default()({}, item, {
                            createTime: item.orderCreateTime,
                            senderProvinceName: item.senderCityName,
                            receiverProvinceName: item.receiverCityName
                        });
                    });
                    var list = _this3.receiveList;
                    if (_this3.receiveListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this3.receiveList = list;
                    _this3.receiveListPagination = {
                        pageNo: Number(result.pageNo),
                        limit: Number(result.limit),
                        total: Number(result.total),
                        hasNext: res.morePage
                    };
                } else {
                    _this3.receiveList = [];
                    _this3.receiveListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/waybillnosList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var chat_waybillnosList = ({
    name: 'online-waybillNo-list',
    components: {
        waybillItem: src_views_chat_waybillItem
    },
    data: function data() {
        return {
            currentTab: 'RECEIVE', // 我寄的 - 'SEND', wo'shou 'RECEIVE'
            senderList: [],
            senderListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            },
            receiveList: [],
            receiveListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            }
        };
    },

    methods: {
        init: function init() {
            this.openid = window.localStorage.getItem('openid');
            this.source = window.localStorage.getItem('source');
            this.userid = window.localStorage.getItem('userid');
            this.changeTab(this.currentTab);
            this.initScroll();
        },

        // 上拉加载方法
        initScroll: function initScroll() {
            var _this = this;

            this.$nextTick(function () {
                // 我发送的
                var scrollDom = document.getElementById('sender-list');
                scrollDom.onscroll = function () {
                    var scrollTop = scrollDom.scrollTop;
                    var clientHeight = scrollDom.clientHeight;
                    var scrollHeight = scrollDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.senderListPagination.hasNext) {
                            _this.senderListPagination.pageNo += 1;
                            _this.getSendList();
                        }
                    }
                };
                // 我收到的
                var scrollReceiveDom = document.getElementById('receive-list');
                scrollReceiveDom.onscroll = function () {
                    var scrollTop = scrollReceiveDom.scrollTop;
                    var clientHeight = scrollReceiveDom.clientHeight;
                    var scrollHeight = scrollReceiveDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.receiveListPagination.hasNext) {
                            _this.receiveListPagination.pageNo += 1;
                            _this.getReceiveList();
                        }
                    }
                };
            });
        },

        // 下拉刷新
        refresh: function refresh() {
            // TODO
        },
        sendMessage: function sendMessage(item) {
            if (this.currentTab === 'SEND') {
                this.$emit('sendMessage', item.mailNo ? item.mailNo : item.orderNo);
            } else {
                this.$emit('sendMessage', item.mailNo);
            }
            this.$emit('close');
        },

        // 切换tab
        changeTab: function changeTab(type) {
            this.currentTab = type;
            if (type === 'SEND') {
                this.getSendList();
            } else {
                this.getReceiveList();
            }
        },

        // 关闭当前窗口
        close: function close() {
            this.$emit('close');
        },


        // 手动收入订单
        goSetOrder: function goSetOrder() {
            this.$emit('goSetOrder');
        },


        // 我寄的
        getSendList: function getSendList() {
            var _this2 = this;

            if (!this.userid) {
                return;
            }
            dingding_getMySendList({
                // userid: "1330437178689974274",
                userid: this.userid,
                source: this.source,
                pageNo: this.senderListPagination.pageNo,
                limit: this.senderListPagination.limit
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items;
                    var list = _this2.senderList;
                    if (_this2.senderListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this2.senderList = list;
                    _this2.senderListPagination = {
                        pageNo: result.pageNo,
                        limit: result.limit,
                        total: result.total,
                        hasNext: result.pageNo * result.limit < result.total
                    };
                } else {
                    _this2.senderList = [];
                    _this2.senderListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        },


        // 我收的
        getReceiveList: function getReceiveList() {
            var _this3 = this;

            if (!this.userid) {
                return;
            }
            service_getMyReceiveList({
                // userid: ":task:" + this.openid,
                // userid: "1331881598127812609",
                userid: this.userid,
                pageNo: this.receiveListPagination.pageNo,
                limit: this.receiveListPagination.limit,
                source: this.source
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items.map(function (item) {
                        return extends_default()({}, item, {
                            createTime: item.orderCreateTime,
                            senderProvinceName: item.senderCityName,
                            receiverProvinceName: item.receiverCityName
                        });
                    });
                    var list = _this3.receiveList;
                    if (_this3.receiveListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this3.receiveList = list;
                    _this3.receiveListPagination = {
                        pageNo: Number(result.pageNo),
                        limit: Number(result.limit),
                        total: Number(result.total),
                        hasNext: res.morePage
                    };
                } else {
                    _this3.receiveList = [];
                    _this3.receiveListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae33ca8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/waybillnosList.vue
var waybillnosList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"online-customer-waybillnos"},[_c('div',{staticClass:"waybillnos-title flx-row-be"},[_c('div',{staticClass:"tab-list flx-row"},[_c('div',{staticClass:"tab-item",class:{ active: _vm.currentTab === 'SEND' },on:{"click":function($event){return _vm.changeTab('SEND')}}},[_vm._v("\n                我寄的\n            ")]),_vm._v(" "),_c('div',{staticClass:"tab-item last",class:{ active: _vm.currentTab === 'RECEIVE' },on:{"click":function($event){return _vm.changeTab('RECEIVE')}}},[_vm._v("\n                我收的\n            ")])]),_vm._v(" "),_c('img',{staticClass:"close",attrs:{"src":"static/img/chat/ico_close.png","alt":"close"},on:{"click":_vm.close}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'SEND'),expression:"currentTab === 'SEND'"}],staticClass:"waybillnos-list",attrs:{"id":"sender-list"}},[_vm._l((_vm.senderList),function(item){return _c('waybill-item',{key:item.id,attrs:{"type":"SEND","item":item},on:{"sendMessage":function($event){return _vm.sendMessage(item)}}})}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.senderList.length === 0),expression:"senderList.length === 0"}],staticClass:"empty-list"},[_c('img',{staticClass:"empty-img",attrs:{"src":__webpack_require__("RhUM"),"alt":"暂无数据"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("这里还没有订单信息呢~")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.senderListPagination.hasNext && _vm.senderList.length > 0),expression:"!senderListPagination.hasNext && senderList.length > 0"}],staticClass:"end-line"},[_vm._v("\n            我是有底线的\n        ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'RECEIVE'),expression:"currentTab === 'RECEIVE'"}],staticClass:"waybillnos-list",attrs:{"id":"receive-list"}},[_vm._l((_vm.receiveList),function(item){return _c('waybill-item',{key:item.id,attrs:{"type":"RECEIVE","item":item},on:{"sendMessage":function($event){return _vm.sendMessage(item)}}})}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.receiveList.length === 0),expression:"receiveList.length === 0"}],staticClass:"empty-list"},[_c('img',{staticClass:"empty-img",attrs:{"src":__webpack_require__("RhUM"),"alt":"暂无数据"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("这里还没有订单信息呢~")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.receiveListPagination.hasNext && _vm.receiveList.length > 0),expression:"!receiveListPagination.hasNext && receiveList.length > 0"}],staticClass:"end-line"},[_vm._v("\n            我是有底线的\n        ")])],2),_vm._v(" "),_c('button',{staticClass:"submit-btn",on:{"click":_vm.goSetOrder}},[_vm._v("没有相应的订单")])])}
var waybillnosList_staticRenderFns = []
var waybillnosList_esExports = { render: waybillnosList_render, staticRenderFns: waybillnosList_staticRenderFns }
/* harmony default export */ var views_chat_waybillnosList = (waybillnosList_esExports);
// CONCATENATED MODULE: ./src/views/chat/waybillnosList.vue
function waybillnosList_injectStyle (ssrContext) {
  __webpack_require__("xBBy")
}
var waybillnosList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waybillnosList___vue_template_functional__ = false
/* styles */
var waybillnosList___vue_styles__ = waybillnosList_injectStyle
/* scopeId */
var waybillnosList___vue_scopeId__ = "data-v-6ae33ca8"
/* moduleIdentifier (server only) */
var waybillnosList___vue_module_identifier__ = null
var waybillnosList_Component = waybillnosList_normalizeComponent(
  chat_waybillnosList,
  views_chat_waybillnosList,
  waybillnosList___vue_template_functional__,
  waybillnosList___vue_styles__,
  waybillnosList___vue_scopeId__,
  waybillnosList___vue_module_identifier__
)

/* harmony default export */ var src_views_chat_waybillnosList = (waybillnosList_Component.exports);

// CONCATENATED MODULE: ./src/service/date.js
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
};

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}
// EXTERNAL MODULE: ./node_modules/timers-browserify/main.js
var main = __webpack_require__("162o");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/yto-modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var yto_modal = ({
    name: 'YtoModal',
    data: function data() {
        return {
            visible: false,
            obj: {
                type: 'confirm',
                confirm: function confirm() {},
                cancel: function cancel() {}
            }
        };
    },

    methods: {
        open: function open(obj) {
            this.visible = true;
            this.obj = obj;
            this.$emit('open');
        },
        close: function close() {
            this.visible = false;
        },
        confirm: function confirm() {
            var _this = this;

            if (this.obj.confirm) {
                this.obj.confirm(function () {
                    _this.visible = false;
                });
            } else {
                this.visible = false;
            }
        },
        cancel: function cancel() {
            var _this2 = this;

            if (this.obj.cancel) {
                this.obj.cancel(function () {
                    _this2.visible = false;
                });
            } else {
                this.visible = false;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/yto-modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_yto_modal = ({
    name: 'YtoModal',
    data: function data() {
        return {
            visible: false,
            obj: {
                type: 'confirm',
                confirm: function confirm() {},
                cancel: function cancel() {}
            }
        };
    },

    methods: {
        open: function open(obj) {
            this.visible = true;
            this.obj = obj;
            this.$emit('open');
        },
        close: function close() {
            this.visible = false;
        },
        confirm: function confirm() {
            var _this = this;

            if (this.obj.confirm) {
                this.obj.confirm(function () {
                    _this.visible = false;
                });
            } else {
                this.visible = false;
            }
        },
        cancel: function cancel() {
            var _this2 = this;

            if (this.obj.cancel) {
                this.obj.cancel(function () {
                    _this2.visible = false;
                });
            } else {
                this.visible = false;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1740d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yto-modal.vue
var yto_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"modal-mask",on:{"click":function($event){_vm.visible = false}}},[(_vm.obj.type === 'confirm')?_c('div',{staticClass:"modal-container confrim",on:{"click":function($event){$event.stopPropagation();return (function () {return}).apply(null, arguments)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"operate-container"},[_c('div',{staticClass:"btn default",on:{"click":_vm.cancel}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"btn primary",on:{"click":_vm.confirm}},[_vm._v("确定")])])],2):_vm._e(),_vm._v(" "),(_vm.obj.type === 'bottom')?_c('div',{staticClass:"modal-container bottom",on:{"click":function($event){$event.stopPropagation();return (function () {return}).apply(null, arguments)}}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.obj.type === 'pic')?_c('div',{staticClass:"modal-container transparent"},[_vm._t("default")],2):_vm._e()])}
var yto_modal_staticRenderFns = []
var yto_modal_esExports = { render: yto_modal_render, staticRenderFns: yto_modal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_yto_modal = (yto_modal_esExports);
// CONCATENATED MODULE: ./src/components/yto-modal.vue
function yto_modal_injectStyle (ssrContext) {
  __webpack_require__("i+A6")
}
var yto_modal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var yto_modal___vue_template_functional__ = false
/* styles */
var yto_modal___vue_styles__ = yto_modal_injectStyle
/* scopeId */
var yto_modal___vue_scopeId__ = "data-v-6b1740d7"
/* moduleIdentifier (server only) */
var yto_modal___vue_module_identifier__ = null
var yto_modal_Component = yto_modal_normalizeComponent(
  components_yto_modal,
  selectortype_template_index_0_src_components_yto_modal,
  yto_modal___vue_template_functional__,
  yto_modal___vue_styles__,
  yto_modal___vue_scopeId__,
  yto_modal___vue_module_identifier__
)

/* harmony default export */ var src_components_yto_modal = (yto_modal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/chat.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









var timer = null;
/* harmony default export */ var chat = ({
    name: "new-chat",
    components: {
        YtoModal: src_components_yto_modal,
        waybillnosList: src_views_chat_waybillnosList,
        YtoRate: src_components_yto_rate
    },
    data: function data() {
        return {
            verifyShow: false,
            telPhone: '',
            phoneValue: '',
            dataForm: {
                disabled: false,
                btnText: '发送验证码',
                countTime: 0
            },
            errorTipShow: false,
            errorTip: '',
            phoneNumber: "", // 手机号码
            validPhone: "", // 校验手机号消息
            handleWaybillNo: "", // 手动输入的运单号
            validWaybillNo: "", // 校验运单号消息
            handleorderNo: "", // 手动输入的国际订单号
            validorderNo: "", //校验国际订单号消息
            enterType: "0",
            disabledone: false,
            disabledtwo: true,
            currentType: "auto", // auto - xiaoI对话  service - 人工对话 wait - 排队 survey 满意度调查 offline 非工作时间
            msgBox: [], // 初始数据;
            questions: [{
                childrenList: []
            }], // 热点问题
            currentTab: 0, // 当前选中的热点问题
            childQuestions: [], // 热点问题;
            inputValue: "", // 发送小小
            selectBox: [], // 快捷操作
            rate: 5, // 当前评价
            subId: -1,
            sessionId: '', // 机器人会话id
            nodeId: '', // 机器人nodeId
            robotId: '', // 机器人id
            robotStatus: '', // 机器人会话状态
            imgUrl: "", // 预览图片
            isHistory: false,
            isImg: false, // 发送出去的是否是图片类型
            msgId: 0,
            siteCode: "",
            wayBillNo: "", // 运单号
            sessionInfo: {
                source: "",
                openid: "",
                platform: "site"
            },
            msgReBox: [], // 对话数据;
            isActive: false, // 是否可以发送消息;
            quickItems: [], // 快速查询工具
            conclusion: "亲，谢谢您的肯定，祝您生活愉快！" // 结束语
        };
    },
    created: function created() {
        this.getInitData();
    },
    mounted: function mounted() {
        // 获取常见问题列表及开头语
        this.initLink();
        // 获取快捷操作
        this.getQuickLink();
        // 获取当前状态
        this.getInitStatus();
    },

    methods: {
        // 获取初始化数据
        getInitData: function getInitData() {
            console.log("href:" + location.href);
            console.log("router" + stringify_default()(this.$route.query));
            var _$route$query = this.$route.query,
                _$route$query$waybill = _$route$query.waybillNo,
                waybillNo = _$route$query$waybill === undefined ? "" : _$route$query$waybill,
                _$route$query$nodeCod = _$route$query.nodeCode,
                nodeCode = _$route$query$nodeCod === undefined ? "" : _$route$query$nodeCod,
                _$route$query$platfor = _$route$query.platform,
                platform = _$route$query$platfor === undefined ? "" : _$route$query$platfor,
                _$route$query$source = _$route$query.source,
                source = _$route$query$source === undefined ? "mobile" : _$route$query$source,
                _$route$query$openid = _$route$query.openid,
                openid = _$route$query$openid === undefined ? "" : _$route$query$openid,
                _$route$query$userid = _$route$query.userid,
                userid = _$route$query$userid === undefined ? "" : _$route$query$userid,
                _$route$query$robotId = _$route$query.robotId,
                robotId = _$route$query$robotId === undefined ? "" : _$route$query$robotId,
                _$route$query$session = _$route$query.sessionId,
                sessionId = _$route$query$session === undefined ? "" : _$route$query$session;

            this.waybillNo = waybillNo;
            this.siteCode = nodeCode;

            platform = common.isEmpty(platform) ? window.localStorage.getItem("platform") || "site" : platform;
            source = common.isEmpty(source) ? window.localStorage.getItem("source") || "" : source;
            userid = common.isEmpty(userid) ? window.localStorage.getItem("userid") || "" : userid;
            robotId = common.isEmpty(robotId) ? window.localStorage.getItem("robotId") || "" : robotId;
            sessionId = common.isEmpty(sessionId) ? window.localStorage.getItem("sessionId") || "" : sessionId;
            if (common.isEmpty(openid)) {
                openid = window.localStorage.getItem("openid") || common.getOpenId();
            }
            window.localStorage.setItem("platform", platform); //平台
            window.localStorage.setItem("openid", openid); //客户标志
            window.localStorage.setItem("source", source); //数据来源
            window.localStorage.setItem("userid", userid); //用户id
            this.robotId = robotId;
            this.sessionId = sessionId;
            this.sessionInfo = {
                openid: openid || '',
                source: source || '',
                platform: platform || '',
                userid: userid || ''
            };
        },


        // 初始查询状态;
        getInitStatus: function getInitStatus() {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var res;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return service_getStatus(_this.sessionInfo || {});

                            case 2:
                                res = _context.sent;

                                if (!(res && res.status == 0)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.currentType = res.data.stage;
                                _this.subId = res.data.subId;
                                // 评价中
                                if (_this.currentType === "survey") {
                                    _this.closeSession('init');
                                } else if (_this.currentType === "wait") {
                                    // 等待中直接改成服务中，拉取消息
                                    _this.currentType = "service";
                                }
                                // 获取机器人会话历史
                                _context.next = 9;
                                return _this.getRobotMessageList();

                            case 9:
                                // 服务中的才获取历史消息
                                if (_this.currentType === "service") {
                                    _this.getMessageList();
                                    // 拉取人工消息
                                    if (!timer) {
                                        timer = setInterval(_this.getManualMessage, 2000);
                                    }
                                }

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 初始查询链接;
        initLink: function initLink() {
            var _this2 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return dingding_getWelcomeMessage({
                                    source: 'mobile'
                                });

                            case 2:
                                res = _context2.sent;

                                if (res && res.status === 0) {
                                    // 显示开头语
                                    if (res.data && res.data.welcome) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.welcome
                                        };

                                        _this2.msgBox.push(msgBox);
                                    }
                                    // 显示热点问题
                                    if (res.data && res.data.quetions && res.data.quetions.length > 0) {
                                        _this2.questions = res.data.quetions;
                                    }
                                    // 结束语
                                    if (res.data.conclusion) {
                                        _this2.conclusion = res.data.conclusion;
                                    }
                                } else {
                                    _this2.$vux.toast.text(res.message, "bottom");
                                }

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getQuickLink: function getQuickLink() {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var res;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return dingding_getQuickLinkUrl({
                                    source: 'mobile',
                                    platform: _this3.sessionInfo.platform
                                });

                            case 2:
                                res = _context3.sent;

                                if (res && res.status === 0) {
                                    if (res.data && res.data.items && res.data.items.length > 0) {
                                        _this3.selectBox = res.data.items;
                                    }
                                    // 快捷操作
                                    if (res.data.quickReplyTerms) {
                                        _this3.quickItems = res.data.quickReplyTerms.split(";");
                                    }
                                } else {
                                    _this3.$vux.toast.text(res.message, "bottom");
                                }

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },


        // 修改热点问题
        changeTab: function changeTab(i) {
            this.currentTab = i;
        },


        // 跳转其他页面
        goOtherLink: function goOtherLink(url, icon) {
            var filterObj = {
                yuyue: "order",
                chajian: "track",
                wangdian: "site",
                yunfei: "freight"
            };
            this.fastTrackCount(filterObj[icon], function () {
                location.href = url;
            });
        },


        // 处理问题
        resolveProblem: function resolveProblem(index, flag) {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                var item, res;
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                item = _this4.msgReBox[index];

                                if (!(item.resolve === 0 || item.resolve === 1)) {
                                    _context4.next = 4;
                                    break;
                                }

                                _this4.$vux.toast.text('请勿重复评价！', "bottom");
                                return _context4.abrupt("return");

                            case 4:
                                _this4.$set(item, 'resolve', flag);
                                _context4.next = 7;
                                return dingding_robotAdopt({
                                    isOk: flag === 1,
                                    messageId: _this4.msgReBox[index].nodeId,
                                    sessionId: _this4.sessionId,
                                    source: 'mobile'
                                });

                            case 7:
                                res = _context4.sent;

                                if (res.status === 0) {
                                    // 关闭机器人会话？
                                    _this4.sendDingDing(item.resolve === 1 ? '已解决' : '未解决');
                                } else {
                                    _this4.$vux.toast.text(res.message, "bottom");
                                }

                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },


        // 发送消息;
        sendMsg: function sendMsg(message) {
            // 转人工中
            if (this.currentType === 'toManual') {
                this.$vux.toast.text('目前排队人数较多，请耐心等待！', "bottom");
                return;
            }
            if (this.inputValue === "" && !message && !this.isImg) {
                return false;
            }
            if (this.inputValue.length >= 350) {
                this.$vux.toast.text("字符长度超过限制！", "bottom");
                return;
            }
            // 非图片类型
            if (!this.isImg) {
                var _ibox = {
                    type: 1,
                    imgUrl: "",
                    msgContent: common.formatMsg(message ? message : this.inputValue)
                };
                this.msgReBox.push(_ibox);
                var newMessage = message || this.inputValue;
                // 清空输入框
                this.inputValue = "";
                // 滚动到底部
                this.scrollToBottom();
                if (this.currentType === "auto") {
                    this.sendDingDing(newMessage);
                } else if (this.currentType === "service") {
                    this.sendManual(newMessage);
                }
            } else {
                //图片1
                var _ibox2 = {
                    type: 1,
                    imgUrl: message,
                    msgContent: "<img src=\"" + message + "\" style=\"max-width: 220px; display: block;\"/>"
                };
                this.msgReBox.push(_ibox2);
                this.isImg = false;
                // 清空输入框
                this.inputValue = "";
                // 滚动到底部
                this.scrollToBottom();
            }
        },


        // 发送钉钉消息
        sendDingDing: function sendDingDing(message) {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                var params, res, item, msg;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                params = {
                                    content: message,
                                    platform: _this5.sessionInfo.platform,
                                    sessionId: _this5.sessionId,
                                    mail_no: _this5.waybillNo,
                                    source: _this5.sessionInfo.source
                                };
                                _context5.next = 3;
                                return dingding_robotCall(params);

                            case 3:
                                res = _context5.sent;

                                if (!(res.status === 0)) {
                                    _context5.next = 31;
                                    break;
                                }

                                item = res.data;

                                _this5.robotStatus = item.stage;
                                msg = {
                                    type: 0,
                                    nodeId: item.nodeId,
                                    contentType: "",
                                    msgContent: "",
                                    relateQuestions: item.relateQuestions
                                };

                                _this5.sessionId = item.sessionId;
                                _this5.robotId = item.robotId || '';
                                window.localStorage.setItem('robotId', item.robotId || '');
                                window.localStorage.setItem('sessionId', item.sessionId || '');

                                if (item.verifyCode && item.verifyCode == 1) {
                                    _this5.telPhone = item.customerMobile;
                                    _this5.verifyShow = true;
                                }
                                _context5.t0 = res.data.stage;
                                _context5.next = _context5.t0 === 'TO_HUMAN' ? 16 : _context5.t0 === 'TO_O_HUMAN' ? 18 : _context5.t0 === 'INVALID' ? 21 : 25;
                                break;

                            case 16:
                                if (item.mail_no) {
                                    // 有单直接转人工
                                    _this5.chooseWaybill(item.mail_no);
                                } else {
                                    // 无单咨询
                                    msg.contentType = "ACS";
                                    // 埋点-客户追踪
                                    _this5.trackManual();
                                    _this5.msgReBox.push(msg);
                                }
                                return _context5.abrupt("break", 28);

                            case 18:
                                // if (item.mail_no) {
                                //     // 有单直接转人工
                                //     this.chooseWaybill(item.mail_no);
                                // } else {
                                //     // 无单咨询
                                //     this.siteCode = "999995";
                                //     this.getAuth("siteCode");
                                // }
                                _this5.siteCode = "999995";
                                _this5.getAuth("siteCode", item.mail_no);
                                return _context5.abrupt("break", 28);

                            case 21:
                                // 再次发送消息
                                _this5.sessionId = '';
                                _this5.robotId = '';
                                _this5.sendDingDing(message);
                                return _context5.abrupt("break", 28);

                            case 25:
                                msg.msgContent = common.convertMsg(item.answer) || '系统繁忙';
                                _this5.msgReBox.push(msg);
                                return _context5.abrupt("break", 28);

                            case 28:
                                _this5.scrollToBottom();
                                _context5.next = 32;
                                break;

                            case 31:
                                _this5.$vux.toast.text(res.message);

                            case 32:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },


        // 发送人工消息
        sendManual: function sendManual(message) {
            var _this6 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return service_postMessage(extends_default()({
                                    content: message
                                }, _this6.sessionInfo, {
                                    subId: _this6.subId,
                                    msgId: _this6.msgId,
                                    type: "text"
                                }));

                            case 2:
                                res = _context6.sent;

                                if (!timer) {
                                    timer = setInterval(_this6.getManualMessage, 2000);
                                }
                                // 如果人工消息是等待中的话，需要返回消息
                                if (res.status === 0) {
                                    if (res.data.stage === "auto") {
                                        // 关闭定时器
                                        if (timer) {
                                            clearInterval(timer), timer = null;
                                        }
                                        _this6.currentType = "auto";
                                    }

                                    // 有人工消息直接展示在页面上
                                    if (res.data.content) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.content
                                        };

                                        _this6.msgReBox.push(msgBox);
                                        _this6.scrollToBottom();
                                    }
                                }

                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },


        // 获取人工消息
        getManualMessage: function getManualMessage() {
            var _this7 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                var result, msg, pmsg, _ibox3;

                return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return service_pullMessage(extends_default()({}, _this7.sessionInfo, {
                                    subId: _this7.subId,
                                    msgId: _this7.msgId,
                                    attr: 'pull-message'
                                }));

                            case 2:
                                result = _context7.sent;
                                msg = {
                                    type: 0,
                                    imgUrl: ""
                                };

                                if (!(result.status === 0)) {
                                    _context7.next = 17;
                                    break;
                                }

                                if (!(result.data != null)) {
                                    _context7.next = 15;
                                    break;
                                }

                                pmsg = result.data;
                                // 会话自动关闭

                                if (!(pmsg.category === "sys_ssncls")) {
                                    _context7.next = 13;
                                    break;
                                }

                                // 客服关闭会话
                                _this7.currentType = "auto";
                                _this7.closeSession();
                                return _context7.abrupt("return");

                            case 13:
                                _this7.msgId = result.data.msgId;
                                if (result.data != null && result.data.type === "text") {
                                    msg.msgContent = common.convertMsg(result.data.text.content);
                                    _this7.msgReBox.push(msg);
                                    _this7.scrollToBottom();
                                } else if (result.data != null && result.data.type === "image") {
                                    if (result.data.image.pic_url.startsWith('http')) {
                                        _this7.imgUrl = result.data.image.pic_url;
                                    } else {
                                        _this7.imgUrl = "data:image/png;base64," + result.data.image.pic_url;
                                    }
                                    _ibox3 = {
                                        type: 0,
                                        imgUrl: _this7.imgUrl,
                                        msgContent: "<img src=\"" + _this7.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                    };

                                    _this7.msgReBox.push(_ibox3);
                                    _this7.scrollToBottom();
                                }

                            case 15:
                                _context7.next = 18;
                                break;

                            case 17:
                                console.log("拉取会话失败！");

                            case 18:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },


        // 获取机器人聊天记录
        getRobotMessageList: function getRobotMessageList() {
            var _this8 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                var res, items;
                return regenerator_default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.robotId) {
                                    _context8.next = 2;
                                    break;
                                }

                                return _context8.abrupt("return");

                            case 2:
                                _context8.next = 4;
                                return dingding_robotMessageList({
                                    // robotId: this.robotId,
                                    sessionId: _this8.sessionId,
                                    current: 1,
                                    size: 1000
                                });

                            case 4:
                                res = _context8.sent;

                                if (res.code == 0) {
                                    if (res.data && res.data.items && res.data.items.length > 0) {
                                        items = res.data.items;

                                        items.forEach(function (msg) {
                                            var type = msg.category === 'autreq' ? 1 : 0;
                                            if (msg.msgType === "text") {
                                                var _ibox4 = {
                                                    type: type,
                                                    imgUrl: "",
                                                    msgContent: common.convertMsg(msg.content)
                                                };
                                                _this8.msgReBox.push(_ibox4);
                                            } else {
                                                var imgUrl = "data:image/png;base64," + msg.picUrl;
                                                var _ibox5 = {
                                                    type: type,
                                                    imgUrl: imgUrl,
                                                    msgContent: "<img src=\"" + imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                };
                                                _this8.msgReBox.push(_ibox5);
                                            }
                                        });
                                    }
                                } else {
                                    _this8.$vux.toast.text(res.message, 'bottom');
                                }

                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        },


        // 获取历史消息
        getMessageList: function getMessageList() {
            var _this9 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                var msg, msgs, i, lastMsgId, date, _msg, type, _ibox6, _msg2;

                return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return service_getHistory(extends_default()({}, _this9.sessionInfo));

                            case 2:
                                msg = _context9.sent;

                                if (msg !== null && msg.status === 0) {
                                    msgs = msg.data.items;

                                    if (msgs.length > 0) {
                                        _this9.isHistory = true;
                                        for (i = 0; i < msgs.length; i++) {
                                            if (msgs[i].msgId != 0) {
                                                lastMsgId = msgs[i].msgId;

                                                _this9.msgId = lastMsgId || 0;
                                            }
                                            if (msgs[i].sendAt != null && msgs[i].sendAt != "") {
                                                date = new Date(msgs[i].sendAt);

                                                _this9.lastTime = formatDate(date, "MM月dd日 hh:mm"); //最后之间
                                            }
                                            if (msgs[i].category === "sys_ssncls") {
                                                // 会话关闭
                                                // this.closeSession()
                                            } else {
                                                if (msgs[i].type === "text") {
                                                    _msg = {
                                                        type: 0,
                                                        imgUrl: "",
                                                        msgContent: common.convertMsg(msgs[i].msgBody.content)
                                                    };

                                                    if (msgs[i].category === "manreq") {
                                                        _msg.type = 1;
                                                    }
                                                    _this9.msgReBox.push(_msg);
                                                } else if (msgs[i].type === "image") {
                                                    type = 0;

                                                    if (msgs[i].category === "manreq") {
                                                        type = 1;
                                                    }
                                                    _this9.imgUrl = "data:image/png;base64," + msgs[i].msgBody.pic_url;
                                                    _ibox6 = {
                                                        type: type,
                                                        imgUrl: _this9.imgUrl,
                                                        msgContent: "<img src=\"" + _this9.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                    };

                                                    _this9.msgReBox.push(_ibox6);
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    _msg2 = {
                                        type: 0,
                                        imgUrl: "",
                                        msgContent: common.convertMsg(_msg2.message)
                                    };

                                    _this9.msgBox.push(ibox);
                                }
                                _this9.scrollToBottom();

                            case 5:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9);
            }))();
        },


        // 验证码后调用机器人接口
        rebotResponse: function rebotResponse(phoneType) {
            var _this10 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
                var params, res, item, msg;
                return regenerator_default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                params = {
                                    content: phoneType,
                                    platform: _this10.sessionInfo.platform,
                                    sessionId: _this10.sessionId,
                                    mail_no: _this10.waybillNo,
                                    source: _this10.sessionInfo.source,
                                    mobileVerifyResult: phoneType
                                };
                                _context10.next = 3;
                                return dingding_robotCall(params);

                            case 3:
                                res = _context10.sent;

                                if (!(res.status === 0)) {
                                    _context10.next = 30;
                                    break;
                                }

                                item = res.data;

                                _this10.robotStatus = item.stage;
                                msg = {
                                    type: 0,
                                    nodeId: item.nodeId,
                                    contentType: "",
                                    msgContent: "",
                                    relateQuestions: item.relateQuestions
                                };

                                _this10.sessionId = item.sessionId;
                                _this10.robotId = item.robotId || '';
                                window.localStorage.setItem('robotId', item.robotId || '');
                                window.localStorage.setItem('sessionId', item.sessionId || '');

                                _context10.t0 = res.data.stage;
                                _context10.next = _context10.t0 === 'TO_HUMAN' ? 15 : _context10.t0 === 'TO_O_HUMAN' ? 17 : _context10.t0 === 'INVALID' ? 20 : 24;
                                break;

                            case 15:
                                if (item.mail_no) {
                                    // 有单直接转人工
                                    _this10.chooseWaybill(item.mail_no);
                                } else {
                                    // 无单咨询
                                    msg.contentType = "ACS";
                                    // 埋点-客户追踪
                                    _this10.trackManual();
                                    _this10.msgReBox.push(msg);
                                }
                                return _context10.abrupt("break", 27);

                            case 17:
                                // if (item.mail_no) {
                                //     // 有单直接转人工
                                //     this.chooseWaybill(item.mail_no);
                                // } else {
                                //     // 无单咨询
                                //     this.siteCode = "999995";
                                //     this.getAuth("siteCode");
                                // }
                                _this10.siteCode = "999995";
                                _this10.getAuth("siteCode", item.mail_no);
                                return _context10.abrupt("break", 27);

                            case 20:
                                // 再次发送消息
                                _this10.sessionId = '';
                                _this10.robotId = '';
                                _this10.sendDingDing(message);
                                return _context10.abrupt("break", 27);

                            case 24:
                                msg.msgContent = common.convertMsg(item.answer) || '系统繁忙';
                                _this10.msgReBox.push(msg);
                                return _context10.abrupt("break", 27);

                            case 27:
                                _this10.scrollToBottom();
                                _context10.next = 31;
                                break;

                            case 30:
                                _this10.$vux.toast.text(res.message);

                            case 31:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10);
            }))();
        },

        // 跳过验证码
        skip: function skip() {
            var phoneType = 'skip';
            this.rebotResponse(phoneType);
            this.verifyShow = false;
            this.phoneValue = '';
            this.errorTipShow = false;
        },

        // 倒计时
        endTime: function endTime() {
            var _this11 = this;

            var currentTime = this.dataForm.countTime;
            var lastTime = setInterval(function () {
                currentTime--;
                _this11.dataForm.btnText = '重新发送(' + currentTime + ')';
                if (currentTime <= 0) {
                    _this11.dataForm.disabled = false;
                    _this11.dataForm.btnText = '重新发送';
                    clearInterval(lastTime);
                }
            }, 1000);
        },

        // 发送验证码
        getVerify: function getVerify() {
            var _this12 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                var params, res;
                return regenerator_default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                params = {
                                    sessionId: _this12.sessionId
                                };
                                _context11.next = 3;
                                return dingding_sendVerify(params);

                            case 3:
                                res = _context11.sent;

                                if (res.status == 0) {
                                    console.log(res.data);
                                    _this12.dataForm.disabled = true;
                                    _this12.dataForm.countTime = 120;
                                    _this12.endTime();
                                } else if (res.status == -1) {
                                    _this12.errorTipShow = true;
                                    _this12.errorTip = res.message;
                                }

                            case 5:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this12);
            }))();
        },

        // 确定验证码
        gerDetermine: function gerDetermine() {
            var _this13 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                var params, res, phoneType;
                return regenerator_default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                console.log(_this13.phoneValue);

                                if (_this13.phoneValue) {
                                    _context12.next = 5;
                                    break;
                                }

                                _this13.errorTipShow = true;
                                _this13.errorTip = '验证码不能为空';
                                return _context12.abrupt("return");

                            case 5:
                                params = {
                                    sessionId: _this13.sessionId,
                                    verifyCode: _this13.phoneValue
                                };
                                _context12.next = 8;
                                return dingding_checkVerify(params);

                            case 8:
                                res = _context12.sent;

                                if (res.status == 0) {
                                    console.log(res.data);
                                    if (res.data.code === 'EQUAL') {
                                        phoneType = 'success';

                                        _this13.rebotResponse(phoneType);
                                        _this13.verifyShow = false;
                                        _this13.phoneValue = '';
                                        _this13.errorTipShow = false;
                                    } else if (res.data.code === 'EXPIRE') {
                                        _this13.errorTipShow = true;
                                        _this13.errorTip = res.data.message;
                                    } else if (res.data.code === 'NOT_EQUAL') {
                                        _this13.errorTipShow = true;
                                        _this13.errorTip = res.data.message;
                                    }
                                }

                            case 10:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this13);
            }))();
        },

        // 查看图片
        imgClick: function imgClick(data) {
            var _this14 = this;

            if (!data) {
                return false;
            }
            this.imgUrl = data;
            this.$nextTick(function () {
                _this14.$refs.picShowDialog.open({
                    type: "pic"
                });
            });
        },


        // 隐藏预览图片
        hideImage: function hideImage() {
            var _this15 = this;

            this.$nextTick(function () {
                _this15.$refs.picShowDialog.close();
            });
        },


        // 选择订单号
        chooseWaybill: function chooseWaybill(waybillNo) {
            this.handleWaybillNo = waybillNo;
            this.getAuth("waybillNo");
        },


        // 获取权限
        getAuth: function getAuth(type) {
            var _this16 = this;

            var waybillNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                var res, msgBox, _ibox7, _msgBox;

                return regenerator_default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _this16.currentType = "toManual";
                                _context13.next = 3;
                                return service_authSession(extends_default()({}, _this16.sessionInfo, {
                                    robotSessionId: _this16.robotId,
                                    mobile: type === "mobile" ? _this16.phoneNumber : "",
                                    waybillNo: type === "waybillNo" ? _this16.handleWaybillNo : waybillNo,
                                    orderNo: type === "orderNo" ? _this16.handleorderNo : "",
                                    siteCode: type === "siteCode" ? _this16.siteCode : ""
                                }));

                            case 3:
                                res = _context13.sent;

                                if (!(res.status === 0)) {
                                    _context13.next = 20;
                                    break;
                                }

                                if (!(res.data && res.data.stage === 'offline')) {
                                    _context13.next = 10;
                                    break;
                                }

                                msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this16.msgReBox.push(msgBox);
                                _this16.scrollToBottom();
                                return _context13.abrupt("return");

                            case 10:
                                _this16.subId = res.data.subId;
                                _this16.currentType = "service";
                                // 重置messageId
                                _this16.msgId = 0;

                                // 开启定时
                                if (!timer) {
                                    timer = setInterval(_this16.getManualMessage, 2000);
                                }
                                // 页面显示消息

                                if (!(type == "siteCode")) {
                                    _context13.next = 16;
                                    break;
                                }

                                return _context13.abrupt("return");

                            case 16:
                                _ibox7 = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: type === "mobile" ? _this16.phoneNumber : type === "waybillNo" ? _this16.handleWaybillNo : _this16.handleorderNo
                                };

                                _this16.msgReBox.push(_ibox7);
                                _context13.next = 22;
                                break;

                            case 20:
                                _msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this16.msgReBox.push(_msgBox);

                            case 22:
                                _this16.scrollToBottom();

                            case 23:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this16);
            }))();
        },


        // 人工客服点击追踪-埋点
        trackManual: function trackManual() {
            var _this17 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                var result;
                return regenerator_default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return service_trackManual();

                            case 2:
                                result = _context14.sent;

                            case 3:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this17);
            }))();
        },


        // 快速通道计数
        fastTrackCount: function fastTrackCount(type, cb) {
            var _this18 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
                var result;
                return regenerator_default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return service_fastTrackEntranceCount(extends_default()({}, _this18.sessionInfo, {
                                    type: type
                                }));

                            case 2:
                                result = _context15.sent;

                                cb && cb();

                            case 4:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this18);
            }))();
        },


        // 打开查询订单
        goWayBillNo: function goWayBillNo() {
            var _this19 = this;

            if (this.currentType === 'service') {
                return;
            }
            // 微信小程序才打开运单列表
            if (this.sessionInfo.userid) {
                this.$nextTick(function () {
                    _this19.$refs["chooseWaybillNo"].open({
                        type: "bottom"
                    });
                });
            } else {
                this.searchWaybillNo();
            }
        },
        onOpenChooseWaybill: function onOpenChooseWaybill() {
            var _this20 = this;

            this.$nextTick(function () {
                _this20.$refs["com-choose-waybill"].init();
            });
        },

        // 关闭查询订单
        closeChooseWaybill: function closeChooseWaybill() {
            var _this21 = this;

            this.$nextTick(function () {
                _this21.$refs["chooseWaybillNo"].close();
            });
        },

        // 关闭订单列表-打开查询订单
        goSetOrder: function goSetOrder() {
            this.closeChooseWaybill();
            this.searchWaybillNo();
        },


        // 校验手机号
        toValidPhone: function toValidPhone(e) {
            var value = e.target.value;
            var reg = constant.mobileRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validPhone = "请输入正确的手机号";
                } else {
                    this.validPhone = "";
                }
            }
        },


        // 校验运单号
        toValidWaybillNo: function toValidWaybillNo(e) {
            var value = e.target.value;
            var reg = constant.waybillNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validWaybillNo = "请输入正确的运单号";
                } else {
                    this.validWaybillNo = "";
                }
            }
        },


        // 校验国际订单号
        toValidorderNo: function toValidorderNo(e) {
            var value = e.target.value;
            var reg = constant.orderNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validorderNo = "请输入正确的国际订单号";
                } else {
                    this.validorderNo = "";
                }
            }
        },


        // 查询手机号
        goPhone: function goPhone() {
            var _this22 = this;

            // 服务中不能点击
            if (this.currentType === 'service') {
                return;
            }
            this.phoneNumber = "";
            this.validPhone = "";
            this.$refs["setPhoneDialog"].open({
                title: "请输入手机号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.mobileRegular();
                    if (reg.test(_this22.phoneNumber)) {
                        _this22.getAuth("mobile");
                        close && close();
                        _this22.validPhone = "";
                    } else {
                        _this22.validPhone = "请输入正确的手机号";
                    }
                }
            });
        },
        changeRadio: function changeRadio() {
            if (this.enterType == 0) {
                this.disabledone = false;
                this.disabledtwo = true;
                this.handleorderNo = "";
                this.validorderNo = "";
            }
            if (this.enterType == 1) {
                this.disabledone = true;
                this.disabledtwo = false;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
            }
            if (this.enterType == 2) {
                this.disabledone = true;
                this.disabledtwo = true;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
                this.handleorderNo = "";
                this.validorderNo = "";
            }
        },

        // 查询国际订单号
        goorderNo: function goorderNo() {
            var _this23 = this;

            if (this.currentType === 'service') {
                return;
            }
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.handleorderNo = "";
            this.validorderNo = "";
            this.$refs["setorderNo"].open({
                title: "请选择进入方式",
                type: "confirm",
                confirm: function confirm(close) {
                    console.log('enterType-->', _this23.enterType);
                    if (_this23.enterType == 0) {
                        var reg = constant.waybillNoRegular();
                        if (reg.test(_this23.handleWaybillNo)) {
                            _this23.getAuth("waybillNo");
                            _this23.validWaybillNo = "";
                            close && close();
                        } else {
                            _this23.validWaybillNo = "请输入正确的运单号";
                        }
                    }
                    if (_this23.enterType == 1) {
                        var _reg = constant.orderNoRegular();
                        if (_reg.test(_this23.handleorderNo)) {
                            _this23.getAuth("orderNo");
                            _this23.validorderNo = "";
                            close && close();
                        } else {
                            _this23.validorderNo = "请输入正确的国际订单号";
                        }
                    }
                    if (_this23.enterType == 2) {
                        _this23.siteCode = "999995";
                        _this23.getAuth("siteCode");
                        close && close();
                    }
                }
            });
        },

        // 查询运单号
        searchWaybillNo: function searchWaybillNo() {
            var _this24 = this;

            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.$refs["setWaybillNo"].open({
                title: "请输入单号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.waybillNoRegular();
                    if (reg.test(_this24.handleWaybillNo)) {
                        _this24.getAuth("waybillNo");
                        _this24.validWaybillNo = "";
                        close && close();
                    } else {
                        _this24.validWaybillNo = "请输入正确的运单号";
                    }
                }
            });
        },

        // 滚动到底部
        scrollToBottom: function scrollToBottom() {
            var _this25 = this;

            this.$nextTick(function () {
                var innerBox = _this25.$refs.xwBody;
                console.log("start:" + innerBox.scrollTop);
                if (innerBox.scrollHeight > innerBox.clientHeight) {
                    Object(main["setTimeout"])(function () {
                        //设置滚动条到最底部
                        innerBox.scrollTop = innerBox.scrollHeight;
                        innerBox.style.opacity = 1;
                        console.log("end:" + innerBox.scrollTop);
                    }, 50);
                }
            });
        },


        // 关闭会话
        closeSession: function closeSession(type) {
            var _this26 = this;

            this.rate = 5;
            this.$nextTick(function () {
                _this26.$refs["rateDialog"].open({
                    title: "服务评价",
                    type: "confirm",
                    confirm: function confirm(close) {
                        service_closeSession(extends_default()({}, _this26.sessionInfo, {
                            survey: _this26.rate
                        })).then(function (res) {
                            if (res.status === 0) {
                                // this.$vux.toast.text('评价成功', 'bottom');
                                // 关闭人工消息
                                var _ibox8 = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent: _this26.conclusion
                                };
                                _this26.msgReBox.push(_ibox8);
                                _this26.scrollToBottom();
                                _this26.currentType = "auto";
                                if (timer) {
                                    clearInterval(timer);
                                    timer = null;
                                }
                                close && close();
                            } else {
                                _this26.$vux.toast.text(res.message, "bottom");
                            }
                        });
                    },
                    cancel: function cancel(close) {
                        // 如果当前是初始化状态，获取的评价调查状态
                        // 当用户点击取消的时候，需要调用关闭评价状态-默认给5星，并改成机器人会话状态
                        if (type === 'init') {
                            service_closeSession(extends_default()({}, _this26.sessionInfo, {
                                survey: 5
                            }));
                            _this26.currentType = 'auto';
                        }
                        close && close();
                    }
                });
            });
        },

        // 上传图片
        upload: function upload(e) {
            if (!this.currentType === "auto") {
                this.$vux.toast.text("机器人模式不能发送图片消息！", "bottom");
                return;
            }
            var files = e.target.files || e.dataTransfer.files;
            if (!(files[0].type === "image/png" || files[0].type === "image/jpeg")) {
                this.$vux.toast.text("亲，只支持图片上传！", "bottom");
                return;
            }
            if (files.length < 1) {
                this.$vux.toast.text("请寻找需要上传的图片！", "bottom");
                return;
            }
            this.isImg = true;
            this.imgPreview(files[0]);
        },
        imgPreview: function imgPreview(file) {
            var self = this;
            var Orientation = 0;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // EXIF.getData(file, function(){
            //     Orientation=EXIF.getTag(this, 'Orientation');
            // });
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/^image/.test(file.type)) {
                // 创建一个reader
                var reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
                    var result, img, senddata, config;
                    return regenerator_default.a.wrap(function _callee19$(_context19) {
                        while (1) {
                            switch (_context19.prev = _context19.next) {
                                case 0:
                                    result = this.result;

                                    if (result !== "null" && result !== null) {
                                        img = new Image();

                                        img.src = result;
                                        senddata = extends_default()({}, self.sessionInfo, {
                                            type: "image"
                                        });
                                        config = {
                                            headers: { "Content-Type": "application/json" }
                                        };
                                        //判断图片是否大于1M,是就直接上传，反s之压缩图片2

                                        if (this.result.length <= 1024 * 1024) {
                                            Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
                                                var data, index, res;
                                                return regenerator_default.a.wrap(function _callee16$(_context16) {
                                                    while (1) {
                                                        switch (_context16.prev = _context16.next) {
                                                            case 0:
                                                                data = self.compress(img, Orientation);
                                                                index = data.indexOf("base64") + 7;

                                                                senddata.imgData = data.substr(index);
                                                                _context16.next = 5;
                                                                return service_postMessage(senddata);

                                                            case 5:
                                                                res = _context16.sent;

                                                                if (!(res.status === 0)) {
                                                                    _context16.next = 11;
                                                                    break;
                                                                }

                                                                self.sendMsg(data);
                                                                return _context16.abrupt("return");

                                                            case 11:
                                                                self.showPositionValue = true;
                                                                self.toastText = "上传图片失败";
                                                                return _context16.abrupt("return");

                                                            case 14:
                                                            case "end":
                                                                return _context16.stop();
                                                        }
                                                    }
                                                }, _callee16, this);
                                            })), 500);
                                        } else {
                                            img.onload = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
                                                return regenerator_default.a.wrap(function _callee18$(_context18) {
                                                    while (1) {
                                                        switch (_context18.prev = _context18.next) {
                                                            case 0:
                                                                Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
                                                                    var data, index, res;
                                                                    return regenerator_default.a.wrap(function _callee17$(_context17) {
                                                                        while (1) {
                                                                            switch (_context17.prev = _context17.next) {
                                                                                case 0:
                                                                                    data = self.compress(img, Orientation);
                                                                                    index = data.indexOf("base64") + 7;

                                                                                    senddata.imgData = data.substr(index);
                                                                                    _context17.next = 5;
                                                                                    return service_postMessage(senddata);

                                                                                case 5:
                                                                                    res = _context17.sent;

                                                                                    if (!(res.status === 0)) {
                                                                                        _context17.next = 11;
                                                                                        break;
                                                                                    }

                                                                                    self.sendMsg(data);
                                                                                    return _context17.abrupt("return");

                                                                                case 11:
                                                                                    self.showPositionValue = true;
                                                                                    self.toastText = "上传图片失败";
                                                                                    return _context17.abrupt("return");

                                                                                case 14:
                                                                                case "end":
                                                                                    return _context17.stop();
                                                                            }
                                                                        }
                                                                    }, _callee17, this);
                                                                })), 500);

                                                            case 1:
                                                            case "end":
                                                                return _context18.stop();
                                                        }
                                                    }
                                                }, _callee18, this);
                                            }));
                                        }
                                    }

                                case 2:
                                case "end":
                                    return _context19.stop();
                            }
                        }
                    }, _callee19, this);
                }));
            }
        },
        rotateImg: function rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            var min_step = 0;
            var max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            var height = img.height;
            var width = img.width;
            var step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == "right") {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            var degree = step * 90 * Math.PI / 180;
            var ctx = canvas.getContext("2d");
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress: function compress(img, Orientation) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            //瓦片canvas
            var tCanvas = document.createElement("canvas");
            var tctx = tCanvas.getContext("2d");
            var initSize = img.src.length;
            var width = img.width;
            var height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            var ratio = void 0;
            if ((ratio = width * height / 4000000) > 1) {
                /* console.log("大于400万像素")*/
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //        铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            var count = void 0;
            if ((count = width * height / 1000000) > 1) {
                /*   console.log("超过100W像素");*/
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                //            计算每块瓦片的宽和高
                var nw = ~~(width / count);
                var nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (var i = 0; i < count; i++) {
                    for (var j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6:
                        //需要顺时针（向左）90度旋转
                        this.rotateImg(img, "left", canvas);
                        break;
                    case 8:
                        //需要逆时针（向右）90度旋转
                        this.rotateImg(img, "right", canvas);
                        break;
                    case 3:
                        //需要180度旋转
                        this.rotateImg(img, "right", canvas); //转两次
                        this.rotateImg(img, "right", canvas);
                        break;
                }
            }
            //进行最小压缩
            var ndata = canvas.toDataURL("image/jpeg", 0.4);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata;
        },

        // 改变评价
        changeRate: function changeRate(value) {
            this.rate = value;
        }
    },
    destroyed: function destroyed() {
        // 关闭定时器
        if (timer) {
            clearInterval(timer), timer = null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/chat/chat.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









var chat_timer = null;
/* harmony default export */ var chat_chat = ({
    name: "new-chat",
    components: {
        YtoModal: src_components_yto_modal,
        waybillnosList: src_views_chat_waybillnosList,
        YtoRate: src_components_yto_rate
    },
    data: function data() {
        return {
            verifyShow: false,
            telPhone: '',
            phoneValue: '',
            dataForm: {
                disabled: false,
                btnText: '发送验证码',
                countTime: 0
            },
            errorTipShow: false,
            errorTip: '',
            phoneNumber: "", // 手机号码
            validPhone: "", // 校验手机号消息
            handleWaybillNo: "", // 手动输入的运单号
            validWaybillNo: "", // 校验运单号消息
            handleorderNo: "", // 手动输入的国际订单号
            validorderNo: "", //校验国际订单号消息
            enterType: "0",
            disabledone: false,
            disabledtwo: true,
            currentType: "auto", // auto - xiaoI对话  service - 人工对话 wait - 排队 survey 满意度调查 offline 非工作时间
            msgBox: [], // 初始数据;
            questions: [{
                childrenList: []
            }], // 热点问题
            currentTab: 0, // 当前选中的热点问题
            childQuestions: [], // 热点问题;
            inputValue: "", // 发送小小
            selectBox: [], // 快捷操作
            rate: 5, // 当前评价
            subId: -1,
            sessionId: '', // 机器人会话id
            nodeId: '', // 机器人nodeId
            robotId: '', // 机器人id
            robotStatus: '', // 机器人会话状态
            imgUrl: "", // 预览图片
            isHistory: false,
            isImg: false, // 发送出去的是否是图片类型
            msgId: 0,
            siteCode: "",
            wayBillNo: "", // 运单号
            sessionInfo: {
                source: "",
                openid: "",
                platform: "site"
            },
            msgReBox: [], // 对话数据;
            isActive: false, // 是否可以发送消息;
            quickItems: [], // 快速查询工具
            conclusion: "亲，谢谢您的肯定，祝您生活愉快！" // 结束语
        };
    },
    created: function created() {
        this.getInitData();
    },
    mounted: function mounted() {
        // 获取常见问题列表及开头语
        this.initLink();
        // 获取快捷操作
        this.getQuickLink();
        // 获取当前状态
        this.getInitStatus();
    },

    methods: {
        // 获取初始化数据
        getInitData: function getInitData() {
            console.log("href:" + location.href);
            console.log("router" + stringify_default()(this.$route.query));
            var _$route$query = this.$route.query,
                _$route$query$waybill = _$route$query.waybillNo,
                waybillNo = _$route$query$waybill === undefined ? "" : _$route$query$waybill,
                _$route$query$nodeCod = _$route$query.nodeCode,
                nodeCode = _$route$query$nodeCod === undefined ? "" : _$route$query$nodeCod,
                _$route$query$platfor = _$route$query.platform,
                platform = _$route$query$platfor === undefined ? "" : _$route$query$platfor,
                _$route$query$source = _$route$query.source,
                source = _$route$query$source === undefined ? "mobile" : _$route$query$source,
                _$route$query$openid = _$route$query.openid,
                openid = _$route$query$openid === undefined ? "" : _$route$query$openid,
                _$route$query$userid = _$route$query.userid,
                userid = _$route$query$userid === undefined ? "" : _$route$query$userid,
                _$route$query$robotId = _$route$query.robotId,
                robotId = _$route$query$robotId === undefined ? "" : _$route$query$robotId,
                _$route$query$session = _$route$query.sessionId,
                sessionId = _$route$query$session === undefined ? "" : _$route$query$session;

            this.waybillNo = waybillNo;
            this.siteCode = nodeCode;

            platform = common.isEmpty(platform) ? window.localStorage.getItem("platform") || "site" : platform;
            source = common.isEmpty(source) ? window.localStorage.getItem("source") || "" : source;
            userid = common.isEmpty(userid) ? window.localStorage.getItem("userid") || "" : userid;
            robotId = common.isEmpty(robotId) ? window.localStorage.getItem("robotId") || "" : robotId;
            sessionId = common.isEmpty(sessionId) ? window.localStorage.getItem("sessionId") || "" : sessionId;
            if (common.isEmpty(openid)) {
                openid = window.localStorage.getItem("openid") || common.getOpenId();
            }
            window.localStorage.setItem("platform", platform); //平台
            window.localStorage.setItem("openid", openid); //客户标志
            window.localStorage.setItem("source", source); //数据来源
            window.localStorage.setItem("userid", userid); //用户id
            this.robotId = robotId;
            this.sessionId = sessionId;
            this.sessionInfo = {
                openid: openid || '',
                source: source || '',
                platform: platform || '',
                userid: userid || ''
            };
        },


        // 初始查询状态;
        getInitStatus: function getInitStatus() {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var res;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return service_getStatus(_this.sessionInfo || {});

                            case 2:
                                res = _context.sent;

                                if (!(res && res.status == 0)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.currentType = res.data.stage;
                                _this.subId = res.data.subId;
                                // 评价中
                                if (_this.currentType === "survey") {
                                    _this.closeSession('init');
                                } else if (_this.currentType === "wait") {
                                    // 等待中直接改成服务中，拉取消息
                                    _this.currentType = "service";
                                }
                                // 获取机器人会话历史
                                _context.next = 9;
                                return _this.getRobotMessageList();

                            case 9:
                                // 服务中的才获取历史消息
                                if (_this.currentType === "service") {
                                    _this.getMessageList();
                                    // 拉取人工消息
                                    if (!chat_timer) {
                                        chat_timer = setInterval(_this.getManualMessage, 2000);
                                    }
                                }

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 初始查询链接;
        initLink: function initLink() {
            var _this2 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return dingding_getWelcomeMessage({
                                    source: 'mobile'
                                });

                            case 2:
                                res = _context2.sent;

                                if (res && res.status === 0) {
                                    // 显示开头语
                                    if (res.data && res.data.welcome) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.welcome
                                        };

                                        _this2.msgBox.push(msgBox);
                                    }
                                    // 显示热点问题
                                    if (res.data && res.data.quetions && res.data.quetions.length > 0) {
                                        _this2.questions = res.data.quetions;
                                    }
                                    // 结束语
                                    if (res.data.conclusion) {
                                        _this2.conclusion = res.data.conclusion;
                                    }
                                } else {
                                    _this2.$vux.toast.text(res.message, "bottom");
                                }

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getQuickLink: function getQuickLink() {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var res;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return dingding_getQuickLinkUrl({
                                    source: 'mobile',
                                    platform: _this3.sessionInfo.platform
                                });

                            case 2:
                                res = _context3.sent;

                                if (res && res.status === 0) {
                                    if (res.data && res.data.items && res.data.items.length > 0) {
                                        _this3.selectBox = res.data.items;
                                    }
                                    // 快捷操作
                                    if (res.data.quickReplyTerms) {
                                        _this3.quickItems = res.data.quickReplyTerms.split(";");
                                    }
                                } else {
                                    _this3.$vux.toast.text(res.message, "bottom");
                                }

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },


        // 修改热点问题
        changeTab: function changeTab(i) {
            this.currentTab = i;
        },


        // 跳转其他页面
        goOtherLink: function goOtherLink(url, icon) {
            var filterObj = {
                yuyue: "order",
                chajian: "track",
                wangdian: "site",
                yunfei: "freight"
            };
            this.fastTrackCount(filterObj[icon], function () {
                location.href = url;
            });
        },


        // 处理问题
        resolveProblem: function resolveProblem(index, flag) {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                var item, res;
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                item = _this4.msgReBox[index];

                                if (!(item.resolve === 0 || item.resolve === 1)) {
                                    _context4.next = 4;
                                    break;
                                }

                                _this4.$vux.toast.text('请勿重复评价！', "bottom");
                                return _context4.abrupt("return");

                            case 4:
                                _this4.$set(item, 'resolve', flag);
                                _context4.next = 7;
                                return dingding_robotAdopt({
                                    isOk: flag === 1,
                                    messageId: _this4.msgReBox[index].nodeId,
                                    sessionId: _this4.sessionId,
                                    source: 'mobile'
                                });

                            case 7:
                                res = _context4.sent;

                                if (res.status === 0) {
                                    // 关闭机器人会话？
                                    _this4.sendDingDing(item.resolve === 1 ? '已解决' : '未解决');
                                } else {
                                    _this4.$vux.toast.text(res.message, "bottom");
                                }

                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },


        // 发送消息;
        sendMsg: function sendMsg(message) {
            // 转人工中
            if (this.currentType === 'toManual') {
                this.$vux.toast.text('目前排队人数较多，请耐心等待！', "bottom");
                return;
            }
            if (this.inputValue === "" && !message && !this.isImg) {
                return false;
            }
            if (this.inputValue.length >= 350) {
                this.$vux.toast.text("字符长度超过限制！", "bottom");
                return;
            }
            // 非图片类型
            if (!this.isImg) {
                var _ibox = {
                    type: 1,
                    imgUrl: "",
                    msgContent: common.formatMsg(message ? message : this.inputValue)
                };
                this.msgReBox.push(_ibox);
                var newMessage = message || this.inputValue;
                // 清空输入框
                this.inputValue = "";
                // 滚动到底部
                this.scrollToBottom();
                if (this.currentType === "auto") {
                    this.sendDingDing(newMessage);
                } else if (this.currentType === "service") {
                    this.sendManual(newMessage);
                }
            } else {
                //图片1
                var _ibox2 = {
                    type: 1,
                    imgUrl: message,
                    msgContent: "<img src=\"" + message + "\" style=\"max-width: 220px; display: block;\"/>"
                };
                this.msgReBox.push(_ibox2);
                this.isImg = false;
                // 清空输入框
                this.inputValue = "";
                // 滚动到底部
                this.scrollToBottom();
            }
        },


        // 发送钉钉消息
        sendDingDing: function sendDingDing(message) {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                var params, res, item, msg;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                params = {
                                    content: message,
                                    platform: _this5.sessionInfo.platform,
                                    sessionId: _this5.sessionId,
                                    mail_no: _this5.waybillNo,
                                    source: _this5.sessionInfo.source
                                };
                                _context5.next = 3;
                                return dingding_robotCall(params);

                            case 3:
                                res = _context5.sent;

                                if (!(res.status === 0)) {
                                    _context5.next = 31;
                                    break;
                                }

                                item = res.data;

                                _this5.robotStatus = item.stage;
                                msg = {
                                    type: 0,
                                    nodeId: item.nodeId,
                                    contentType: "",
                                    msgContent: "",
                                    relateQuestions: item.relateQuestions
                                };

                                _this5.sessionId = item.sessionId;
                                _this5.robotId = item.robotId || '';
                                window.localStorage.setItem('robotId', item.robotId || '');
                                window.localStorage.setItem('sessionId', item.sessionId || '');

                                if (item.verifyCode && item.verifyCode == 1) {
                                    _this5.telPhone = item.customerMobile;
                                    _this5.verifyShow = true;
                                }
                                _context5.t0 = res.data.stage;
                                _context5.next = _context5.t0 === 'TO_HUMAN' ? 16 : _context5.t0 === 'TO_O_HUMAN' ? 18 : _context5.t0 === 'INVALID' ? 21 : 25;
                                break;

                            case 16:
                                if (item.mail_no) {
                                    // 有单直接转人工
                                    _this5.chooseWaybill(item.mail_no);
                                } else {
                                    // 无单咨询
                                    msg.contentType = "ACS";
                                    // 埋点-客户追踪
                                    _this5.trackManual();
                                    _this5.msgReBox.push(msg);
                                }
                                return _context5.abrupt("break", 28);

                            case 18:
                                // if (item.mail_no) {
                                //     // 有单直接转人工
                                //     this.chooseWaybill(item.mail_no);
                                // } else {
                                //     // 无单咨询
                                //     this.siteCode = "999995";
                                //     this.getAuth("siteCode");
                                // }
                                _this5.siteCode = "999995";
                                _this5.getAuth("siteCode", item.mail_no);
                                return _context5.abrupt("break", 28);

                            case 21:
                                // 再次发送消息
                                _this5.sessionId = '';
                                _this5.robotId = '';
                                _this5.sendDingDing(message);
                                return _context5.abrupt("break", 28);

                            case 25:
                                msg.msgContent = common.convertMsg(item.answer) || '系统繁忙';
                                _this5.msgReBox.push(msg);
                                return _context5.abrupt("break", 28);

                            case 28:
                                _this5.scrollToBottom();
                                _context5.next = 32;
                                break;

                            case 31:
                                _this5.$vux.toast.text(res.message);

                            case 32:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },


        // 发送人工消息
        sendManual: function sendManual(message) {
            var _this6 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return service_postMessage(extends_default()({
                                    content: message
                                }, _this6.sessionInfo, {
                                    subId: _this6.subId,
                                    msgId: _this6.msgId,
                                    type: "text"
                                }));

                            case 2:
                                res = _context6.sent;

                                if (!chat_timer) {
                                    chat_timer = setInterval(_this6.getManualMessage, 2000);
                                }
                                // 如果人工消息是等待中的话，需要返回消息
                                if (res.status === 0) {
                                    if (res.data.stage === "auto") {
                                        // 关闭定时器
                                        if (chat_timer) {
                                            clearInterval(chat_timer), chat_timer = null;
                                        }
                                        _this6.currentType = "auto";
                                    }

                                    // 有人工消息直接展示在页面上
                                    if (res.data.content) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.content
                                        };

                                        _this6.msgReBox.push(msgBox);
                                        _this6.scrollToBottom();
                                    }
                                }

                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },


        // 获取人工消息
        getManualMessage: function getManualMessage() {
            var _this7 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                var result, msg, pmsg, _ibox3;

                return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return service_pullMessage(extends_default()({}, _this7.sessionInfo, {
                                    subId: _this7.subId,
                                    msgId: _this7.msgId,
                                    attr: 'pull-message'
                                }));

                            case 2:
                                result = _context7.sent;
                                msg = {
                                    type: 0,
                                    imgUrl: ""
                                };

                                if (!(result.status === 0)) {
                                    _context7.next = 17;
                                    break;
                                }

                                if (!(result.data != null)) {
                                    _context7.next = 15;
                                    break;
                                }

                                pmsg = result.data;
                                // 会话自动关闭

                                if (!(pmsg.category === "sys_ssncls")) {
                                    _context7.next = 13;
                                    break;
                                }

                                // 客服关闭会话
                                _this7.currentType = "auto";
                                _this7.closeSession();
                                return _context7.abrupt("return");

                            case 13:
                                _this7.msgId = result.data.msgId;
                                if (result.data != null && result.data.type === "text") {
                                    msg.msgContent = common.convertMsg(result.data.text.content);
                                    _this7.msgReBox.push(msg);
                                    _this7.scrollToBottom();
                                } else if (result.data != null && result.data.type === "image") {
                                    if (result.data.image.pic_url.startsWith('http')) {
                                        _this7.imgUrl = result.data.image.pic_url;
                                    } else {
                                        _this7.imgUrl = "data:image/png;base64," + result.data.image.pic_url;
                                    }
                                    _ibox3 = {
                                        type: 0,
                                        imgUrl: _this7.imgUrl,
                                        msgContent: "<img src=\"" + _this7.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                    };

                                    _this7.msgReBox.push(_ibox3);
                                    _this7.scrollToBottom();
                                }

                            case 15:
                                _context7.next = 18;
                                break;

                            case 17:
                                console.log("拉取会话失败！");

                            case 18:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },


        // 获取机器人聊天记录
        getRobotMessageList: function getRobotMessageList() {
            var _this8 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                var res, items;
                return regenerator_default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.robotId) {
                                    _context8.next = 2;
                                    break;
                                }

                                return _context8.abrupt("return");

                            case 2:
                                _context8.next = 4;
                                return dingding_robotMessageList({
                                    // robotId: this.robotId,
                                    sessionId: _this8.sessionId,
                                    current: 1,
                                    size: 1000
                                });

                            case 4:
                                res = _context8.sent;

                                if (res.code == 0) {
                                    if (res.data && res.data.items && res.data.items.length > 0) {
                                        items = res.data.items;

                                        items.forEach(function (msg) {
                                            var type = msg.category === 'autreq' ? 1 : 0;
                                            if (msg.msgType === "text") {
                                                var _ibox4 = {
                                                    type: type,
                                                    imgUrl: "",
                                                    msgContent: common.convertMsg(msg.content)
                                                };
                                                _this8.msgReBox.push(_ibox4);
                                            } else {
                                                var imgUrl = "data:image/png;base64," + msg.picUrl;
                                                var _ibox5 = {
                                                    type: type,
                                                    imgUrl: imgUrl,
                                                    msgContent: "<img src=\"" + imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                };
                                                _this8.msgReBox.push(_ibox5);
                                            }
                                        });
                                    }
                                } else {
                                    _this8.$vux.toast.text(res.message, 'bottom');
                                }

                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        },


        // 获取历史消息
        getMessageList: function getMessageList() {
            var _this9 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                var msg, msgs, i, lastMsgId, date, _msg, type, _ibox6, _msg2;

                return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return service_getHistory(extends_default()({}, _this9.sessionInfo));

                            case 2:
                                msg = _context9.sent;

                                if (msg !== null && msg.status === 0) {
                                    msgs = msg.data.items;

                                    if (msgs.length > 0) {
                                        _this9.isHistory = true;
                                        for (i = 0; i < msgs.length; i++) {
                                            if (msgs[i].msgId != 0) {
                                                lastMsgId = msgs[i].msgId;

                                                _this9.msgId = lastMsgId || 0;
                                            }
                                            if (msgs[i].sendAt != null && msgs[i].sendAt != "") {
                                                date = new Date(msgs[i].sendAt);

                                                _this9.lastTime = formatDate(date, "MM月dd日 hh:mm"); //最后之间
                                            }
                                            if (msgs[i].category === "sys_ssncls") {
                                                // 会话关闭
                                                // this.closeSession()
                                            } else {
                                                if (msgs[i].type === "text") {
                                                    _msg = {
                                                        type: 0,
                                                        imgUrl: "",
                                                        msgContent: common.convertMsg(msgs[i].msgBody.content)
                                                    };

                                                    if (msgs[i].category === "manreq") {
                                                        _msg.type = 1;
                                                    }
                                                    _this9.msgReBox.push(_msg);
                                                } else if (msgs[i].type === "image") {
                                                    type = 0;

                                                    if (msgs[i].category === "manreq") {
                                                        type = 1;
                                                    }
                                                    _this9.imgUrl = "data:image/png;base64," + msgs[i].msgBody.pic_url;
                                                    _ibox6 = {
                                                        type: type,
                                                        imgUrl: _this9.imgUrl,
                                                        msgContent: "<img src=\"" + _this9.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                    };

                                                    _this9.msgReBox.push(_ibox6);
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    _msg2 = {
                                        type: 0,
                                        imgUrl: "",
                                        msgContent: common.convertMsg(_msg2.message)
                                    };

                                    _this9.msgBox.push(ibox);
                                }
                                _this9.scrollToBottom();

                            case 5:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9);
            }))();
        },


        // 验证码后调用机器人接口
        rebotResponse: function rebotResponse(phoneType) {
            var _this10 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
                var params, res, item, msg;
                return regenerator_default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                params = {
                                    content: phoneType,
                                    platform: _this10.sessionInfo.platform,
                                    sessionId: _this10.sessionId,
                                    mail_no: _this10.waybillNo,
                                    source: _this10.sessionInfo.source,
                                    mobileVerifyResult: phoneType
                                };
                                _context10.next = 3;
                                return dingding_robotCall(params);

                            case 3:
                                res = _context10.sent;

                                if (!(res.status === 0)) {
                                    _context10.next = 30;
                                    break;
                                }

                                item = res.data;

                                _this10.robotStatus = item.stage;
                                msg = {
                                    type: 0,
                                    nodeId: item.nodeId,
                                    contentType: "",
                                    msgContent: "",
                                    relateQuestions: item.relateQuestions
                                };

                                _this10.sessionId = item.sessionId;
                                _this10.robotId = item.robotId || '';
                                window.localStorage.setItem('robotId', item.robotId || '');
                                window.localStorage.setItem('sessionId', item.sessionId || '');

                                _context10.t0 = res.data.stage;
                                _context10.next = _context10.t0 === 'TO_HUMAN' ? 15 : _context10.t0 === 'TO_O_HUMAN' ? 17 : _context10.t0 === 'INVALID' ? 20 : 24;
                                break;

                            case 15:
                                if (item.mail_no) {
                                    // 有单直接转人工
                                    _this10.chooseWaybill(item.mail_no);
                                } else {
                                    // 无单咨询
                                    msg.contentType = "ACS";
                                    // 埋点-客户追踪
                                    _this10.trackManual();
                                    _this10.msgReBox.push(msg);
                                }
                                return _context10.abrupt("break", 27);

                            case 17:
                                // if (item.mail_no) {
                                //     // 有单直接转人工
                                //     this.chooseWaybill(item.mail_no);
                                // } else {
                                //     // 无单咨询
                                //     this.siteCode = "999995";
                                //     this.getAuth("siteCode");
                                // }
                                _this10.siteCode = "999995";
                                _this10.getAuth("siteCode", item.mail_no);
                                return _context10.abrupt("break", 27);

                            case 20:
                                // 再次发送消息
                                _this10.sessionId = '';
                                _this10.robotId = '';
                                _this10.sendDingDing(message);
                                return _context10.abrupt("break", 27);

                            case 24:
                                msg.msgContent = common.convertMsg(item.answer) || '系统繁忙';
                                _this10.msgReBox.push(msg);
                                return _context10.abrupt("break", 27);

                            case 27:
                                _this10.scrollToBottom();
                                _context10.next = 31;
                                break;

                            case 30:
                                _this10.$vux.toast.text(res.message);

                            case 31:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10);
            }))();
        },

        // 跳过验证码
        skip: function skip() {
            var phoneType = 'skip';
            this.rebotResponse(phoneType);
            this.verifyShow = false;
            this.phoneValue = '';
            this.errorTipShow = false;
        },

        // 倒计时
        endTime: function endTime() {
            var _this11 = this;

            var currentTime = this.dataForm.countTime;
            var lastTime = setInterval(function () {
                currentTime--;
                _this11.dataForm.btnText = '重新发送(' + currentTime + ')';
                if (currentTime <= 0) {
                    _this11.dataForm.disabled = false;
                    _this11.dataForm.btnText = '重新发送';
                    clearInterval(lastTime);
                }
            }, 1000);
        },

        // 发送验证码
        getVerify: function getVerify() {
            var _this12 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                var params, res;
                return regenerator_default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                params = {
                                    sessionId: _this12.sessionId
                                };
                                _context11.next = 3;
                                return dingding_sendVerify(params);

                            case 3:
                                res = _context11.sent;

                                if (res.status == 0) {
                                    console.log(res.data);
                                    _this12.dataForm.disabled = true;
                                    _this12.dataForm.countTime = 120;
                                    _this12.endTime();
                                } else if (res.status == -1) {
                                    _this12.errorTipShow = true;
                                    _this12.errorTip = res.message;
                                }

                            case 5:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this12);
            }))();
        },

        // 确定验证码
        gerDetermine: function gerDetermine() {
            var _this13 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                var params, res, phoneType;
                return regenerator_default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                console.log(_this13.phoneValue);

                                if (_this13.phoneValue) {
                                    _context12.next = 5;
                                    break;
                                }

                                _this13.errorTipShow = true;
                                _this13.errorTip = '验证码不能为空';
                                return _context12.abrupt("return");

                            case 5:
                                params = {
                                    sessionId: _this13.sessionId,
                                    verifyCode: _this13.phoneValue
                                };
                                _context12.next = 8;
                                return dingding_checkVerify(params);

                            case 8:
                                res = _context12.sent;

                                if (res.status == 0) {
                                    console.log(res.data);
                                    if (res.data.code === 'EQUAL') {
                                        phoneType = 'success';

                                        _this13.rebotResponse(phoneType);
                                        _this13.verifyShow = false;
                                        _this13.phoneValue = '';
                                        _this13.errorTipShow = false;
                                    } else if (res.data.code === 'EXPIRE') {
                                        _this13.errorTipShow = true;
                                        _this13.errorTip = res.data.message;
                                    } else if (res.data.code === 'NOT_EQUAL') {
                                        _this13.errorTipShow = true;
                                        _this13.errorTip = res.data.message;
                                    }
                                }

                            case 10:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this13);
            }))();
        },

        // 查看图片
        imgClick: function imgClick(data) {
            var _this14 = this;

            if (!data) {
                return false;
            }
            this.imgUrl = data;
            this.$nextTick(function () {
                _this14.$refs.picShowDialog.open({
                    type: "pic"
                });
            });
        },


        // 隐藏预览图片
        hideImage: function hideImage() {
            var _this15 = this;

            this.$nextTick(function () {
                _this15.$refs.picShowDialog.close();
            });
        },


        // 选择订单号
        chooseWaybill: function chooseWaybill(waybillNo) {
            this.handleWaybillNo = waybillNo;
            this.getAuth("waybillNo");
        },


        // 获取权限
        getAuth: function getAuth(type) {
            var _this16 = this;

            var waybillNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                var res, msgBox, _ibox7, _msgBox;

                return regenerator_default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _this16.currentType = "toManual";
                                _context13.next = 3;
                                return service_authSession(extends_default()({}, _this16.sessionInfo, {
                                    robotSessionId: _this16.robotId,
                                    mobile: type === "mobile" ? _this16.phoneNumber : "",
                                    waybillNo: type === "waybillNo" ? _this16.handleWaybillNo : waybillNo,
                                    orderNo: type === "orderNo" ? _this16.handleorderNo : "",
                                    siteCode: type === "siteCode" ? _this16.siteCode : ""
                                }));

                            case 3:
                                res = _context13.sent;

                                if (!(res.status === 0)) {
                                    _context13.next = 20;
                                    break;
                                }

                                if (!(res.data && res.data.stage === 'offline')) {
                                    _context13.next = 10;
                                    break;
                                }

                                msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this16.msgReBox.push(msgBox);
                                _this16.scrollToBottom();
                                return _context13.abrupt("return");

                            case 10:
                                _this16.subId = res.data.subId;
                                _this16.currentType = "service";
                                // 重置messageId
                                _this16.msgId = 0;

                                // 开启定时
                                if (!chat_timer) {
                                    chat_timer = setInterval(_this16.getManualMessage, 2000);
                                }
                                // 页面显示消息

                                if (!(type == "siteCode")) {
                                    _context13.next = 16;
                                    break;
                                }

                                return _context13.abrupt("return");

                            case 16:
                                _ibox7 = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: type === "mobile" ? _this16.phoneNumber : type === "waybillNo" ? _this16.handleWaybillNo : _this16.handleorderNo
                                };

                                _this16.msgReBox.push(_ibox7);
                                _context13.next = 22;
                                break;

                            case 20:
                                _msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this16.msgReBox.push(_msgBox);

                            case 22:
                                _this16.scrollToBottom();

                            case 23:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this16);
            }))();
        },


        // 人工客服点击追踪-埋点
        trackManual: function trackManual() {
            var _this17 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                var result;
                return regenerator_default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return service_trackManual();

                            case 2:
                                result = _context14.sent;

                            case 3:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this17);
            }))();
        },


        // 快速通道计数
        fastTrackCount: function fastTrackCount(type, cb) {
            var _this18 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
                var result;
                return regenerator_default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return service_fastTrackEntranceCount(extends_default()({}, _this18.sessionInfo, {
                                    type: type
                                }));

                            case 2:
                                result = _context15.sent;

                                cb && cb();

                            case 4:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this18);
            }))();
        },


        // 打开查询订单
        goWayBillNo: function goWayBillNo() {
            var _this19 = this;

            if (this.currentType === 'service') {
                return;
            }
            // 微信小程序才打开运单列表
            if (this.sessionInfo.userid) {
                this.$nextTick(function () {
                    _this19.$refs["chooseWaybillNo"].open({
                        type: "bottom"
                    });
                });
            } else {
                this.searchWaybillNo();
            }
        },
        onOpenChooseWaybill: function onOpenChooseWaybill() {
            var _this20 = this;

            this.$nextTick(function () {
                _this20.$refs["com-choose-waybill"].init();
            });
        },

        // 关闭查询订单
        closeChooseWaybill: function closeChooseWaybill() {
            var _this21 = this;

            this.$nextTick(function () {
                _this21.$refs["chooseWaybillNo"].close();
            });
        },

        // 关闭订单列表-打开查询订单
        goSetOrder: function goSetOrder() {
            this.closeChooseWaybill();
            this.searchWaybillNo();
        },


        // 校验手机号
        toValidPhone: function toValidPhone(e) {
            var value = e.target.value;
            var reg = constant.mobileRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validPhone = "请输入正确的手机号";
                } else {
                    this.validPhone = "";
                }
            }
        },


        // 校验运单号
        toValidWaybillNo: function toValidWaybillNo(e) {
            var value = e.target.value;
            var reg = constant.waybillNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validWaybillNo = "请输入正确的运单号";
                } else {
                    this.validWaybillNo = "";
                }
            }
        },


        // 校验国际订单号
        toValidorderNo: function toValidorderNo(e) {
            var value = e.target.value;
            var reg = constant.orderNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validorderNo = "请输入正确的国际订单号";
                } else {
                    this.validorderNo = "";
                }
            }
        },


        // 查询手机号
        goPhone: function goPhone() {
            var _this22 = this;

            // 服务中不能点击
            if (this.currentType === 'service') {
                return;
            }
            this.phoneNumber = "";
            this.validPhone = "";
            this.$refs["setPhoneDialog"].open({
                title: "请输入手机号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.mobileRegular();
                    if (reg.test(_this22.phoneNumber)) {
                        _this22.getAuth("mobile");
                        close && close();
                        _this22.validPhone = "";
                    } else {
                        _this22.validPhone = "请输入正确的手机号";
                    }
                }
            });
        },
        changeRadio: function changeRadio() {
            if (this.enterType == 0) {
                this.disabledone = false;
                this.disabledtwo = true;
                this.handleorderNo = "";
                this.validorderNo = "";
            }
            if (this.enterType == 1) {
                this.disabledone = true;
                this.disabledtwo = false;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
            }
            if (this.enterType == 2) {
                this.disabledone = true;
                this.disabledtwo = true;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
                this.handleorderNo = "";
                this.validorderNo = "";
            }
        },

        // 查询国际订单号
        goorderNo: function goorderNo() {
            var _this23 = this;

            if (this.currentType === 'service') {
                return;
            }
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.handleorderNo = "";
            this.validorderNo = "";
            this.$refs["setorderNo"].open({
                title: "请选择进入方式",
                type: "confirm",
                confirm: function confirm(close) {
                    console.log('enterType-->', _this23.enterType);
                    if (_this23.enterType == 0) {
                        var reg = constant.waybillNoRegular();
                        if (reg.test(_this23.handleWaybillNo)) {
                            _this23.getAuth("waybillNo");
                            _this23.validWaybillNo = "";
                            close && close();
                        } else {
                            _this23.validWaybillNo = "请输入正确的运单号";
                        }
                    }
                    if (_this23.enterType == 1) {
                        var _reg = constant.orderNoRegular();
                        if (_reg.test(_this23.handleorderNo)) {
                            _this23.getAuth("orderNo");
                            _this23.validorderNo = "";
                            close && close();
                        } else {
                            _this23.validorderNo = "请输入正确的国际订单号";
                        }
                    }
                    if (_this23.enterType == 2) {
                        _this23.siteCode = "999995";
                        _this23.getAuth("siteCode");
                        close && close();
                    }
                }
            });
        },

        // 查询运单号
        searchWaybillNo: function searchWaybillNo() {
            var _this24 = this;

            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.$refs["setWaybillNo"].open({
                title: "请输入单号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.waybillNoRegular();
                    if (reg.test(_this24.handleWaybillNo)) {
                        _this24.getAuth("waybillNo");
                        _this24.validWaybillNo = "";
                        close && close();
                    } else {
                        _this24.validWaybillNo = "请输入正确的运单号";
                    }
                }
            });
        },

        // 滚动到底部
        scrollToBottom: function scrollToBottom() {
            var _this25 = this;

            this.$nextTick(function () {
                var innerBox = _this25.$refs.xwBody;
                console.log("start:" + innerBox.scrollTop);
                if (innerBox.scrollHeight > innerBox.clientHeight) {
                    Object(main["setTimeout"])(function () {
                        //设置滚动条到最底部
                        innerBox.scrollTop = innerBox.scrollHeight;
                        innerBox.style.opacity = 1;
                        console.log("end:" + innerBox.scrollTop);
                    }, 50);
                }
            });
        },


        // 关闭会话
        closeSession: function closeSession(type) {
            var _this26 = this;

            this.rate = 5;
            this.$nextTick(function () {
                _this26.$refs["rateDialog"].open({
                    title: "服务评价",
                    type: "confirm",
                    confirm: function confirm(close) {
                        service_closeSession(extends_default()({}, _this26.sessionInfo, {
                            survey: _this26.rate
                        })).then(function (res) {
                            if (res.status === 0) {
                                // this.$vux.toast.text('评价成功', 'bottom');
                                // 关闭人工消息
                                var _ibox8 = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent: _this26.conclusion
                                };
                                _this26.msgReBox.push(_ibox8);
                                _this26.scrollToBottom();
                                _this26.currentType = "auto";
                                if (chat_timer) {
                                    clearInterval(chat_timer);
                                    chat_timer = null;
                                }
                                close && close();
                            } else {
                                _this26.$vux.toast.text(res.message, "bottom");
                            }
                        });
                    },
                    cancel: function cancel(close) {
                        // 如果当前是初始化状态，获取的评价调查状态
                        // 当用户点击取消的时候，需要调用关闭评价状态-默认给5星，并改成机器人会话状态
                        if (type === 'init') {
                            service_closeSession(extends_default()({}, _this26.sessionInfo, {
                                survey: 5
                            }));
                            _this26.currentType = 'auto';
                        }
                        close && close();
                    }
                });
            });
        },

        // 上传图片
        upload: function upload(e) {
            if (!this.currentType === "auto") {
                this.$vux.toast.text("机器人模式不能发送图片消息！", "bottom");
                return;
            }
            var files = e.target.files || e.dataTransfer.files;
            if (!(files[0].type === "image/png" || files[0].type === "image/jpeg")) {
                this.$vux.toast.text("亲，只支持图片上传！", "bottom");
                return;
            }
            if (files.length < 1) {
                this.$vux.toast.text("请寻找需要上传的图片！", "bottom");
                return;
            }
            this.isImg = true;
            this.imgPreview(files[0]);
        },
        imgPreview: function imgPreview(file) {
            var self = this;
            var Orientation = 0;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // EXIF.getData(file, function(){
            //     Orientation=EXIF.getTag(this, 'Orientation');
            // });
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/^image/.test(file.type)) {
                // 创建一个reader
                var reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
                    var result, img, senddata, config;
                    return regenerator_default.a.wrap(function _callee19$(_context19) {
                        while (1) {
                            switch (_context19.prev = _context19.next) {
                                case 0:
                                    result = this.result;

                                    if (result !== "null" && result !== null) {
                                        img = new Image();

                                        img.src = result;
                                        senddata = extends_default()({}, self.sessionInfo, {
                                            type: "image"
                                        });
                                        config = {
                                            headers: { "Content-Type": "application/json" }
                                        };
                                        //判断图片是否大于1M,是就直接上传，反s之压缩图片2

                                        if (this.result.length <= 1024 * 1024) {
                                            Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
                                                var data, index, res;
                                                return regenerator_default.a.wrap(function _callee16$(_context16) {
                                                    while (1) {
                                                        switch (_context16.prev = _context16.next) {
                                                            case 0:
                                                                data = self.compress(img, Orientation);
                                                                index = data.indexOf("base64") + 7;

                                                                senddata.imgData = data.substr(index);
                                                                _context16.next = 5;
                                                                return service_postMessage(senddata);

                                                            case 5:
                                                                res = _context16.sent;

                                                                if (!(res.status === 0)) {
                                                                    _context16.next = 11;
                                                                    break;
                                                                }

                                                                self.sendMsg(data);
                                                                return _context16.abrupt("return");

                                                            case 11:
                                                                self.showPositionValue = true;
                                                                self.toastText = "上传图片失败";
                                                                return _context16.abrupt("return");

                                                            case 14:
                                                            case "end":
                                                                return _context16.stop();
                                                        }
                                                    }
                                                }, _callee16, this);
                                            })), 500);
                                        } else {
                                            img.onload = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
                                                return regenerator_default.a.wrap(function _callee18$(_context18) {
                                                    while (1) {
                                                        switch (_context18.prev = _context18.next) {
                                                            case 0:
                                                                Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
                                                                    var data, index, res;
                                                                    return regenerator_default.a.wrap(function _callee17$(_context17) {
                                                                        while (1) {
                                                                            switch (_context17.prev = _context17.next) {
                                                                                case 0:
                                                                                    data = self.compress(img, Orientation);
                                                                                    index = data.indexOf("base64") + 7;

                                                                                    senddata.imgData = data.substr(index);
                                                                                    _context17.next = 5;
                                                                                    return service_postMessage(senddata);

                                                                                case 5:
                                                                                    res = _context17.sent;

                                                                                    if (!(res.status === 0)) {
                                                                                        _context17.next = 11;
                                                                                        break;
                                                                                    }

                                                                                    self.sendMsg(data);
                                                                                    return _context17.abrupt("return");

                                                                                case 11:
                                                                                    self.showPositionValue = true;
                                                                                    self.toastText = "上传图片失败";
                                                                                    return _context17.abrupt("return");

                                                                                case 14:
                                                                                case "end":
                                                                                    return _context17.stop();
                                                                            }
                                                                        }
                                                                    }, _callee17, this);
                                                                })), 500);

                                                            case 1:
                                                            case "end":
                                                                return _context18.stop();
                                                        }
                                                    }
                                                }, _callee18, this);
                                            }));
                                        }
                                    }

                                case 2:
                                case "end":
                                    return _context19.stop();
                            }
                        }
                    }, _callee19, this);
                }));
            }
        },
        rotateImg: function rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            var min_step = 0;
            var max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            var height = img.height;
            var width = img.width;
            var step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == "right") {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            var degree = step * 90 * Math.PI / 180;
            var ctx = canvas.getContext("2d");
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress: function compress(img, Orientation) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            //瓦片canvas
            var tCanvas = document.createElement("canvas");
            var tctx = tCanvas.getContext("2d");
            var initSize = img.src.length;
            var width = img.width;
            var height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            var ratio = void 0;
            if ((ratio = width * height / 4000000) > 1) {
                /* console.log("大于400万像素")*/
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //        铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            var count = void 0;
            if ((count = width * height / 1000000) > 1) {
                /*   console.log("超过100W像素");*/
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                //            计算每块瓦片的宽和高
                var nw = ~~(width / count);
                var nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (var i = 0; i < count; i++) {
                    for (var j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6:
                        //需要顺时针（向左）90度旋转
                        this.rotateImg(img, "left", canvas);
                        break;
                    case 8:
                        //需要逆时针（向右）90度旋转
                        this.rotateImg(img, "right", canvas);
                        break;
                    case 3:
                        //需要180度旋转
                        this.rotateImg(img, "right", canvas); //转两次
                        this.rotateImg(img, "right", canvas);
                        break;
                }
            }
            //进行最小压缩
            var ndata = canvas.toDataURL("image/jpeg", 0.4);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata;
        },

        // 改变评价
        changeRate: function changeRate(value) {
            this.rate = value;
        }
    },
    destroyed: function destroyed() {
        // 关闭定时器
        if (chat_timer) {
            clearInterval(chat_timer), chat_timer = null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29266f60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/chat.vue
var chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chatBox",staticClass:"chatBox"},[_c('div',{ref:"xwBody",staticClass:"msgBox"},[_c('div',{ref:"testBox",staticStyle:{"margin":"0 auto","width":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHistory),expression:"isHistory"}],staticClass:"timeShowWrap"},[_c('p',{staticClass:"timeShow"},[_vm._v("\n                    "+_vm._s(new Date().toLocaleTimeString())+"\n                ")])]),_vm._v(" "),_vm._l((_vm.msgBox),function(item,index){return _c('div',{key:index,class:['msglist', item.type === 0 ? '' : 'self']},[_c('div',{staticClass:"userImg"},[(item.type === 0)?_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("MEgf")}}):_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("fHXO")}})]),_vm._v(" "),_c('div',{staticClass:"msgInfo",domProps:{"innerHTML":_vm._s(item.msgContent)},on:{"click":function($event){return _vm.imgClick(item.imgUrl)}}},[_vm._v("\n                    "+_vm._s(item.msgContent)+"\n                ")])])})],2),_vm._v(" "),(_vm.selectBox.length > 0)?_c('div',{class:this.sessionInfo.platform === 'ruyiApplet' ? 'ruyiSelect-box' : 'select-box'},_vm._l((_vm.selectBox),function(item,index){return _c('span',{key:index,staticClass:"box-item",on:{"click":function () { return _vm.goOtherLink(item.url, item.icon); }}},[_c('img',{class:index === 2 ? 'adjust' : '',attrs:{"src":item.iconUrl,"alt":item.name}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-5px"}},[_vm._v(_vm._s(item.name))])])}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.msgReBox),function(item,index){return _c('div',{key:index,class:['msglist', item.type === 0 ? '' : 'self']},[_c('div',{staticClass:"userImg"},[(item.type === 0)?_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("MEgf")}}):_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("fHXO")}})]),_vm._v(" "),(item.contentType === 'ACS')?_c('div',{staticClass:"msgInfo msg-answer msg-acs"},[_c('div',{staticClass:"link-item acs-item",class:{'disabled': _vm.currentType === 'service'},on:{"click":_vm.goWayBillNo}},[_vm._v("\n                    1、境内运单号进入\n                ")]),_vm._v(" "),_c('div',{staticClass:"link-item acs-item",class:{'disabled': _vm.currentType === 'service'},on:{"click":_vm.goorderNo}},[_vm._v("\n                    2、国际及港澳台业务咨询\n                ")])]):_c('div',{staticClass:"msgInfo msg-answer"},[_c('div',{staticClass:"msg-content",domProps:{"innerHTML":_vm._s(item.msgContent)},on:{"click":function($event){return _vm.imgClick(item.imgUrl)}}}),_vm._v(" "),(item.relateQuestions && item.relateQuestions.length > 0)?_c('div',{staticClass:"links-container"},_vm._l((item.relateQuestions),function(link,index){return _c('div',{key:index,staticClass:"link-item",on:{"click":function () { return _vm.sendMsg(link); }}},[_vm._v("\n                        "+_vm._s(link)+"\n                    ")])}),0):_vm._e(),_vm._v(" "),(item.nodeId)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn",class:item.resolve === 1
                                    ? 'btn-outline'
                                    : 'btn-default',on:{"click":function($event){return _vm.resolveProblem(index, 1)}}},[_vm._v("\n                        已解决\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:item.resolve === 0
                                    ? 'btn-outline'
                                    : 'btn-default',on:{"click":function($event){return _vm.resolveProblem(index, 0)}}},[_vm._v("\n                        未解决\n                    ")])]):_vm._e()])])})],2),_vm._v(" "),_c('div',{staticClass:"quick-select"},_vm._l((_vm.quickItems),function(item,index){return _c('div',{key:index,staticClass:"quick-item",on:{"click":function () { return _vm.sendMsg(item); }}},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0),_vm._v(" "),_c('div',{ref:"chatFooter",staticClass:"chatFooter"},[_c('div',{staticClass:"sendBox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentType === 'service'),expression:"currentType === 'service'"}],staticClass:"iconBox"},[_c('i',{staticClass:"iIcon imgbtn"},[_c('input',{ref:"upload",staticStyle:{"width":"22px","height":"22px","opacity":"0"},attrs:{"type":"file","accept":"image/gif,image/jpeg,image/jpg,image/png,image/svg"},on:{"change":_vm.upload}})]),_vm._v(" "),_c('span',{staticClass:"closeBtn",on:{"click":_vm.closeSession}},[_vm._v("结束对话")])]),_vm._v(" "),_c('div',{staticClass:"inputBox"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],staticClass:"text-input",attrs:{"placeholder":"请输入内容","id":"text-input","max":"30","rows":"1"},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"sendBtn",class:_vm.inputValue.length > 0 ? 'active' : '',on:{"click":function () { return _vm.sendMsg(); }}},[_vm._v("\n                    发送\n                ")])])])]),_vm._v(" "),_c('yto-modal',{ref:"rateDialog"},[_c('yto-rate',{attrs:{"value":_vm.rate},on:{"change":_vm.changeRate}})],1),_vm._v(" "),_c('yto-modal',{ref:"chooseWaybillNo",on:{"open":_vm.onOpenChooseWaybill}},[_c('waybillnos-list',{ref:"com-choose-waybill",on:{"close":_vm.closeChooseWaybill,"sendMessage":_vm.chooseWaybill,"goSetOrder":_vm.goSetOrder}})],1),_vm._v(" "),_c('yto-modal',{ref:"setWaybillNo"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_vm._v("单号:")]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleWaybillNo),expression:"handleWaybillNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.handleWaybillNo)},on:{"change":_vm.toValidWaybillNo,"input":function($event){if($event.target.composing){ return; }_vm.handleWaybillNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validWaybillNo))])])])]),_vm._v(" "),_c('yto-modal',{ref:"setPhoneDialog"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_vm._v("手机号:")]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-value",attrs:{"placeholder":"请输入","type":"number","pattern":"\\d*"},domProps:{"value":(_vm.phoneNumber)},on:{"change":_vm.toValidPhone,"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validPhone))])])])]),_vm._v(" "),_c('yto-modal',{ref:"setorderNo"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labelone"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labelone","value":"0"},domProps:{"checked":_vm._q(_vm.enterType,"0")},on:{"change":[function($event){_vm.enterType="0"},_vm.changeRadio]}}),_vm._v("\n                    运单号")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleWaybillNo),expression:"handleWaybillNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入","disabled":_vm.disabledone},domProps:{"value":(_vm.handleWaybillNo)},on:{"change":_vm.toValidWaybillNo,"input":function($event){if($event.target.composing){ return; }_vm.handleWaybillNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validWaybillNo))])])]),_vm._v(" "),_c('div',{staticClass:"form-item te-form"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labeltwo"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labeltwo","value":"1"},domProps:{"checked":_vm._q(_vm.enterType,"1")},on:{"change":[function($event){_vm.enterType="1"},_vm.changeRadio]}}),_vm._v("\n                    订单号")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleorderNo),expression:"handleorderNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入","disabled":_vm.disabledtwo},domProps:{"value":(_vm.handleorderNo)},on:{"change":_vm.toValidorderNo,"input":function($event){if($event.target.composing){ return; }_vm.handleorderNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validorderNo))])])]),_vm._v(" "),_c('div',{staticClass:"form-item te-item"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labelthree"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labelthree","value":"2"},domProps:{"checked":_vm._q(_vm.enterType,"2")},on:{"change":[function($event){_vm.enterType="2"},_vm.changeRadio]}}),_vm._v("\n                    转运业务咨询")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container container-te"})])]),_vm._v(" "),_c('yto-modal',{ref:"picShowDialog"},[_c('img',{staticClass:"image-show",attrs:{"src":_vm.imgUrl},on:{"click":_vm.hideImage}})]),_vm._v(" "),(this.verifyShow)?_c('div',{staticClass:"pop"}):_vm._e(),_vm._v(" "),(this.verifyShow)?_c('div',{staticClass:"tel"},[_c('p',{staticClass:"tel-title"},[_vm._v("手机号码验证")]),_vm._v(" "),_c('div',{staticClass:"skip",on:{"click":function($event){return _vm.skip()}}},[_vm._v("跳过")]),_vm._v(" "),_c('p',{staticClass:"tips"},[_vm._v("为了更好的为您提供服务，请您进行手机号码验证")]),_vm._v(" "),_c('div',{staticClass:"phone"},[_c('div',{staticClass:"phone-top"},[_vm._v("手机号码:"),_c('span',{staticClass:"phone-top-right"},[_vm._v(_vm._s(this.telPhone))])]),_vm._v(" "),_c('div',{staticClass:"phone-btn"},[_c('div',{staticClass:"verifiction"},[_vm._v("验证码:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneValue),expression:"phoneValue"}],staticClass:"ver-text",attrs:{"type":"text","maxlength":"6","oninput":"value=value.replace(/[^\\d]/g,'')"},domProps:{"value":(_vm.phoneValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneValue=$event.target.value}}}),_vm._v(" "),_c('button',{class:this.dataForm.disabled == false ? 'ver-btn' : 'dis-btn',attrs:{"disabled":this.dataForm.disabled},on:{"click":_vm.getVerify}},[_vm._v(_vm._s(this.dataForm.btnText))])]),_vm._v(" "),_c('div',{staticClass:"determine"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.errorTipShow),expression:"this.errorTipShow"}],staticClass:"determine-tips"},[_vm._v(_vm._s(this.errorTip + ', 请重新输入验证码'))]),_vm._v(" "),_c('button',{staticClass:"determine-btn",class:this.errorTipShow ? '' : 'te-height',on:{"click":_vm.gerDetermine}},[_vm._v("确定")])])])]):_vm._e()],1)}
var chat_staticRenderFns = []
var chat_esExports = { render: chat_render, staticRenderFns: chat_staticRenderFns }
/* harmony default export */ var views_chat_chat = (chat_esExports);
// CONCATENATED MODULE: ./src/views/chat/chat.vue
function chat_injectStyle (ssrContext) {
  __webpack_require__("bOeY")
}
var chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var chat___vue_template_functional__ = false
/* styles */
var chat___vue_styles__ = chat_injectStyle
/* scopeId */
var chat___vue_scopeId__ = "data-v-29266f60"
/* moduleIdentifier (server only) */
var chat___vue_module_identifier__ = null
var chat_Component = chat_normalizeComponent(
  chat_chat,
  views_chat_chat,
  chat___vue_template_functional__,
  chat___vue_styles__,
  chat___vue_scopeId__,
  chat___vue_module_identifier__
)

/* harmony default export */ var src_views_chat_chat = (chat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/waybillItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var xiaoI_waybillItem = ({
    name: 'online-waybill-item',
    props: ['item', 'type'],
    computed: {
        createTime: function createTime() {
            return common.formatTime('YYYY-mm-dd HH:MM', new Date(this.item.createTime));
        }
    },
    methods: {
        // 发送消息
        sendMessage: function sendMessage() {
            this.$emit('sendMessage');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/waybillItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var views_xiaoI_waybillItem = ({
    name: 'online-waybill-item',
    props: ['item', 'type'],
    computed: {
        createTime: function createTime() {
            return common.formatTime('YYYY-mm-dd HH:MM', new Date(this.item.createTime));
        }
    },
    methods: {
        // 发送消息
        sendMessage: function sendMessage() {
            this.$emit('sendMessage');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bb45cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xiaoI/waybillItem.vue
var xiaoI_waybillItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waybill-item",on:{"click":_vm.sendMessage}},[_c('div',{staticClass:"basic-info flx-row-be"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.type === "SEND" ? (_vm.item.mailNo ? '运单号' : '订单号') : '运单号')+"\n            "+_vm._s(_vm.type === "SEND" ? (_vm.item.mailNo ? _vm.item.mailNo : _vm.item.orderNo ) : _vm.item.mailNo))]),_vm._v(" "),_c('span',[_vm._v("下单时间: "+_vm._s(_vm.createTime))])]),_vm._v(" "),_c('div',{staticClass:"send-info flx-row align-column-ce"},[_c('div',{staticClass:"address-container"},[_c('div',{staticClass:"address-name"},[_vm._v(_vm._s(_vm.item.senderProvinceName))]),_vm._v(" "),_c('div',{staticClass:"address-info"},[_vm._v(_vm._s(_vm.item.senderName))])]),_vm._v(" "),_c('div',{staticClass:"address-arrow-container flx-col-ce"},[_c('img',{staticClass:"arrow",attrs:{"src":"static/img/chat/ico_sender.png","alt":"箭头"}}),_vm._v(" "),_c('div',{staticClass:"address-status"},[_vm._v(_vm._s(_vm.item.statusName))])]),_vm._v(" "),_c('div',{staticClass:"address-container"},[_c('div',{staticClass:"address-name"},[_vm._v(_vm._s(_vm.item.receiverProvinceName))]),_vm._v(" "),_c('div',{staticClass:"address-info"},[_vm._v(_vm._s(_vm.item.receiverName))])])])])}
var xiaoI_waybillItem_staticRenderFns = []
var xiaoI_waybillItem_esExports = { render: xiaoI_waybillItem_render, staticRenderFns: xiaoI_waybillItem_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_xiaoI_waybillItem = (xiaoI_waybillItem_esExports);
// CONCATENATED MODULE: ./src/views/xiaoI/waybillItem.vue
function xiaoI_waybillItem_injectStyle (ssrContext) {
  __webpack_require__("5WOj")
}
var xiaoI_waybillItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var xiaoI_waybillItem___vue_template_functional__ = false
/* styles */
var xiaoI_waybillItem___vue_styles__ = xiaoI_waybillItem_injectStyle
/* scopeId */
var xiaoI_waybillItem___vue_scopeId__ = "data-v-34bb45cb"
/* moduleIdentifier (server only) */
var xiaoI_waybillItem___vue_module_identifier__ = null
var xiaoI_waybillItem_Component = xiaoI_waybillItem_normalizeComponent(
  views_xiaoI_waybillItem,
  selectortype_template_index_0_src_views_xiaoI_waybillItem,
  xiaoI_waybillItem___vue_template_functional__,
  xiaoI_waybillItem___vue_styles__,
  xiaoI_waybillItem___vue_scopeId__,
  xiaoI_waybillItem___vue_module_identifier__
)

/* harmony default export */ var src_views_xiaoI_waybillItem = (xiaoI_waybillItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/waybillnosList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var xiaoI_waybillnosList = ({
    name: 'online-waybillNo-list',
    components: {
        waybillItem: src_views_xiaoI_waybillItem
    },
    data: function data() {
        return {
            currentTab: 'RECEIVE', // 我寄的 - 'SEND', wo'shou 'RECEIVE'
            senderList: [],
            senderListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            },
            receiveList: [],
            receiveListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            }
        };
    },

    methods: {
        init: function init() {
            this.openid = window.localStorage.getItem('openid');
            this.source = window.localStorage.getItem('source');
            this.userid = window.localStorage.getItem('userid');
            this.changeTab(this.currentTab);
            this.initScroll();
        },

        // 上拉加载方法
        initScroll: function initScroll() {
            var _this = this;

            this.$nextTick(function () {
                // 我发送的
                var scrollDom = document.getElementById('sender-list');
                scrollDom.onscroll = function () {
                    var scrollTop = scrollDom.scrollTop;
                    var clientHeight = scrollDom.clientHeight;
                    var scrollHeight = scrollDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.senderListPagination.hasNext) {
                            _this.senderListPagination.pageNo += 1;
                            _this.getSendList();
                        }
                    }
                };
                // 我收到的
                var scrollReceiveDom = document.getElementById('receive-list');
                scrollReceiveDom.onscroll = function () {
                    var scrollTop = scrollReceiveDom.scrollTop;
                    var clientHeight = scrollReceiveDom.clientHeight;
                    var scrollHeight = scrollReceiveDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.receiveListPagination.hasNext) {
                            _this.receiveListPagination.pageNo += 1;
                            _this.getReceiveList();
                        }
                    }
                };
            });
        },

        // 下拉刷新
        refresh: function refresh() {
            // TODO
        },
        sendMessage: function sendMessage(item) {
            if (this.currentTab === 'SEND') {
                this.$emit('sendMessage', item.mailNo ? item.mailNo : item.orderNo);
            } else {
                this.$emit('sendMessage', item.mailNo);
            }
            this.$emit('close');
        },

        // 切换tab
        changeTab: function changeTab(type) {
            this.currentTab = type;
            if (type === 'SEND') {
                this.getSendList();
            } else {
                this.getReceiveList();
            }
        },

        // 关闭当前窗口
        close: function close() {
            this.$emit('close');
        },


        // 手动收入订单
        goSetOrder: function goSetOrder() {
            this.$emit('goSetOrder');
        },


        // 我寄的
        getSendList: function getSendList() {
            var _this2 = this;

            if (!this.userid) {
                return;
            }
            service_getMySendList({
                // userid: "1330437178689974274",
                userid: this.userid,
                source: this.source,
                pageNo: this.senderListPagination.pageNo,
                limit: this.senderListPagination.limit
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items;
                    var list = _this2.senderList;
                    if (_this2.senderListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this2.senderList = list;
                    _this2.senderListPagination = {
                        pageNo: result.pageNo,
                        limit: result.limit,
                        total: result.total,
                        hasNext: result.pageNo * result.limit < result.total
                    };
                } else {
                    _this2.senderList = [];
                    _this2.senderListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        },


        // 我收的
        getReceiveList: function getReceiveList() {
            var _this3 = this;

            if (!this.userid) {
                return;
            }
            service_getMyReceiveList({
                // userid: ":task:" + this.openid,
                // userid: "1331881598127812609",
                userid: this.userid,
                pageNo: this.receiveListPagination.pageNo,
                limit: this.receiveListPagination.limit,
                source: this.source
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items.map(function (item) {
                        return extends_default()({}, item, {
                            createTime: item.orderCreateTime,
                            senderProvinceName: item.senderCityName,
                            receiverProvinceName: item.receiverCityName
                        });
                    });
                    var list = _this3.receiveList;
                    if (_this3.receiveListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this3.receiveList = list;
                    _this3.receiveListPagination = {
                        pageNo: Number(result.pageNo),
                        limit: Number(result.limit),
                        total: Number(result.total),
                        hasNext: res.morePage
                    };
                } else {
                    _this3.receiveList = [];
                    _this3.receiveListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/waybillnosList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var views_xiaoI_waybillnosList = ({
    name: 'online-waybillNo-list',
    components: {
        waybillItem: src_views_xiaoI_waybillItem
    },
    data: function data() {
        return {
            currentTab: 'RECEIVE', // 我寄的 - 'SEND', wo'shou 'RECEIVE'
            senderList: [],
            senderListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            },
            receiveList: [],
            receiveListPagination: {
                pageNo: 1,
                limit: 5,
                total: 0,
                hasNext: false
            }
        };
    },

    methods: {
        init: function init() {
            this.openid = window.localStorage.getItem('openid');
            this.source = window.localStorage.getItem('source');
            this.userid = window.localStorage.getItem('userid');
            this.changeTab(this.currentTab);
            this.initScroll();
        },

        // 上拉加载方法
        initScroll: function initScroll() {
            var _this = this;

            this.$nextTick(function () {
                // 我发送的
                var scrollDom = document.getElementById('sender-list');
                scrollDom.onscroll = function () {
                    var scrollTop = scrollDom.scrollTop;
                    var clientHeight = scrollDom.clientHeight;
                    var scrollHeight = scrollDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.senderListPagination.hasNext) {
                            _this.senderListPagination.pageNo += 1;
                            _this.getSendList();
                        }
                    }
                };
                // 我收到的
                var scrollReceiveDom = document.getElementById('receive-list');
                scrollReceiveDom.onscroll = function () {
                    var scrollTop = scrollReceiveDom.scrollTop;
                    var clientHeight = scrollReceiveDom.clientHeight;
                    var scrollHeight = scrollReceiveDom.scrollHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                        // 加载下一页
                        if (_this.receiveListPagination.hasNext) {
                            _this.receiveListPagination.pageNo += 1;
                            _this.getReceiveList();
                        }
                    }
                };
            });
        },

        // 下拉刷新
        refresh: function refresh() {
            // TODO
        },
        sendMessage: function sendMessage(item) {
            if (this.currentTab === 'SEND') {
                this.$emit('sendMessage', item.mailNo ? item.mailNo : item.orderNo);
            } else {
                this.$emit('sendMessage', item.mailNo);
            }
            this.$emit('close');
        },

        // 切换tab
        changeTab: function changeTab(type) {
            this.currentTab = type;
            if (type === 'SEND') {
                this.getSendList();
            } else {
                this.getReceiveList();
            }
        },

        // 关闭当前窗口
        close: function close() {
            this.$emit('close');
        },


        // 手动收入订单
        goSetOrder: function goSetOrder() {
            this.$emit('goSetOrder');
        },


        // 我寄的
        getSendList: function getSendList() {
            var _this2 = this;

            if (!this.userid) {
                return;
            }
            service_getMySendList({
                // userid: "1330437178689974274",
                userid: this.userid,
                source: this.source,
                pageNo: this.senderListPagination.pageNo,
                limit: this.senderListPagination.limit
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items;
                    var list = _this2.senderList;
                    if (_this2.senderListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this2.senderList = list;
                    _this2.senderListPagination = {
                        pageNo: result.pageNo,
                        limit: result.limit,
                        total: result.total,
                        hasNext: result.pageNo * result.limit < result.total
                    };
                } else {
                    _this2.senderList = [];
                    _this2.senderListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        },


        // 我收的
        getReceiveList: function getReceiveList() {
            var _this3 = this;

            if (!this.userid) {
                return;
            }
            service_getMyReceiveList({
                // userid: ":task:" + this.openid,
                // userid: "1331881598127812609",
                userid: this.userid,
                pageNo: this.receiveListPagination.pageNo,
                limit: this.receiveListPagination.limit,
                source: this.source
            }).then(function (res) {
                var result = res.data;
                if (result && result.items) {
                    var newList = result.items.map(function (item) {
                        return extends_default()({}, item, {
                            createTime: item.orderCreateTime,
                            senderProvinceName: item.senderCityName,
                            receiverProvinceName: item.receiverCityName
                        });
                    });
                    var list = _this3.receiveList;
                    if (_this3.receiveListPagination.pageNo === 1) {
                        list = newList;
                    } else {
                        list = list.concat(newList);
                    }
                    _this3.receiveList = list;
                    _this3.receiveListPagination = {
                        pageNo: Number(result.pageNo),
                        limit: Number(result.limit),
                        total: Number(result.total),
                        hasNext: res.morePage
                    };
                } else {
                    _this3.receiveList = [];
                    _this3.receiveListPagination = {
                        pageNo: 1,
                        limit: 5,
                        total: 0,
                        hasNext: false
                    };
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261b0dd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xiaoI/waybillnosList.vue
var xiaoI_waybillnosList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"online-customer-waybillnos"},[_c('div',{staticClass:"waybillnos-title flx-row-be"},[_c('div',{staticClass:"tab-list flx-row"},[_c('div',{staticClass:"tab-item",class:{ active: _vm.currentTab === 'SEND' },on:{"click":function($event){return _vm.changeTab('SEND')}}},[_vm._v("\n                我寄的\n            ")]),_vm._v(" "),_c('div',{staticClass:"tab-item last",class:{ active: _vm.currentTab === 'RECEIVE' },on:{"click":function($event){return _vm.changeTab('RECEIVE')}}},[_vm._v("\n                我收的\n            ")])]),_vm._v(" "),_c('img',{staticClass:"close",attrs:{"src":"static/img/chat/ico_close.png","alt":"close"},on:{"click":_vm.close}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'SEND'),expression:"currentTab === 'SEND'"}],staticClass:"waybillnos-list",attrs:{"id":"sender-list"}},[_vm._l((_vm.senderList),function(item){return _c('waybill-item',{key:item.id,attrs:{"type":"SEND","item":item},on:{"sendMessage":function($event){return _vm.sendMessage(item)}}})}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.senderList.length === 0),expression:"senderList.length === 0"}],staticClass:"empty-list"},[_c('img',{staticClass:"empty-img",attrs:{"src":__webpack_require__("RhUM"),"alt":"暂无数据"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("这里还没有订单信息呢~")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.senderListPagination.hasNext && _vm.senderList.length > 0),expression:"!senderListPagination.hasNext && senderList.length > 0"}],staticClass:"end-line"},[_vm._v("\n            我是有底线的\n        ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'RECEIVE'),expression:"currentTab === 'RECEIVE'"}],staticClass:"waybillnos-list",attrs:{"id":"receive-list"}},[_vm._l((_vm.receiveList),function(item){return _c('waybill-item',{key:item.id,attrs:{"type":"RECEIVE","item":item},on:{"sendMessage":function($event){return _vm.sendMessage(item)}}})}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.receiveList.length === 0),expression:"receiveList.length === 0"}],staticClass:"empty-list"},[_c('img',{staticClass:"empty-img",attrs:{"src":__webpack_require__("RhUM"),"alt":"暂无数据"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("这里还没有订单信息呢~")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.receiveListPagination.hasNext && _vm.receiveList.length > 0),expression:"!receiveListPagination.hasNext && receiveList.length > 0"}],staticClass:"end-line"},[_vm._v("\n            我是有底线的\n        ")])],2),_vm._v(" "),_c('button',{staticClass:"submit-btn",on:{"click":_vm.goSetOrder}},[_vm._v("没有相应的订单")])])}
var xiaoI_waybillnosList_staticRenderFns = []
var xiaoI_waybillnosList_esExports = { render: xiaoI_waybillnosList_render, staticRenderFns: xiaoI_waybillnosList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_xiaoI_waybillnosList = (xiaoI_waybillnosList_esExports);
// CONCATENATED MODULE: ./src/views/xiaoI/waybillnosList.vue
function xiaoI_waybillnosList_injectStyle (ssrContext) {
  __webpack_require__("TS1M")
}
var xiaoI_waybillnosList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var xiaoI_waybillnosList___vue_template_functional__ = false
/* styles */
var xiaoI_waybillnosList___vue_styles__ = xiaoI_waybillnosList_injectStyle
/* scopeId */
var xiaoI_waybillnosList___vue_scopeId__ = "data-v-261b0dd6"
/* moduleIdentifier (server only) */
var xiaoI_waybillnosList___vue_module_identifier__ = null
var xiaoI_waybillnosList_Component = xiaoI_waybillnosList_normalizeComponent(
  views_xiaoI_waybillnosList,
  selectortype_template_index_0_src_views_xiaoI_waybillnosList,
  xiaoI_waybillnosList___vue_template_functional__,
  xiaoI_waybillnosList___vue_styles__,
  xiaoI_waybillnosList___vue_scopeId__,
  xiaoI_waybillnosList___vue_module_identifier__
)

/* harmony default export */ var src_views_xiaoI_waybillnosList = (xiaoI_waybillnosList_Component.exports);

// CONCATENATED MODULE: ./src/service/uploadfetch.js


axios_default.a.defaults.timeout = 10000;
axios_default.a.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=utf-8';
// axios.defaults.baseURL = process.env.BASE_API;
axios_default.a.defaults.processData = false;
axios_default.a.defaults.contentType = false;
function uploadfetch_post(url, params, config) {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(url, params, config).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}
// CONCATENATED MODULE: ./src/service/uploadService.js


/**
 *  图片上传
 * @param data
 * @returns {*}
 */
var uploadService_imageUpload = function imageUpload(data, config) {
  return uploadfetch_post("/client_web_api" + '/message/post/image', data, config);
};

/**
 *  图片下载
 * @param data
 * @returns {*}
 */
var uploadService_imageDownload = function imageDownload(data) {
  return uploadfetch_post("/client_web_api" + '/v1/online/image/download', data);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/chat.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









var xiaoI_chat_timer = null;
var xiaoIProblemLinks = []; // xiaoI问题列表
/* harmony default export */ var xiaoI_chat = ({
    name: "new-chat",
    components: {
        YtoModal: src_components_yto_modal,
        waybillnosList: src_views_xiaoI_waybillnosList,
        YtoRate: src_components_yto_rate
    },
    data: function data() {
        return {
            phoneNumber: "", // 手机号码
            validPhone: "", // 校验手机号消息
            handleWaybillNo: "", // 手动输入的运单号
            validWaybillNo: "", // 校验运单号消息
            handleorderNo: "", // 手动输入的国际订单号
            validorderNo: "", //校验国际订单号消息
            enterType: "0",
            disabledone: false,
            disabledtwo: true,
            currentType: "auto", // auto - xiaoI对话  service - 人工对话 wait - 排队 survey 满意度调查 offline 非工作时间
            msgBox: [], // 初始数据;
            inputValue: "", // 发送小小
            selectBox: [], // 快捷操作
            rate: 5, // 当前评价
            subId: -1,
            imgUrl: "", // 预览图片
            isHistory: false,
            isImg: false, // 发送出去的是否是图片类型
            msgId: 0,
            siteCode: "",
            wayBillNo: "", // 运单号
            sessionInfo: {
                source: "",
                openid: "",
                platform: "site"
            },
            msgReBox: [], // 对话数据;
            hotQuestions: [], // 热点问题;
            isActive: false, // 是否可以发送消息;
            quickItems: [] // 快速查询工具
        };
    },
    created: function created() {
        this.getInitData();
    },
    mounted: function mounted() {
        // 获取开头语
        this.getBeginChat();
        // 获取常见问题列表
        this.initLink();
        // 获取当前状态
        this.getInitStatus();
    },

    methods: {
        // 获取初始化数据
        getInitData: function getInitData() {
            console.log("href:" + location.href);
            console.log("router" + stringify_default()(this.$route.query));
            var _$route$query = this.$route.query,
                _$route$query$waybill = _$route$query.waybillNo,
                waybillNo = _$route$query$waybill === undefined ? "" : _$route$query$waybill,
                _$route$query$nodeCod = _$route$query.nodeCode,
                nodeCode = _$route$query$nodeCod === undefined ? "" : _$route$query$nodeCod,
                _$route$query$platfor = _$route$query.platform,
                platform = _$route$query$platfor === undefined ? "" : _$route$query$platfor,
                _$route$query$source = _$route$query.source,
                source = _$route$query$source === undefined ? "" : _$route$query$source,
                _$route$query$openid = _$route$query.openid,
                openid = _$route$query$openid === undefined ? "" : _$route$query$openid,
                _$route$query$userid = _$route$query.userid,
                userid = _$route$query$userid === undefined ? "" : _$route$query$userid;

            this.waybillNo = waybillNo;
            this.siteCode = nodeCode;

            platform = common.isEmpty(platform) ? window.localStorage.getItem("platform") || "site" : platform;
            source = common.isEmpty(source) ? window.localStorage.getItem("source") || "" : source;
            userid = common.isEmpty(userid) ? window.localStorage.getItem("userid") || "" : userid;
            if (common.isEmpty(openid)) {
                openid = window.localStorage.getItem("openid") || common.getOpenId();
            }
            window.localStorage.setItem("platform", platform); //平台
            window.localStorage.setItem("openid", openid); //客户标志
            window.localStorage.setItem("source", source); //数据来源
            window.localStorage.setItem("userid", userid); //用户id
            this.sessionInfo = {
                openid: openid || '',
                source: source || '',
                platform: platform || '',
                userid: userid || ''
            };
        },


        // 初始查询状态;
        getInitStatus: function getInitStatus() {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var res;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return service_getStatus(_this.sessionInfo || {});

                            case 2:
                                res = _context.sent;

                                if (res && res.status == 0) {
                                    _this.currentType = res.data.stage;
                                    _this.subId = res.data.subId;
                                    if (_this.currentType === "survey") {
                                        // 打开会话
                                        _this.closeSession('init');
                                    } else if (_this.currentType === "wait") {
                                        // 等待中直接改成服务中，拉取消息
                                        _this.currentType = "service";
                                    }

                                    // 服务中的才获取历史消息
                                    if (_this.currentType === "service") {
                                        _this.getMessageList();
                                        // 拉取人工消息
                                        if (!xiaoI_chat_timer) {
                                            xiaoI_chat_timer = setInterval(_this.getManualMessage, 2000);
                                        }
                                    }
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 初始查询链接;
        initLink: function initLink() {
            var _this2 = this;

            var data = {
                platform: "wechat"
            };
            service_getLink(data).then(function (res) {
                if (res.data && Array.isArray(res.data.items)) {
                    _this2.selectBox = res.data.items;
                }
                // 快捷操作
                if (res.data.quickReplyTerms) {
                    _this2.quickItems = res.data.quickReplyTerms.split(";");
                }
            });
        },


        // 跳转其他页面
        goOtherLink: function goOtherLink(url, icon) {
            var filterObj = {
                yuyue: "order",
                chajian: "track",
                wangdian: "site",
                yunfei: "freight"
            };
            this.fastTrackCount(filterObj[icon], function () {
                location.href = url;
            });
        },


        // 获取xiaoI问题链接
        getXiaoILinks: function getXiaoILinks(str) {
            var reg = /\[link.*?\](.*?)\[\/link\]/gi;
            var result = reg.exec(str);
            if (result) {
                var link = result[1].replace(/【(.*)】/, "");
                xiaoIProblemLinks.push(link);
                var newStr = str.substr(result.index + result.length);
                this.getXiaoILinks(newStr);
            } else {
                return;
            }
        },


        // 处理问题
        resolveProblem: function resolveProblem(index, message) {
            this.msgReBox[index].resolve = message;
            this.sendMsg(message, "RESOLVE");
        },


        // 发送消息;
        sendMsg: function sendMsg(message, type) {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var newMessage, _ibox, _ibox2;

                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this3.inputValue === "" && !message && !_this3.isImg)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return", false);

                            case 2:
                                if (!(_this3.inputValue.length >= 350)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _this3.$vux.toast.text("", "bottom");
                                return _context2.abrupt("return");

                            case 5:
                                // xiaoI解决问题
                                newMessage = message;

                                if (type === "RESOLVE") {
                                    if (message === "a") {
                                        newMessage = "已解决";
                                    } else {
                                        newMessage = "未解决";
                                    }
                                }
                                // 非图片类型

                                if (_this3.isImg) {
                                    _context2.next = 20;
                                    break;
                                }

                                _ibox = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: common.formatMsg(message ? newMessage : _this3.inputValue)
                                };

                                _this3.msgReBox.push(_ibox);

                                if (!(_this3.currentType === "auto")) {
                                    _context2.next = 15;
                                    break;
                                }

                                _context2.next = 13;
                                return _this3.sendXiaoI(message, type);

                            case 13:
                                _context2.next = 18;
                                break;

                            case 15:
                                if (!(_this3.currentType === "service")) {
                                    _context2.next = 18;
                                    break;
                                }

                                _context2.next = 18;
                                return _this3.sendManual(message);

                            case 18:
                                _context2.next = 23;
                                break;

                            case 20:
                                //图片1
                                _ibox2 = {
                                    type: 1,
                                    imgUrl: message,
                                    msgContent: "<img src=\"" + message + "\" style=\"max-width: 220px; display: block;\"/>"
                                };

                                _this3.msgReBox.push(_ibox2);
                                _this3.isImg = false;

                            case 23:
                                // 清空输入框
                                _this3.inputValue = "";
                                // 滚动到底部
                                _this3.scrollToBottom();

                            case 25:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },


        // 获取xiaoI开头语
        getBeginChat: function getBeginChat() {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var params, res;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                params = {
                                    action: "BEGINCHAT",
                                    platform: "weixin", // xiaoI需要写死微信
                                    userId: ":task:" + _this4.sessionInfo.openid
                                };
                                _context3.next = 3;
                                return service_xiaoChat(params);

                            case 3:
                                res = _context3.sent;

                                _this4.msgBox.push(_this4.converXiaoIMessage(res.data.content, res.data.type, true));

                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },


        // 发送xiaoI消息
        sendXiaoI: function sendXiaoI(message) {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                var params, res;
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                params = {
                                    action: "CHATING",
                                    question: message ? message : _this5.inputValue,
                                    platform: _this5.sessionInfo.platform, // xiaoI需要写死微信
                                    userId: ":task:" + _this5.sessionInfo.openid
                                };
                                // 调用xiaoI

                                _context4.next = 3;
                                return service_xiaoChat(params);

                            case 3:
                                res = _context4.sent;

                                _this5.msgReBox.push(_this5.converXiaoIMessage(res.data.content, res.data.type));

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        converXiaoIMessage: function converXiaoIMessage(msgContent, type, isBegin) {
            var msg = {
                type: 0,
                content: "",
                contentType: type,
                msgContent: ""
            };
            // 转人工
            if (msgContent.indexOf("ACS") > -1) {
                msg.contentType = "ACS";
                // 埋点-客户追踪
                this.trackManual();
            } else if (msgContent.indexOf("您可能还关注下列问题") > -1 || msgContent.indexOf("以上答案是否解决了您的问题") > -1) {
                var contentIndex = msgContent.indexOf("您可能还关注下列问题");
                xiaoIProblemLinks = [];
                if (contentIndex > -1) {
                    var content = msgContent.substring(0, contentIndex).replace(/\n/, "");
                    msg.content = common.convertMsg(content);
                    this.getXiaoILinks(msgContent);
                } else {
                    contentIndex = msgContent.indexOf("以上答案是否解决了您的问题");
                    var _content = msgContent.substring(0, contentIndex);
                    msg.content = common.convertMsg(_content);
                }
                msg.contentType = "ANSWER";
                if (!isBegin) {
                    msg.links = xiaoIProblemLinks;
                } else {
                    this.hotQuestions = xiaoIProblemLinks;
                }
            } else {
                msg.msgContent = common.convertMsg(msgContent);
            }
            return msg;
        },


        // 发送人工消息
        sendManual: function sendManual(message) {
            var _this6 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return service_postMessage(extends_default()({
                                    content: message || _this6.inputValue
                                }, _this6.sessionInfo, {
                                    subId: _this6.subId,
                                    msgId: _this6.msgId,
                                    type: "text"
                                }));

                            case 2:
                                res = _context5.sent;

                                if (!xiaoI_chat_timer) {
                                    xiaoI_chat_timer = setInterval(_this6.getManualMessage, 2000);
                                }
                                // 如果人工消息是等待中的话，需要返回消息
                                if (res.status === 0) {
                                    if (res.data.stage === "auto") {
                                        // 关闭定时器
                                        if (xiaoI_chat_timer) {
                                            clearInterval(xiaoI_chat_timer), xiaoI_chat_timer = null;
                                        }
                                        _this6.currentType = "auto";
                                    }

                                    // 有人工消息直接展示在页面上
                                    if (res.data.content) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.content
                                        };

                                        _this6.msgReBox.push(msgBox);
                                        _this6.scrollToBottom();
                                    }
                                }

                            case 5:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },


        // 获取人工消息
        getManualMessage: function getManualMessage() {
            var _this7 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                var result, msg, pmsg, _ibox3;

                return regenerator_default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return service_pullMessage(extends_default()({}, _this7.sessionInfo, {
                                    subId: _this7.subId,
                                    msgId: _this7.msgId,
                                    attr: 'pull-message'
                                }));

                            case 2:
                                result = _context6.sent;
                                msg = {
                                    type: 0,
                                    imgUrl: ""
                                };

                                if (!(result.status === 0)) {
                                    _context6.next = 17;
                                    break;
                                }

                                if (!(result.data != null)) {
                                    _context6.next = 15;
                                    break;
                                }

                                pmsg = result.data;
                                // 会话自动关闭

                                if (!(pmsg.category === "sys_ssncls")) {
                                    _context6.next = 13;
                                    break;
                                }

                                // 客服关闭会话
                                _this7.currentType = "auto";
                                _this7.closeSession();
                                return _context6.abrupt("return");

                            case 13:
                                _this7.msgId = result.data.msgId;
                                if (result.data != null && result.data.type === "text") {
                                    msg.msgContent = common.convertMsg(result.data.text.content);
                                    _this7.msgReBox.push(msg);
                                    _this7.scrollToBottom();
                                } else if (result.data != null && result.data.type === "image") {
                                    _this7.imgUrl = "data:image/png;base64," + result.data.image.pic_url;
                                    _ibox3 = {
                                        type: 0,
                                        imgUrl: _this7.imgUrl,
                                        msgContent: "<img src=\"" + _this7.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                    };

                                    _this7.msgReBox.push(_ibox3);
                                    _this7.scrollToBottom();
                                }

                            case 15:
                                _context6.next = 18;
                                break;

                            case 17:
                                console.log("拉取会话失败！");

                            case 18:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },


        // 获取历史消息
        getMessageList: function getMessageList() {
            var _this8 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                var msg, msgs, i, lastMsgId, date, _msg, type, _ibox4, _msg2;

                return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return service_getHistory(extends_default()({
                                    subId: _this8.subId
                                }, _this8.sessionInfo));

                            case 2:
                                msg = _context7.sent;

                                if (msg !== null && msg.status === 0) {
                                    msgs = msg.data.items;

                                    if (msgs.length > 0) {
                                        _this8.isHistory = true;
                                        for (i = 0; i < msgs.length; i++) {
                                            if (msgs[i].msgId != 0) {
                                                lastMsgId = msgs[i].msgId;

                                                _this8.msgId = lastMsgId || 0;
                                            }
                                            if (msgs[i].sendAt != null && msgs[i].sendAt != "") {
                                                date = new Date(msgs[i].sendAt);

                                                _this8.lastTime = formatDate(date, "MM月dd日 hh:mm"); //最后之间
                                            }
                                            if (msgs[i].category === "sys_ssncls") {
                                                // 会话关闭
                                                // this.closeSession()
                                            } else {
                                                if (msgs[i].type === "text") {
                                                    _msg = {
                                                        type: 0,
                                                        imgUrl: "",
                                                        msgContent: common.convertMsg(msgs[i].msgBody.content)
                                                    };

                                                    if (msgs[i].category === "manreq") {
                                                        _msg.type = 1;
                                                    }
                                                    _this8.msgReBox.push(_msg);
                                                } else if (msgs[i].type === "image") {
                                                    type = 0;

                                                    if (msgs[i].category === "manreq") {
                                                        type = 1;
                                                    }
                                                    _this8.imgUrl = "data:image/png;base64," + msgs[i].msgBody.pic_url;
                                                    _ibox4 = {
                                                        type: type,
                                                        imgUrl: _this8.imgUrl,
                                                        msgContent: "<img src=\"" + _this8.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                    };

                                                    _this8.msgReBox.push(_ibox4);
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    _msg2 = {
                                        type: 0,
                                        imgUrl: "",
                                        msgContent: common.convertMsg(_msg2.message)
                                    };

                                    _this8.msgBox.push(ibox);
                                }
                                _this8.scrollToBottom();

                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this8);
            }))();
        },


        // 查看图片
        imgClick: function imgClick(data) {
            var _this9 = this;

            if (data === "") {
                return false;
            }
            this.imgUrl = data;
            this.$nextTick(function () {
                _this9.$refs.picShowDialog.open({
                    type: "pic"
                });
            });
        },


        // 隐藏预览图片
        hideImage: function hideImage() {
            var _this10 = this;

            this.$nextTick(function () {
                _this10.$refs.picShowDialog.close();
            });
        },


        // 选择订单号
        chooseWaybill: function chooseWaybill(waybillNo) {
            this.handleWaybillNo = waybillNo;
            this.getAuth("waybillNo");
        },


        // 获取权限
        getAuth: function getAuth(type) {
            var _this11 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                var res, msgBox, _ibox5, _msgBox;

                return regenerator_default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return service_authSession(extends_default()({}, _this11.sessionInfo, {
                                    mobile: type === "mobile" ? _this11.phoneNumber : "",
                                    waybillNo: type === "waybillNo" ? _this11.handleWaybillNo : "",
                                    orderNo: type === "orderNo" ? _this11.handleorderNo : "",
                                    siteCode: type === "siteCode" ? _this11.siteCode : ""
                                }));

                            case 2:
                                res = _context8.sent;

                                if (!(res.status === 0)) {
                                    _context8.next = 19;
                                    break;
                                }

                                if (!(res.data && res.data.stage === 'offline')) {
                                    _context8.next = 9;
                                    break;
                                }

                                msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this11.msgReBox.push(msgBox);
                                _this11.scrollToBottom();
                                return _context8.abrupt("return");

                            case 9:
                                _this11.subId = res.data.subId;
                                _this11.currentType = "service";
                                // 重置messageId
                                _this11.msgId = 0;

                                // 开启定时
                                if (!xiaoI_chat_timer) {
                                    xiaoI_chat_timer = setInterval(_this11.getManualMessage, 2000);
                                }
                                // 页面显示消息

                                if (!(type == "siteCode")) {
                                    _context8.next = 15;
                                    break;
                                }

                                return _context8.abrupt("return");

                            case 15:
                                _ibox5 = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: type === "mobile" ? _this11.phoneNumber : type === "waybillNo" ? _this11.handleWaybillNo : _this11.handleorderNo
                                };

                                _this11.msgReBox.push(_ibox5);
                                _context8.next = 21;
                                break;

                            case 19:
                                _msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this11.msgReBox.push(_msgBox);

                            case 21:
                                _this11.scrollToBottom();

                            case 22:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this11);
            }))();
        },


        // 人工客服点击追踪-埋点
        trackManual: function trackManual() {
            var _this12 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                var result;
                return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return service_trackManual();

                            case 2:
                                result = _context9.sent;

                            case 3:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this12);
            }))();
        },


        // 快速通道计数
        fastTrackCount: function fastTrackCount(type, cb) {
            var _this13 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
                var result;
                return regenerator_default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return service_fastTrackEntranceCount(extends_default()({}, _this13.sessionInfo, {
                                    type: type
                                }));

                            case 2:
                                result = _context10.sent;

                                cb && cb();

                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this13);
            }))();
        },


        // 打开查询订单
        goWayBillNo: function goWayBillNo() {
            var _this14 = this;

            if (this.currentType === 'service') {
                return;
            }
            // 微信小程序才打开运单列表
            if (this.sessionInfo.userid) {
                this.$nextTick(function () {
                    _this14.$refs["chooseWaybillNo"].open({
                        type: "bottom"
                    });
                });
            } else {
                this.searchWaybillNo();
            }
        },
        onOpenChooseWaybill: function onOpenChooseWaybill() {
            var _this15 = this;

            this.$nextTick(function () {
                _this15.$refs["com-choose-waybill"].init();
            });
        },

        // 关闭查询订单
        closeChooseWaybill: function closeChooseWaybill() {
            var _this16 = this;

            this.$nextTick(function () {
                _this16.$refs["chooseWaybillNo"].close();
            });
        },

        // 关闭订单列表-打开查询订单
        goSetOrder: function goSetOrder() {
            this.closeChooseWaybill();
            this.searchWaybillNo();
        },


        // 校验手机号
        toValidPhone: function toValidPhone(e) {
            var value = e.target.value;
            var reg = constant.mobileRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validPhone = "请输入正确的手机号";
                } else {
                    this.validPhone = "";
                }
            }
        },


        // 校验运单号
        toValidWaybillNo: function toValidWaybillNo(e) {
            var value = e.target.value;
            var reg = constant.waybillNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validWaybillNo = "请输入正确的运单号";
                } else {
                    this.validWaybillNo = "";
                }
            }
        },


        // 校验国际订单号
        toValidorderNo: function toValidorderNo(e) {
            var value = e.target.value;
            var reg = constant.orderNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validorderNo = "请输入正确的国际订单号";
                } else {
                    this.validorderNo = "";
                }
            }
        },


        // 查询手机号
        goPhone: function goPhone() {
            var _this17 = this;

            // 服务中不能点击
            if (this.currentType === 'service') {
                return;
            }
            this.phoneNumber = "";
            this.validPhone = "";
            this.$refs["setPhoneDialog"].open({
                title: "请输入手机号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.mobileRegular();
                    if (reg.test(_this17.phoneNumber)) {
                        _this17.getAuth("mobile");
                        close && close();
                        _this17.validPhone = "";
                    } else {
                        _this17.validPhone = "请输入正确的手机号";
                    }
                }
            });
        },
        changeRadio: function changeRadio() {
            if (this.enterType == 0) {
                this.disabledone = false;
                this.disabledtwo = true;
                this.handleorderNo = "";
                this.validorderNo = "";
            }
            if (this.enterType == 1) {
                this.disabledone = true;
                this.disabledtwo = false;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
            }
            if (this.enterType == 2) {
                this.disabledone = true;
                this.disabledtwo = true;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
                this.handleorderNo = "";
                this.validorderNo = "";
            }
        },

        // 查询国际订单号
        goorderNo: function goorderNo() {
            var _this18 = this;

            if (this.currentType === 'service') {
                return;
            }
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.handleorderNo = "";
            this.validorderNo = "";
            this.$refs["setorderNo"].open({
                title: "请选择进入方式",
                type: "confirm",
                confirm: function confirm(close) {
                    console.log('enterType-->', _this18.enterType);
                    if (_this18.enterType == 0) {
                        var reg = constant.waybillNoRegular();
                        if (reg.test(_this18.handleWaybillNo)) {
                            _this18.getAuth("waybillNo");
                            _this18.validWaybillNo = "";
                            close && close();
                        } else {
                            _this18.validWaybillNo = "请输入正确的运单号";
                        }
                    }
                    if (_this18.enterType == 1) {
                        var _reg = constant.orderNoRegular();
                        if (_reg.test(_this18.handleorderNo)) {
                            _this18.getAuth("orderNo");
                            _this18.validorderNo = "";
                            close && close();
                        } else {
                            _this18.validorderNo = "请输入正确的国际订单号";
                        }
                    }
                    if (_this18.enterType == 2) {
                        _this18.siteCode = "999995";
                        _this18.getAuth("siteCode");
                        close && close();
                    }
                }
            });
        },

        // 查询运单号
        searchWaybillNo: function searchWaybillNo() {
            var _this19 = this;

            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.$refs["setWaybillNo"].open({
                title: "请输入单号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.waybillNoRegular();
                    if (reg.test(_this19.handleWaybillNo)) {
                        _this19.getAuth("waybillNo");
                        _this19.validWaybillNo = "";
                        close && close();
                    } else {
                        _this19.validWaybillNo = "请输入正确的运单号";
                    }
                }
            });
        },

        // 滚动到底部
        scrollToBottom: function scrollToBottom() {
            var _this20 = this;

            this.$nextTick(function () {
                var innerBox = _this20.$refs.xwBody;
                console.log("start:" + innerBox.scrollTop);
                if (innerBox.scrollHeight > innerBox.clientHeight) {
                    Object(main["setTimeout"])(function () {
                        //设置滚动条到最底部
                        innerBox.scrollTop = innerBox.scrollHeight;
                        innerBox.style.opacity = 1;
                        console.log("end:" + innerBox.scrollTop);
                    }, 50);
                }
            });
        },


        // 关闭会话
        closeSession: function closeSession(type) {
            var _this21 = this;

            this.$nextTick(function () {
                _this21.$refs["rateDialog"].open({
                    title: "服务评价",
                    type: "confirm",
                    confirm: function confirm(close) {
                        service_closeSession(extends_default()({}, _this21.sessionInfo, {
                            survey: _this21.rate
                        })).then(function (res) {
                            if (res.status === 0) {
                                // this.$vux.toast.text('评价成功', 'bottom');
                                // 关闭人工消息
                                var _ibox6 = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent: "亲，谢谢您的肯定，祝您生活愉快！"
                                };
                                _this21.msgReBox.push(_ibox6);
                                _this21.scrollToBottom();
                                _this21.currentType = "auto";
                                if (xiaoI_chat_timer) {
                                    clearInterval(xiaoI_chat_timer);
                                    xiaoI_chat_timer = null;
                                }
                                close && close();
                            } else {
                                _this21.$vux.toast.text(res.message, "bottom");
                            }
                        });
                    },
                    cancel: function cancel(close) {
                        // 如果当前是初始化状态，获取的评价调查状态
                        // 当用户点击取消的时候，需要调用关闭评价状态-默认给5星，并改成xiaoI会话状态
                        if (type === 'init') {
                            service_closeSession(extends_default()({}, _this21.sessionInfo, {
                                survey: 5
                            }));
                            _this21.currentType = 'auto';
                        }
                        close && close();
                    }
                });
            });
        },

        // 上传图片
        upload: function upload(e) {
            if (!this.currentType === "auto") {
                this.$vux.toast.text("机器人模式不能发送图片消息！", "bottom");
                return;
            }
            var files = e.target.files || e.dataTransfer.files;
            if (!(files[0].type === "image/png" || files[0].type === "image/jpeg")) {
                this.$vux.toast.text("亲，只支持图片上传！", "bottom");
                return;
            }
            if (files.length < 1) {
                this.$vux.toast.text("请寻找需要上传的图片！", "bottom");
                return;
            }
            this.isImg = true;
            this.imgPreview(files[0]);
        },
        imgPreview: function imgPreview(file) {
            var self = this;
            var Orientation = 0;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // EXIF.getData(file, function(){
            //     Orientation=EXIF.getTag(this, 'Orientation');
            // });
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/^image/.test(file.type)) {
                // 创建一个reader
                var reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                    var result, img, senddata, config;
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                        while (1) {
                            switch (_context14.prev = _context14.next) {
                                case 0:
                                    result = this.result;

                                    if (result !== "null" && result !== null) {
                                        img = new Image();

                                        img.src = result;
                                        senddata = extends_default()({}, self.sessionInfo, {
                                            type: "image"
                                        });
                                        config = {
                                            headers: { "Content-Type": "application/json" }
                                        };
                                        //判断图片是否大于1M,是就直接上传，反s之压缩图片2

                                        if (this.result.length <= 1024 * 1024) {
                                            Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                                                var data, index, res;
                                                return regenerator_default.a.wrap(function _callee11$(_context11) {
                                                    while (1) {
                                                        switch (_context11.prev = _context11.next) {
                                                            case 0:
                                                                data = self.compress(img, Orientation);
                                                                index = data.indexOf("base64") + 7;

                                                                senddata.imgData = data.substr(index);
                                                                _context11.next = 5;
                                                                return service_postMessage(senddata);

                                                            case 5:
                                                                res = _context11.sent;

                                                                if (!(res.status === 0)) {
                                                                    _context11.next = 11;
                                                                    break;
                                                                }

                                                                self.sendMsg(data);
                                                                return _context11.abrupt("return");

                                                            case 11:
                                                                self.showPositionValue = true;
                                                                self.toastText = "上传图片失败";
                                                                return _context11.abrupt("return");

                                                            case 14:
                                                            case "end":
                                                                return _context11.stop();
                                                        }
                                                    }
                                                }, _callee11, this);
                                            })), 500);
                                        } else {
                                            img.onload = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                                                return regenerator_default.a.wrap(function _callee13$(_context13) {
                                                    while (1) {
                                                        switch (_context13.prev = _context13.next) {
                                                            case 0:
                                                                Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                                                                    var data, index, res;
                                                                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                                                                        while (1) {
                                                                            switch (_context12.prev = _context12.next) {
                                                                                case 0:
                                                                                    data = self.compress(img, Orientation);
                                                                                    index = data.indexOf("base64") + 7;

                                                                                    senddata.imgData = data.substr(index);
                                                                                    _context12.next = 5;
                                                                                    return service_postMessage(senddata);

                                                                                case 5:
                                                                                    res = _context12.sent;

                                                                                    if (!(res.status === 0)) {
                                                                                        _context12.next = 11;
                                                                                        break;
                                                                                    }

                                                                                    self.sendMsg(data);
                                                                                    return _context12.abrupt("return");

                                                                                case 11:
                                                                                    self.showPositionValue = true;
                                                                                    self.toastText = "上传图片失败";
                                                                                    return _context12.abrupt("return");

                                                                                case 14:
                                                                                case "end":
                                                                                    return _context12.stop();
                                                                            }
                                                                        }
                                                                    }, _callee12, this);
                                                                })), 500);

                                                            case 1:
                                                            case "end":
                                                                return _context13.stop();
                                                        }
                                                    }
                                                }, _callee13, this);
                                            }));
                                        }
                                    }

                                case 2:
                                case "end":
                                    return _context14.stop();
                            }
                        }
                    }, _callee14, this);
                }));
            }
        },
        rotateImg: function rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            var min_step = 0;
            var max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            var height = img.height;
            var width = img.width;
            var step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == "right") {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            var degree = step * 90 * Math.PI / 180;
            var ctx = canvas.getContext("2d");
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress: function compress(img, Orientation) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            //瓦片canvas
            var tCanvas = document.createElement("canvas");
            var tctx = tCanvas.getContext("2d");
            var initSize = img.src.length;
            var width = img.width;
            var height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            var ratio = void 0;
            if ((ratio = width * height / 4000000) > 1) {
                /* console.log("大于400万像素")*/
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //        铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            var count = void 0;
            if ((count = width * height / 1000000) > 1) {
                /*   console.log("超过100W像素");*/
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                //            计算每块瓦片的宽和高
                var nw = ~~(width / count);
                var nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (var i = 0; i < count; i++) {
                    for (var j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6:
                        //需要顺时针（向左）90度旋转
                        this.rotateImg(img, "left", canvas);
                        break;
                    case 8:
                        //需要逆时针（向右）90度旋转
                        this.rotateImg(img, "right", canvas);
                        break;
                    case 3:
                        //需要180度旋转
                        this.rotateImg(img, "right", canvas); //转两次
                        this.rotateImg(img, "right", canvas);
                        break;
                }
            }
            //进行最小压缩
            var ndata = canvas.toDataURL("image/jpeg", 0.4);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata;
        },

        // 改变评价
        changeRate: function changeRate(value) {
            this.rate = value;
        }
    },
    destroyed: function destroyed() {
        // 关闭定时器
        if (xiaoI_chat_timer) {
            clearInterval(xiaoI_chat_timer), xiaoI_chat_timer = null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/xiaoI/chat.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









var views_xiaoI_chat_timer = null;
var chat_xiaoIProblemLinks = []; // xiaoI问题列表
/* harmony default export */ var views_xiaoI_chat = ({
    name: "new-chat",
    components: {
        YtoModal: src_components_yto_modal,
        waybillnosList: src_views_xiaoI_waybillnosList,
        YtoRate: src_components_yto_rate
    },
    data: function data() {
        return {
            phoneNumber: "", // 手机号码
            validPhone: "", // 校验手机号消息
            handleWaybillNo: "", // 手动输入的运单号
            validWaybillNo: "", // 校验运单号消息
            handleorderNo: "", // 手动输入的国际订单号
            validorderNo: "", //校验国际订单号消息
            enterType: "0",
            disabledone: false,
            disabledtwo: true,
            currentType: "auto", // auto - xiaoI对话  service - 人工对话 wait - 排队 survey 满意度调查 offline 非工作时间
            msgBox: [], // 初始数据;
            inputValue: "", // 发送小小
            selectBox: [], // 快捷操作
            rate: 5, // 当前评价
            subId: -1,
            imgUrl: "", // 预览图片
            isHistory: false,
            isImg: false, // 发送出去的是否是图片类型
            msgId: 0,
            siteCode: "",
            wayBillNo: "", // 运单号
            sessionInfo: {
                source: "",
                openid: "",
                platform: "site"
            },
            msgReBox: [], // 对话数据;
            hotQuestions: [], // 热点问题;
            isActive: false, // 是否可以发送消息;
            quickItems: [] // 快速查询工具
        };
    },
    created: function created() {
        this.getInitData();
    },
    mounted: function mounted() {
        // 获取开头语
        this.getBeginChat();
        // 获取常见问题列表
        this.initLink();
        // 获取当前状态
        this.getInitStatus();
    },

    methods: {
        // 获取初始化数据
        getInitData: function getInitData() {
            console.log("href:" + location.href);
            console.log("router" + stringify_default()(this.$route.query));
            var _$route$query = this.$route.query,
                _$route$query$waybill = _$route$query.waybillNo,
                waybillNo = _$route$query$waybill === undefined ? "" : _$route$query$waybill,
                _$route$query$nodeCod = _$route$query.nodeCode,
                nodeCode = _$route$query$nodeCod === undefined ? "" : _$route$query$nodeCod,
                _$route$query$platfor = _$route$query.platform,
                platform = _$route$query$platfor === undefined ? "" : _$route$query$platfor,
                _$route$query$source = _$route$query.source,
                source = _$route$query$source === undefined ? "" : _$route$query$source,
                _$route$query$openid = _$route$query.openid,
                openid = _$route$query$openid === undefined ? "" : _$route$query$openid,
                _$route$query$userid = _$route$query.userid,
                userid = _$route$query$userid === undefined ? "" : _$route$query$userid;

            this.waybillNo = waybillNo;
            this.siteCode = nodeCode;

            platform = common.isEmpty(platform) ? window.localStorage.getItem("platform") || "site" : platform;
            source = common.isEmpty(source) ? window.localStorage.getItem("source") || "" : source;
            userid = common.isEmpty(userid) ? window.localStorage.getItem("userid") || "" : userid;
            if (common.isEmpty(openid)) {
                openid = window.localStorage.getItem("openid") || common.getOpenId();
            }
            window.localStorage.setItem("platform", platform); //平台
            window.localStorage.setItem("openid", openid); //客户标志
            window.localStorage.setItem("source", source); //数据来源
            window.localStorage.setItem("userid", userid); //用户id
            this.sessionInfo = {
                openid: openid || '',
                source: source || '',
                platform: platform || '',
                userid: userid || ''
            };
        },


        // 初始查询状态;
        getInitStatus: function getInitStatus() {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var res;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return service_getStatus(_this.sessionInfo || {});

                            case 2:
                                res = _context.sent;

                                if (res && res.status == 0) {
                                    _this.currentType = res.data.stage;
                                    _this.subId = res.data.subId;
                                    if (_this.currentType === "survey") {
                                        // 打开会话
                                        _this.closeSession('init');
                                    } else if (_this.currentType === "wait") {
                                        // 等待中直接改成服务中，拉取消息
                                        _this.currentType = "service";
                                    }

                                    // 服务中的才获取历史消息
                                    if (_this.currentType === "service") {
                                        _this.getMessageList();
                                        // 拉取人工消息
                                        if (!views_xiaoI_chat_timer) {
                                            views_xiaoI_chat_timer = setInterval(_this.getManualMessage, 2000);
                                        }
                                    }
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 初始查询链接;
        initLink: function initLink() {
            var _this2 = this;

            var data = {
                platform: "wechat"
            };
            service_getLink(data).then(function (res) {
                if (res.data && Array.isArray(res.data.items)) {
                    _this2.selectBox = res.data.items;
                }
                // 快捷操作
                if (res.data.quickReplyTerms) {
                    _this2.quickItems = res.data.quickReplyTerms.split(";");
                }
            });
        },


        // 跳转其他页面
        goOtherLink: function goOtherLink(url, icon) {
            var filterObj = {
                yuyue: "order",
                chajian: "track",
                wangdian: "site",
                yunfei: "freight"
            };
            this.fastTrackCount(filterObj[icon], function () {
                location.href = url;
            });
        },


        // 获取xiaoI问题链接
        getXiaoILinks: function getXiaoILinks(str) {
            var reg = /\[link.*?\](.*?)\[\/link\]/gi;
            var result = reg.exec(str);
            if (result) {
                var link = result[1].replace(/【(.*)】/, "");
                chat_xiaoIProblemLinks.push(link);
                var newStr = str.substr(result.index + result.length);
                this.getXiaoILinks(newStr);
            } else {
                return;
            }
        },


        // 处理问题
        resolveProblem: function resolveProblem(index, message) {
            this.msgReBox[index].resolve = message;
            this.sendMsg(message, "RESOLVE");
        },


        // 发送消息;
        sendMsg: function sendMsg(message, type) {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var newMessage, _ibox, _ibox2;

                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this3.inputValue === "" && !message && !_this3.isImg)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return", false);

                            case 2:
                                if (!(_this3.inputValue.length >= 350)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _this3.$vux.toast.text("", "bottom");
                                return _context2.abrupt("return");

                            case 5:
                                // xiaoI解决问题
                                newMessage = message;

                                if (type === "RESOLVE") {
                                    if (message === "a") {
                                        newMessage = "已解决";
                                    } else {
                                        newMessage = "未解决";
                                    }
                                }
                                // 非图片类型

                                if (_this3.isImg) {
                                    _context2.next = 20;
                                    break;
                                }

                                _ibox = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: common.formatMsg(message ? newMessage : _this3.inputValue)
                                };

                                _this3.msgReBox.push(_ibox);

                                if (!(_this3.currentType === "auto")) {
                                    _context2.next = 15;
                                    break;
                                }

                                _context2.next = 13;
                                return _this3.sendXiaoI(message, type);

                            case 13:
                                _context2.next = 18;
                                break;

                            case 15:
                                if (!(_this3.currentType === "service")) {
                                    _context2.next = 18;
                                    break;
                                }

                                _context2.next = 18;
                                return _this3.sendManual(message);

                            case 18:
                                _context2.next = 23;
                                break;

                            case 20:
                                //图片1
                                _ibox2 = {
                                    type: 1,
                                    imgUrl: message,
                                    msgContent: "<img src=\"" + message + "\" style=\"max-width: 220px; display: block;\"/>"
                                };

                                _this3.msgReBox.push(_ibox2);
                                _this3.isImg = false;

                            case 23:
                                // 清空输入框
                                _this3.inputValue = "";
                                // 滚动到底部
                                _this3.scrollToBottom();

                            case 25:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },


        // 获取xiaoI开头语
        getBeginChat: function getBeginChat() {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var params, res;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                params = {
                                    action: "BEGINCHAT",
                                    platform: "weixin", // xiaoI需要写死微信
                                    userId: ":task:" + _this4.sessionInfo.openid
                                };
                                _context3.next = 3;
                                return service_xiaoChat(params);

                            case 3:
                                res = _context3.sent;

                                _this4.msgBox.push(_this4.converXiaoIMessage(res.data.content, res.data.type, true));

                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },


        // 发送xiaoI消息
        sendXiaoI: function sendXiaoI(message) {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                var params, res;
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                params = {
                                    action: "CHATING",
                                    question: message ? message : _this5.inputValue,
                                    platform: _this5.sessionInfo.platform, // xiaoI需要写死微信
                                    userId: ":task:" + _this5.sessionInfo.openid
                                };
                                // 调用xiaoI

                                _context4.next = 3;
                                return service_xiaoChat(params);

                            case 3:
                                res = _context4.sent;

                                _this5.msgReBox.push(_this5.converXiaoIMessage(res.data.content, res.data.type));

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        converXiaoIMessage: function converXiaoIMessage(msgContent, type, isBegin) {
            var msg = {
                type: 0,
                content: "",
                contentType: type,
                msgContent: ""
            };
            // 转人工
            if (msgContent.indexOf("ACS") > -1) {
                msg.contentType = "ACS";
                // 埋点-客户追踪
                this.trackManual();
            } else if (msgContent.indexOf("您可能还关注下列问题") > -1 || msgContent.indexOf("以上答案是否解决了您的问题") > -1) {
                var contentIndex = msgContent.indexOf("您可能还关注下列问题");
                chat_xiaoIProblemLinks = [];
                if (contentIndex > -1) {
                    var content = msgContent.substring(0, contentIndex).replace(/\n/, "");
                    msg.content = common.convertMsg(content);
                    this.getXiaoILinks(msgContent);
                } else {
                    contentIndex = msgContent.indexOf("以上答案是否解决了您的问题");
                    var _content = msgContent.substring(0, contentIndex);
                    msg.content = common.convertMsg(_content);
                }
                msg.contentType = "ANSWER";
                if (!isBegin) {
                    msg.links = chat_xiaoIProblemLinks;
                } else {
                    this.hotQuestions = chat_xiaoIProblemLinks;
                }
            } else {
                msg.msgContent = common.convertMsg(msgContent);
            }
            return msg;
        },


        // 发送人工消息
        sendManual: function sendManual(message) {
            var _this6 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                var res, msgBox;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return service_postMessage(extends_default()({
                                    content: message || _this6.inputValue
                                }, _this6.sessionInfo, {
                                    subId: _this6.subId,
                                    msgId: _this6.msgId,
                                    type: "text"
                                }));

                            case 2:
                                res = _context5.sent;

                                if (!views_xiaoI_chat_timer) {
                                    views_xiaoI_chat_timer = setInterval(_this6.getManualMessage, 2000);
                                }
                                // 如果人工消息是等待中的话，需要返回消息
                                if (res.status === 0) {
                                    if (res.data.stage === "auto") {
                                        // 关闭定时器
                                        if (views_xiaoI_chat_timer) {
                                            clearInterval(views_xiaoI_chat_timer), views_xiaoI_chat_timer = null;
                                        }
                                        _this6.currentType = "auto";
                                    }

                                    // 有人工消息直接展示在页面上
                                    if (res.data.content) {
                                        msgBox = {
                                            type: 0,
                                            msgContent: res.data.content
                                        };

                                        _this6.msgReBox.push(msgBox);
                                        _this6.scrollToBottom();
                                    }
                                }

                            case 5:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },


        // 获取人工消息
        getManualMessage: function getManualMessage() {
            var _this7 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                var result, msg, pmsg, _ibox3;

                return regenerator_default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return service_pullMessage(extends_default()({}, _this7.sessionInfo, {
                                    subId: _this7.subId,
                                    msgId: _this7.msgId,
                                    attr: 'pull-message'
                                }));

                            case 2:
                                result = _context6.sent;
                                msg = {
                                    type: 0,
                                    imgUrl: ""
                                };

                                if (!(result.status === 0)) {
                                    _context6.next = 17;
                                    break;
                                }

                                if (!(result.data != null)) {
                                    _context6.next = 15;
                                    break;
                                }

                                pmsg = result.data;
                                // 会话自动关闭

                                if (!(pmsg.category === "sys_ssncls")) {
                                    _context6.next = 13;
                                    break;
                                }

                                // 客服关闭会话
                                _this7.currentType = "auto";
                                _this7.closeSession();
                                return _context6.abrupt("return");

                            case 13:
                                _this7.msgId = result.data.msgId;
                                if (result.data != null && result.data.type === "text") {
                                    msg.msgContent = common.convertMsg(result.data.text.content);
                                    _this7.msgReBox.push(msg);
                                    _this7.scrollToBottom();
                                } else if (result.data != null && result.data.type === "image") {
                                    _this7.imgUrl = "data:image/png;base64," + result.data.image.pic_url;
                                    _ibox3 = {
                                        type: 0,
                                        imgUrl: _this7.imgUrl,
                                        msgContent: "<img src=\"" + _this7.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                    };

                                    _this7.msgReBox.push(_ibox3);
                                    _this7.scrollToBottom();
                                }

                            case 15:
                                _context6.next = 18;
                                break;

                            case 17:
                                console.log("拉取会话失败！");

                            case 18:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },


        // 获取历史消息
        getMessageList: function getMessageList() {
            var _this8 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                var msg, msgs, i, lastMsgId, date, _msg, type, _ibox4, _msg2;

                return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return service_getHistory(extends_default()({
                                    subId: _this8.subId
                                }, _this8.sessionInfo));

                            case 2:
                                msg = _context7.sent;

                                if (msg !== null && msg.status === 0) {
                                    msgs = msg.data.items;

                                    if (msgs.length > 0) {
                                        _this8.isHistory = true;
                                        for (i = 0; i < msgs.length; i++) {
                                            if (msgs[i].msgId != 0) {
                                                lastMsgId = msgs[i].msgId;

                                                _this8.msgId = lastMsgId || 0;
                                            }
                                            if (msgs[i].sendAt != null && msgs[i].sendAt != "") {
                                                date = new Date(msgs[i].sendAt);

                                                _this8.lastTime = formatDate(date, "MM月dd日 hh:mm"); //最后之间
                                            }
                                            if (msgs[i].category === "sys_ssncls") {
                                                // 会话关闭
                                                // this.closeSession()
                                            } else {
                                                if (msgs[i].type === "text") {
                                                    _msg = {
                                                        type: 0,
                                                        imgUrl: "",
                                                        msgContent: common.convertMsg(msgs[i].msgBody.content)
                                                    };

                                                    if (msgs[i].category === "manreq") {
                                                        _msg.type = 1;
                                                    }
                                                    _this8.msgReBox.push(_msg);
                                                } else if (msgs[i].type === "image") {
                                                    type = 0;

                                                    if (msgs[i].category === "manreq") {
                                                        type = 1;
                                                    }
                                                    _this8.imgUrl = "data:image/png;base64," + msgs[i].msgBody.pic_url;
                                                    _ibox4 = {
                                                        type: type,
                                                        imgUrl: _this8.imgUrl,
                                                        msgContent: "<img src=\"" + _this8.imgUrl + "\" style=\"max-width: 220px; display: block;\"/>"
                                                    };

                                                    _this8.msgReBox.push(_ibox4);
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    _msg2 = {
                                        type: 0,
                                        imgUrl: "",
                                        msgContent: common.convertMsg(_msg2.message)
                                    };

                                    _this8.msgBox.push(ibox);
                                }
                                _this8.scrollToBottom();

                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this8);
            }))();
        },


        // 查看图片
        imgClick: function imgClick(data) {
            var _this9 = this;

            if (data === "") {
                return false;
            }
            this.imgUrl = data;
            this.$nextTick(function () {
                _this9.$refs.picShowDialog.open({
                    type: "pic"
                });
            });
        },


        // 隐藏预览图片
        hideImage: function hideImage() {
            var _this10 = this;

            this.$nextTick(function () {
                _this10.$refs.picShowDialog.close();
            });
        },


        // 选择订单号
        chooseWaybill: function chooseWaybill(waybillNo) {
            this.handleWaybillNo = waybillNo;
            this.getAuth("waybillNo");
        },


        // 获取权限
        getAuth: function getAuth(type) {
            var _this11 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                var res, msgBox, _ibox5, _msgBox;

                return regenerator_default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return service_authSession(extends_default()({}, _this11.sessionInfo, {
                                    mobile: type === "mobile" ? _this11.phoneNumber : "",
                                    waybillNo: type === "waybillNo" ? _this11.handleWaybillNo : "",
                                    orderNo: type === "orderNo" ? _this11.handleorderNo : "",
                                    siteCode: type === "siteCode" ? _this11.siteCode : ""
                                }));

                            case 2:
                                res = _context8.sent;

                                if (!(res.status === 0)) {
                                    _context8.next = 19;
                                    break;
                                }

                                if (!(res.data && res.data.stage === 'offline')) {
                                    _context8.next = 9;
                                    break;
                                }

                                msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this11.msgReBox.push(msgBox);
                                _this11.scrollToBottom();
                                return _context8.abrupt("return");

                            case 9:
                                _this11.subId = res.data.subId;
                                _this11.currentType = "service";
                                // 重置messageId
                                _this11.msgId = 0;

                                // 开启定时
                                if (!views_xiaoI_chat_timer) {
                                    views_xiaoI_chat_timer = setInterval(_this11.getManualMessage, 2000);
                                }
                                // 页面显示消息

                                if (!(type == "siteCode")) {
                                    _context8.next = 15;
                                    break;
                                }

                                return _context8.abrupt("return");

                            case 15:
                                _ibox5 = {
                                    type: 1,
                                    imgUrl: "",
                                    msgContent: type === "mobile" ? _this11.phoneNumber : type === "waybillNo" ? _this11.handleWaybillNo : _this11.handleorderNo
                                };

                                _this11.msgReBox.push(_ibox5);
                                _context8.next = 21;
                                break;

                            case 19:
                                _msgBox = {
                                    type: 0,
                                    msgContent: res.message
                                };

                                _this11.msgReBox.push(_msgBox);

                            case 21:
                                _this11.scrollToBottom();

                            case 22:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this11);
            }))();
        },


        // 人工客服点击追踪-埋点
        trackManual: function trackManual() {
            var _this12 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                var result;
                return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return service_trackManual();

                            case 2:
                                result = _context9.sent;

                            case 3:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this12);
            }))();
        },


        // 快速通道计数
        fastTrackCount: function fastTrackCount(type, cb) {
            var _this13 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
                var result;
                return regenerator_default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return service_fastTrackEntranceCount(extends_default()({}, _this13.sessionInfo, {
                                    type: type
                                }));

                            case 2:
                                result = _context10.sent;

                                cb && cb();

                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this13);
            }))();
        },


        // 打开查询订单
        goWayBillNo: function goWayBillNo() {
            var _this14 = this;

            if (this.currentType === 'service') {
                return;
            }
            // 微信小程序才打开运单列表
            if (this.sessionInfo.userid) {
                this.$nextTick(function () {
                    _this14.$refs["chooseWaybillNo"].open({
                        type: "bottom"
                    });
                });
            } else {
                this.searchWaybillNo();
            }
        },
        onOpenChooseWaybill: function onOpenChooseWaybill() {
            var _this15 = this;

            this.$nextTick(function () {
                _this15.$refs["com-choose-waybill"].init();
            });
        },

        // 关闭查询订单
        closeChooseWaybill: function closeChooseWaybill() {
            var _this16 = this;

            this.$nextTick(function () {
                _this16.$refs["chooseWaybillNo"].close();
            });
        },

        // 关闭订单列表-打开查询订单
        goSetOrder: function goSetOrder() {
            this.closeChooseWaybill();
            this.searchWaybillNo();
        },


        // 校验手机号
        toValidPhone: function toValidPhone(e) {
            var value = e.target.value;
            var reg = constant.mobileRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validPhone = "请输入正确的手机号";
                } else {
                    this.validPhone = "";
                }
            }
        },


        // 校验运单号
        toValidWaybillNo: function toValidWaybillNo(e) {
            var value = e.target.value;
            var reg = constant.waybillNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validWaybillNo = "请输入正确的运单号";
                } else {
                    this.validWaybillNo = "";
                }
            }
        },


        // 校验国际订单号
        toValidorderNo: function toValidorderNo(e) {
            var value = e.target.value;
            var reg = constant.orderNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validorderNo = "请输入正确的国际订单号";
                } else {
                    this.validorderNo = "";
                }
            }
        },


        // 查询手机号
        goPhone: function goPhone() {
            var _this17 = this;

            // 服务中不能点击
            if (this.currentType === 'service') {
                return;
            }
            this.phoneNumber = "";
            this.validPhone = "";
            this.$refs["setPhoneDialog"].open({
                title: "请输入手机号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.mobileRegular();
                    if (reg.test(_this17.phoneNumber)) {
                        _this17.getAuth("mobile");
                        close && close();
                        _this17.validPhone = "";
                    } else {
                        _this17.validPhone = "请输入正确的手机号";
                    }
                }
            });
        },
        changeRadio: function changeRadio() {
            if (this.enterType == 0) {
                this.disabledone = false;
                this.disabledtwo = true;
                this.handleorderNo = "";
                this.validorderNo = "";
            }
            if (this.enterType == 1) {
                this.disabledone = true;
                this.disabledtwo = false;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
            }
            if (this.enterType == 2) {
                this.disabledone = true;
                this.disabledtwo = true;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
                this.handleorderNo = "";
                this.validorderNo = "";
            }
        },

        // 查询国际订单号
        goorderNo: function goorderNo() {
            var _this18 = this;

            if (this.currentType === 'service') {
                return;
            }
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.handleorderNo = "";
            this.validorderNo = "";
            this.$refs["setorderNo"].open({
                title: "请选择进入方式",
                type: "confirm",
                confirm: function confirm(close) {
                    console.log('enterType-->', _this18.enterType);
                    if (_this18.enterType == 0) {
                        var reg = constant.waybillNoRegular();
                        if (reg.test(_this18.handleWaybillNo)) {
                            _this18.getAuth("waybillNo");
                            _this18.validWaybillNo = "";
                            close && close();
                        } else {
                            _this18.validWaybillNo = "请输入正确的运单号";
                        }
                    }
                    if (_this18.enterType == 1) {
                        var _reg = constant.orderNoRegular();
                        if (_reg.test(_this18.handleorderNo)) {
                            _this18.getAuth("orderNo");
                            _this18.validorderNo = "";
                            close && close();
                        } else {
                            _this18.validorderNo = "请输入正确的国际订单号";
                        }
                    }
                    if (_this18.enterType == 2) {
                        _this18.siteCode = "999995";
                        _this18.getAuth("siteCode");
                        close && close();
                    }
                }
            });
        },

        // 查询运单号
        searchWaybillNo: function searchWaybillNo() {
            var _this19 = this;

            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.$refs["setWaybillNo"].open({
                title: "请输入单号",
                type: "confirm",
                confirm: function confirm(close) {
                    var reg = constant.waybillNoRegular();
                    if (reg.test(_this19.handleWaybillNo)) {
                        _this19.getAuth("waybillNo");
                        _this19.validWaybillNo = "";
                        close && close();
                    } else {
                        _this19.validWaybillNo = "请输入正确的运单号";
                    }
                }
            });
        },

        // 滚动到底部
        scrollToBottom: function scrollToBottom() {
            var _this20 = this;

            this.$nextTick(function () {
                var innerBox = _this20.$refs.xwBody;
                console.log("start:" + innerBox.scrollTop);
                if (innerBox.scrollHeight > innerBox.clientHeight) {
                    Object(main["setTimeout"])(function () {
                        //设置滚动条到最底部
                        innerBox.scrollTop = innerBox.scrollHeight;
                        innerBox.style.opacity = 1;
                        console.log("end:" + innerBox.scrollTop);
                    }, 50);
                }
            });
        },


        // 关闭会话
        closeSession: function closeSession(type) {
            var _this21 = this;

            this.$nextTick(function () {
                _this21.$refs["rateDialog"].open({
                    title: "服务评价",
                    type: "confirm",
                    confirm: function confirm(close) {
                        service_closeSession(extends_default()({}, _this21.sessionInfo, {
                            survey: _this21.rate
                        })).then(function (res) {
                            if (res.status === 0) {
                                // this.$vux.toast.text('评价成功', 'bottom');
                                // 关闭人工消息
                                var _ibox6 = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent: "亲，谢谢您的肯定，祝您生活愉快！"
                                };
                                _this21.msgReBox.push(_ibox6);
                                _this21.scrollToBottom();
                                _this21.currentType = "auto";
                                if (views_xiaoI_chat_timer) {
                                    clearInterval(views_xiaoI_chat_timer);
                                    views_xiaoI_chat_timer = null;
                                }
                                close && close();
                            } else {
                                _this21.$vux.toast.text(res.message, "bottom");
                            }
                        });
                    },
                    cancel: function cancel(close) {
                        // 如果当前是初始化状态，获取的评价调查状态
                        // 当用户点击取消的时候，需要调用关闭评价状态-默认给5星，并改成xiaoI会话状态
                        if (type === 'init') {
                            service_closeSession(extends_default()({}, _this21.sessionInfo, {
                                survey: 5
                            }));
                            _this21.currentType = 'auto';
                        }
                        close && close();
                    }
                });
            });
        },

        // 上传图片
        upload: function upload(e) {
            if (!this.currentType === "auto") {
                this.$vux.toast.text("机器人模式不能发送图片消息！", "bottom");
                return;
            }
            var files = e.target.files || e.dataTransfer.files;
            if (!(files[0].type === "image/png" || files[0].type === "image/jpeg")) {
                this.$vux.toast.text("亲，只支持图片上传！", "bottom");
                return;
            }
            if (files.length < 1) {
                this.$vux.toast.text("请寻找需要上传的图片！", "bottom");
                return;
            }
            this.isImg = true;
            this.imgPreview(files[0]);
        },
        imgPreview: function imgPreview(file) {
            var self = this;
            var Orientation = 0;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // EXIF.getData(file, function(){
            //     Orientation=EXIF.getTag(this, 'Orientation');
            // });
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/^image/.test(file.type)) {
                // 创建一个reader
                var reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                    var result, img, senddata, config;
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                        while (1) {
                            switch (_context14.prev = _context14.next) {
                                case 0:
                                    result = this.result;

                                    if (result !== "null" && result !== null) {
                                        img = new Image();

                                        img.src = result;
                                        senddata = extends_default()({}, self.sessionInfo, {
                                            type: "image"
                                        });
                                        config = {
                                            headers: { "Content-Type": "application/json" }
                                        };
                                        //判断图片是否大于1M,是就直接上传，反s之压缩图片2

                                        if (this.result.length <= 1024 * 1024) {
                                            Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                                                var data, index, res;
                                                return regenerator_default.a.wrap(function _callee11$(_context11) {
                                                    while (1) {
                                                        switch (_context11.prev = _context11.next) {
                                                            case 0:
                                                                data = self.compress(img, Orientation);
                                                                index = data.indexOf("base64") + 7;

                                                                senddata.imgData = data.substr(index);
                                                                _context11.next = 5;
                                                                return service_postMessage(senddata);

                                                            case 5:
                                                                res = _context11.sent;

                                                                if (!(res.status === 0)) {
                                                                    _context11.next = 11;
                                                                    break;
                                                                }

                                                                self.sendMsg(data);
                                                                return _context11.abrupt("return");

                                                            case 11:
                                                                self.showPositionValue = true;
                                                                self.toastText = "上传图片失败";
                                                                return _context11.abrupt("return");

                                                            case 14:
                                                            case "end":
                                                                return _context11.stop();
                                                        }
                                                    }
                                                }, _callee11, this);
                                            })), 500);
                                        } else {
                                            img.onload = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                                                return regenerator_default.a.wrap(function _callee13$(_context13) {
                                                    while (1) {
                                                        switch (_context13.prev = _context13.next) {
                                                            case 0:
                                                                Object(main["setTimeout"])(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                                                                    var data, index, res;
                                                                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                                                                        while (1) {
                                                                            switch (_context12.prev = _context12.next) {
                                                                                case 0:
                                                                                    data = self.compress(img, Orientation);
                                                                                    index = data.indexOf("base64") + 7;

                                                                                    senddata.imgData = data.substr(index);
                                                                                    _context12.next = 5;
                                                                                    return service_postMessage(senddata);

                                                                                case 5:
                                                                                    res = _context12.sent;

                                                                                    if (!(res.status === 0)) {
                                                                                        _context12.next = 11;
                                                                                        break;
                                                                                    }

                                                                                    self.sendMsg(data);
                                                                                    return _context12.abrupt("return");

                                                                                case 11:
                                                                                    self.showPositionValue = true;
                                                                                    self.toastText = "上传图片失败";
                                                                                    return _context12.abrupt("return");

                                                                                case 14:
                                                                                case "end":
                                                                                    return _context12.stop();
                                                                            }
                                                                        }
                                                                    }, _callee12, this);
                                                                })), 500);

                                                            case 1:
                                                            case "end":
                                                                return _context13.stop();
                                                        }
                                                    }
                                                }, _callee13, this);
                                            }));
                                        }
                                    }

                                case 2:
                                case "end":
                                    return _context14.stop();
                            }
                        }
                    }, _callee14, this);
                }));
            }
        },
        rotateImg: function rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            var min_step = 0;
            var max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            var height = img.height;
            var width = img.width;
            var step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == "right") {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            var degree = step * 90 * Math.PI / 180;
            var ctx = canvas.getContext("2d");
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress: function compress(img, Orientation) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            //瓦片canvas
            var tCanvas = document.createElement("canvas");
            var tctx = tCanvas.getContext("2d");
            var initSize = img.src.length;
            var width = img.width;
            var height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            var ratio = void 0;
            if ((ratio = width * height / 4000000) > 1) {
                /* console.log("大于400万像素")*/
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //        铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            var count = void 0;
            if ((count = width * height / 1000000) > 1) {
                /*   console.log("超过100W像素");*/
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                //            计算每块瓦片的宽和高
                var nw = ~~(width / count);
                var nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (var i = 0; i < count; i++) {
                    for (var j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6:
                        //需要顺时针（向左）90度旋转
                        this.rotateImg(img, "left", canvas);
                        break;
                    case 8:
                        //需要逆时针（向右）90度旋转
                        this.rotateImg(img, "right", canvas);
                        break;
                    case 3:
                        //需要180度旋转
                        this.rotateImg(img, "right", canvas); //转两次
                        this.rotateImg(img, "right", canvas);
                        break;
                }
            }
            //进行最小压缩
            var ndata = canvas.toDataURL("image/jpeg", 0.4);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata;
        },

        // 改变评价
        changeRate: function changeRate(value) {
            this.rate = value;
        }
    },
    destroyed: function destroyed() {
        // 关闭定时器
        if (views_xiaoI_chat_timer) {
            clearInterval(views_xiaoI_chat_timer), views_xiaoI_chat_timer = null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75591fb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xiaoI/chat.vue
var xiaoI_chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chatBox",staticClass:"chatBox"},[_c('div',{ref:"xwBody",staticClass:"msgBox"},[_c('div',{ref:"testBox",staticStyle:{"margin":"0 auto","width":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHistory),expression:"isHistory"}],staticClass:"timeShowWrap"},[_c('p',{staticClass:"timeShow"},[_vm._v("\n                    "+_vm._s(new Date().toLocaleTimeString())+"\n                ")])]),_vm._v(" "),_vm._l((_vm.msgBox),function(item,index){return _c('div',{key:index,class:['msglist', item.type === 0 ? '' : 'self']},[_c('div',{staticClass:"userImg"},[(item.type === 0)?_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("MEgf")}}):_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("fHXO")}})]),_vm._v(" "),(item.contentType === 'ANSWER')?_c('div',{staticClass:"msgInfo msg-answer"},[_c('div',{staticClass:"msg-content",domProps:{"innerHTML":_vm._s(item.content)}}),_vm._v(" "),(item.links && item.links.length > 0)?_c('div',{staticClass:"links-container"},_vm._l((item.links),function(link,index){return _c('div',{key:index,staticClass:"link-item",on:{"click":function () { return _vm.sendMsg(link); }}},[_vm._v("\n                            "+_vm._s(link)+"\n                        ")])}),0):_vm._e()]):_c('div',{staticClass:"msgInfo",domProps:{"innerHTML":_vm._s(item.msgContent)},on:{"click":function($event){return _vm.imgClick(item.imgUrl)}}},[_vm._v("\n                    "+_vm._s(item.msgContent)+"\n                ")])])})],2),_vm._v(" "),_c('div',{staticClass:"hot-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-right"},[_c('ul',_vm._l((_vm.hotQuestions),function(item,index){return _c('li',{key:index,on:{"click":function () { return _vm.sendMsg(item); }}},[_vm._v("\n                        "+_vm._s(item)+"\n                    ")])}),0)])]),_vm._v(" "),(_vm.selectBox.length > 0)?_c('div',{staticClass:"select-box"},_vm._l((_vm.selectBox),function(item,index){return _c('span',{key:index,staticClass:"box-item",on:{"click":function () { return _vm.goOtherLink(item.url, item.icon); }}},[_c('img',{class:index === 2 ? 'adjust' : '',attrs:{"src":("static/img/chat/icon-" + (item.icon) + ".png"),"alt":item.name}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-5px"}},[_vm._v(_vm._s(item.name))])])}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.msgReBox),function(item,index){return _c('div',{key:index,class:['msglist', item.type === 0 ? '' : 'self']},[_c('div',{staticClass:"userImg"},[(item.type === 0)?_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("MEgf")}}):_c('img',{staticClass:"userImg",attrs:{"src":__webpack_require__("fHXO")}})]),_vm._v(" "),(item.contentType === 'ANSWER')?_c('div',{staticClass:"msgInfo msg-answer"},[_c('div',{staticClass:"msg-content",domProps:{"innerHTML":_vm._s(item.content)}}),_vm._v(" "),(item.links && item.links.length > 0)?_c('div',{staticClass:"links-container"},_vm._l((item.links),function(link,index){return _c('div',{key:index,staticClass:"link-item",on:{"click":function () { return _vm.sendMsg(link); }}},[_vm._v("\n                        "+_vm._s(link)+"\n                    ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn",class:item.resolve === 'a'
                                    ? 'btn-outline'
                                    : 'btn-default',on:{"click":function($event){return _vm.resolveProblem(index, 'a')}}},[_vm._v("\n                        已解决\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:item.resolve === 'b'
                                    ? 'btn-outline'
                                    : 'btn-default',on:{"click":function($event){return _vm.resolveProblem(index, 'b')}}},[_vm._v("\n                        未解决\n                    ")])])]):(item.contentType === 'ACS')?_c('div',{staticClass:"msgInfo msg-answer msg-acs"},[_c('div',{staticClass:"link-item acs-item",class:{'disabled': _vm.currentType === 'service'},on:{"click":_vm.goWayBillNo}},[_vm._v("\n                    1、境内运单号进入\n                ")]),_vm._v(" "),_c('div',{staticClass:"link-item acs-item",class:{'disabled': _vm.currentType === 'service'},on:{"click":_vm.goorderNo}},[_vm._v("\n                    2、国际及港澳台业务咨询\n                ")])]):_c('div',{staticClass:"msgInfo",domProps:{"innerHTML":_vm._s(item.msgContent)},on:{"click":function($event){return _vm.imgClick(item.imgUrl)}}},[_vm._v("\n                "+_vm._s(item.msgContent)+"\n            ")])])})],2),_vm._v(" "),_c('div',{staticClass:"quick-select"},_vm._l((_vm.quickItems),function(item,index){return _c('div',{key:index,staticClass:"quick-item",on:{"click":function () { return _vm.sendMsg(item); }}},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0),_vm._v(" "),_c('div',{ref:"chatFooter",staticClass:"chatFooter"},[_c('div',{staticClass:"sendBox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentType === 'service'),expression:"currentType === 'service'"}],staticClass:"iconBox"},[_c('i',{staticClass:"iIcon imgbtn"},[_c('input',{ref:"upload",staticStyle:{"width":"22px","height":"22px","opacity":"0"},attrs:{"type":"file","accept":"image/gif,image/jpeg,image/jpg,image/png,image/svg"},on:{"change":_vm.upload}})]),_vm._v(" "),_c('span',{staticClass:"closeBtn",on:{"click":_vm.closeSession}},[_vm._v("结束对话")])]),_vm._v(" "),_c('div',{staticClass:"inputBox"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],staticClass:"text-input",attrs:{"placeholder":"请输入内容","id":"text-input","max":"30","rows":"1"},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"sendBtn",class:_vm.inputValue.length > 0 ? 'active' : '',on:{"click":function () { return _vm.sendMsg(); }}},[_vm._v("\n                    发送\n                ")])])])]),_vm._v(" "),_c('yto-modal',{ref:"rateDialog"},[_c('yto-rate',{attrs:{"value":_vm.rate},on:{"change":_vm.changeRate}})],1),_vm._v(" "),_c('yto-modal',{ref:"chooseWaybillNo",on:{"open":_vm.onOpenChooseWaybill}},[_c('waybillnos-list',{ref:"com-choose-waybill",on:{"close":_vm.closeChooseWaybill,"sendMessage":_vm.chooseWaybill,"goSetOrder":_vm.goSetOrder}})],1),_vm._v(" "),_c('yto-modal',{ref:"setWaybillNo"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_vm._v("单号:")]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleWaybillNo),expression:"handleWaybillNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.handleWaybillNo)},on:{"change":_vm.toValidWaybillNo,"input":function($event){if($event.target.composing){ return; }_vm.handleWaybillNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validWaybillNo))])])])]),_vm._v(" "),_c('yto-modal',{ref:"setPhoneDialog"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_vm._v("手机号:")]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-value",attrs:{"placeholder":"请输入","type":"number","pattern":"\\d*"},domProps:{"value":(_vm.phoneNumber)},on:{"change":_vm.toValidPhone,"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validPhone))])])])]),_vm._v(" "),_c('yto-modal',{ref:"setorderNo"},[_c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labelone"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labelone","value":"0"},domProps:{"checked":_vm._q(_vm.enterType,"0")},on:{"change":[function($event){_vm.enterType="0"},_vm.changeRadio]}}),_vm._v("\n                运单号")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleWaybillNo),expression:"handleWaybillNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入","disabled":_vm.disabledone},domProps:{"value":(_vm.handleWaybillNo)},on:{"change":_vm.toValidWaybillNo,"input":function($event){if($event.target.composing){ return; }_vm.handleWaybillNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validWaybillNo))])])]),_vm._v(" "),_c('div',{staticClass:"form-item te-form"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labeltwo"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labeltwo","value":"1"},domProps:{"checked":_vm._q(_vm.enterType,"1")},on:{"change":[function($event){_vm.enterType="1"},_vm.changeRadio]}}),_vm._v("\n                订单号")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handleorderNo),expression:"handleorderNo"}],staticClass:"form-value",attrs:{"placeholder":"请输入","disabled":_vm.disabledtwo},domProps:{"value":(_vm.handleorderNo)},on:{"change":_vm.toValidorderNo,"input":function($event){if($event.target.composing){ return; }_vm.handleorderNo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"valid-message"},[_vm._v(_vm._s(_vm.validorderNo))])])]),_vm._v(" "),_c('div',{staticClass:"form-item te-item"},[_c('div',{staticClass:"form-label"},[_c('label',{attrs:{"for":"labelthree"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enterType),expression:"enterType"}],staticClass:"radio-item",attrs:{"name":"Radio","type":"radio","id":"labelthree","value":"2"},domProps:{"checked":_vm._q(_vm.enterType,"2")},on:{"change":[function($event){_vm.enterType="2"},_vm.changeRadio]}}),_vm._v("\n                转运业务咨询")])]),_vm._v(" "),_c('div',{staticClass:"form-value-container container-te"})])]),_vm._v(" "),_c('yto-modal',{ref:"picShowDialog"},[_c('img',{staticClass:"image-show",attrs:{"src":_vm.imgUrl},on:{"click":_vm.hideImage}})])],1)}
var xiaoI_chat_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-left"},[_c('div',{staticClass:"left-top"},[_c('img',{attrs:{"src":__webpack_require__("4KD4"),"alt":""}})])])}]
var xiaoI_chat_esExports = { render: xiaoI_chat_render, staticRenderFns: xiaoI_chat_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_xiaoI_chat = (xiaoI_chat_esExports);
// CONCATENATED MODULE: ./src/views/xiaoI/chat.vue
function xiaoI_chat_injectStyle (ssrContext) {
  __webpack_require__("j4ie")
}
var xiaoI_chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var xiaoI_chat___vue_template_functional__ = false
/* styles */
var xiaoI_chat___vue_styles__ = xiaoI_chat_injectStyle
/* scopeId */
var xiaoI_chat___vue_scopeId__ = "data-v-75591fb8"
/* moduleIdentifier (server only) */
var xiaoI_chat___vue_module_identifier__ = null
var xiaoI_chat_Component = xiaoI_chat_normalizeComponent(
  views_xiaoI_chat,
  selectortype_template_index_0_src_views_xiaoI_chat,
  xiaoI_chat___vue_template_functional__,
  xiaoI_chat___vue_styles__,
  xiaoI_chat___vue_scopeId__,
  xiaoI_chat___vue_module_identifier__
)

/* harmony default export */ var src_views_xiaoI_chat = (xiaoI_chat_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





/* eslint-disable */

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: src_views_chat_chat,
    meta: { keepalive: true }
  }, {
    path: '/chatIndex',
    name: 'chatIndex',
    component: src_views_index,
    meta: { keepalive: true }
  }, {
    path: '/newChat',
    name: 'newChat',
    component: src_views_chat_chat,
    meta: { keepalive: true }
  }, {
    path: '/xiaoI',
    name: 'xiaoI',
    component: src_views_xiaoI_chat,
    meta: { keepalive: true }
  }]
});

// router.beforeEach((to, from, next) => {
//     if (to.path === '/newChat' && to.query.platform !== 'wechat') {
//         next({ path: '/xiaoI', query: to.query })
//     } else {
//         next();
//     }
// })

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/main.js


/* eslint-disable no-new */








vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */], { position: 'bottom' });
fastclick_default.a.prototype.focus = function (targetElement) {
  if (targetElement.type !== 'number' && targetElement.value) {
    targetElement.selectionStart = targetElement.selectionEnd = targetElement.value.length;
  }

  targetElement.focus();
};
fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "PCAH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RhUM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/noorder.e8d4eba.png";

/***/ }),

/***/ "TS1M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bOeY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fHXO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gmhV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAACyCAYAAABBVyOTAAAdAUlEQVR4Xu2dB3QU1RrH/7tpJAQIAVKo0qtAQAQRpQmoFEVUUB/VhwUUUJAmTZooSlNBUaPgAxFBpINKFekQeu8QCKEkSAmQ9s6dZJbZ2dndmZ3Z2Z3JN+fkpOwt3/3f+8t3+1hADylAChhGAYthLCVDSQFSAAQsNQJSwEAKELAGqiwylRQgYKkNkAIGUoCANVBlkamkgJbAapkW1QwpYEYFstUWSg1kauKqtZvikwJmUEAxwJ5A50kcJq6n8cxQMVSGvKGAYgBzZZEdTylEcsPLDcdXo9LweaP6qZT+qIBsuBTCKCtduaDICScVRk48f6wUsokUUKuAFIByoHQZRg5Q7sKIP3f3O3lVtU2B4vuLAs7gEv/d3e/i8jiF1h2MrsaersAUfiYXYH+pBLKDFFCqgCsghZ/JBddjYJ0B7QxI/u/i7+4mneT841AqIoUnBbyhgKsuqxSc/N+cgSvXS3NlcQWKEliFgHoKrTfEpTRJAb0UcAerGFxXnpe32QFmpcBKeVb2N2fAKvW0eolL+ZACWirgDFYhpM5+dgonAFXAimEVQ+rudyXjYS3FpLRIAS0VcNeFZZ+L4XT3uzNoZQPraolGCkzey4q/85CSp9WyyVBa/qKAXM/KQyz1nZVFapwrCbGccarQM8qCtXXr1sHx8fFtIiIi2gQGBtaxWq0xAML9RWWygxTwkgK3srKykjIyMnanpqYu69Gjx7Lly5ffzwXSU2jtvKwnwDrzplY2lk1KSmobFRU11mKxlPOSKJQsKWAIBbKzs08lJycPi4mJWZoLbZYbeIXe1mMPKzXry/7GAZr7Za1cubI1ISFhdGhoaD9DqElGkgI6KZCWljYlLi5uxNGjRxmwQmiFPzvrGrv1sM42Okh5Vh5a6507d8YQrDq1AMrGcAowaMPCwoYLgHXmbV16WVeTS7wo4mUbO8+a2w1uFx0dPddwKpLBpICOCly+fPnVmJiYJRLdYx5eHlanO6LcAetqkomBa2UTTEuXLt1JY1Yda56yMqQCbEzbtm3bR3InosTdY+GklNjL2gD2BFhbN5gBe/ny5fZRUVGzDakgGU0K6KxAcnJyl+jo6EW5XWPes4q7x6qA5aF26AozYO/du/d9cHDwyzqXm7IjBQypwP379+eHhIS87mQsy8CV6hYr8rDiySY7D5uZmbnbarVWMKR6ZDQpoLMCWVlZJwICAuq48bDC3VJ23lZOl1gKWG78yr6ys7MTaVOEzrVO2RlZgVsWi6WEAFh3Y1nZwEpNONl511xgbxhZPbKdFNBbAYvFUkgELPOorsaxsrrEzoDloQ3IBTZV7wJTfqSAkRWwWCwRuYBmCpZ4NAfWwbsSsEZuNmS7rxQQAMt3h6Vmi4VdYY88LAHrqxqmfE2lgB7Aipd0+EmngOzs7BRTqUmFIQW8rIDFYikMgHWHxR5WOJZV5WEJWC9XIiWfdxTwJrDONk2Qh8077YtKqrECMoDlvavDwXZ3N0uIgRWPY6lLrHFlUnLmV0ACWGFXWGq3k+xJJ1fA8ss6NIY1fxujEmqoQC6wDEx+HEvAaqgvJUUKaKoAAaupnJQYKeBdBQhY7+qraepXk2/hwJ5LSLmepmm6vkiscGQoatSORdEoul9Pif4ErBK1fBh209qT+GHGNqSns6GLOZ6goAB0f7s+GjUrb44C6VAKAlYHkdVmwTzroN5LTAUrrwmD9pOv2pGnldlICFiZQvky2Po/jiN++lZfmuDVvHv0aoAmLSt6NQ+zJE7AGqAmF83bh0Xz9hrAUs9MbN+pFtp3qulZ5DwWi4A1QIVLAVu1RjSq1GAvRTDWc+RAEg4fuGxnNAErvw4JWPla+SykFLCaNvJDMm/pqXZCtQZeL4tqC/07AQLWv+uHs87rjZyANUAryDGRgDVAVRGwBqgknUwkYHUSWk02BKwa9cwVl4A1QH0SsAaoJJ1MJGB1ElpNNgSsGvXMFZeANUB9ErAGqCSdTCRgdRJaTTYErBr1zBWXgDVAfRKwBqgknUwkYHUSWk02BKwa9cwVl4A1QH0SsAaoJJ1MJGB1ElpNNgSsGvXMFZeANUB9ErAGqCSdTCRgdRJaTTYErBr1zBWXgDVAfXodWB01MFNZdJTNlhUB6wvVFeZppkZuprIorEZNghOwmsjo3UTM1MjNVBbv1rp06gSsL1RXmKeZGrmZyqKwGjUJTsBqIqN3EzFTIzdTWbxb6+RhfaGvJnmaqZGbqSyaVK7CRMjDKhTMF8HN1MjNVBZftAUC1heqK8zTTI3cTGVRWI2aBCdgNZHRu4mYqZGbqSzerXUaw/pCX03yNFMjN1NZNKlchYmQh1UomC+Cm6mRm6ksvmgLBKwvVFeYp5kauZnKorAaNQlOwGoio3cTMVMjN1NZvFvrNIb1hb6a5CnVyOndOppIa7hEyMMaoMqkgDWA2bJN1PQ9QbJzNWZAAtYA9UbvhzVAJelkIgGrk9BqsqE3sKtRz1xxCViD1OemtSfxw4xtSE/PNIjF7s0MCgpA97fro1Gz8u4DUwhOAQLWQA2BedoDey4h5XqandU3UtOwdtUxtyWpW780Spct7DacVIC0O+nY+vdppKbY5x0aFowSpQrhzKnryJD4ZxJbshAebVgGVqvFLtnCkaGoUTsWRaPCPbInr0YiYE1S80PeXYrE86l2pQkMCrCDqFbdEug/vJniEh87fAVffrrBAdaY4gUx6KOnwKCdMOJPnDl5zS7t2o+URN/BjREQaFWcJ0WQVoCANUnLWDBnD5b8ut9Wmrh6JfHia7XxYb9ltr8xL/fZ18/L9mqZGVlY/Ot+LFlwAFmZWXZKla9UFO8Pa4agICs+GbkGJ49dsfv84bjieO/DpggkWDVtYQSspnL6LrHTJ65h5IAVNgOY15s++yWMHfqHHUwNG5fDW+897tbQQ/uSMOub7biUeMMhbN0GpfH2+42QnZWNiR+twbHDyXZhqtWMRf9hTREUHOA2HwqgTAECVplefh263+sLcf3aHZuNg0e3ABvfzpi0yc7ul/4ThzYdasBiP6zkwpw7nYIFcxKwZ2eiQ1ktFgvavfQwOrxaC/fvZ+Lz0Wtw+MBlu3BVqkdjwMjmCCZYvdJWCFivyOqbRL//ais2/HnclnmnbnXxzHPV8NHAlTh1/KqdUaUfKowGT5YFm/zJnz8YV5JvY+eWsw4A8pEiIsPwRp+G3ERRenoWJo1di4N7L9mlWbFqFAaObI6QfIG+ESAP5ErAmqiS16w8ynVj+adR0/J4o29DnD+TgrFDViMtLV1xadm4t2mrSmBeOSx/EDIysjBl/Hrs223vgdmYlk1A5QsNUpwHRZCvAAErXyu/D3n0UDLGDV1ts/Oh8kUw+vNnud/ZZ1M/Xo9bN+/JLkfl6tF4pVtdlKtYhIuTmZmNaRPWI2HHBbs0WD6s+82Apse7ChCw3tVX19QZjL06z7flGV4gBNN/etn2+7837mJu/C5s23QGmaJZX6Gh7GABG+OymV7+ycrKxpefbsTOreccutZDxrZE/vBgXcuaVzMjYE1U8zdv3EXvrr/aShQVU4BbxhE/N1LvYueWczh3+jquXc2ZpGJwP1Q+EnUeLQkWT/iw2eDpkzZxoAufEqUiMHRcSxQoGGIiFf27KASsf9ePIuvEXeJyFYti1MRnFKUhDpydDXwz5R9s3nDK7qPYEoXw4fiWKFgon6r0KbIyBQhYZXr5dej46VvBTvbwT5OWFdGjVwNVNn/7xRb8veaEXRrRsQU5WCMKh6pKmyIrV4CAVa6ZV2LM+nob1sjYDyyVeUCAFRWqFMPxI1fsdiQNG98KlapFeWzvD9O3Yp3gHwBLqFh0AXw4riUii4Z5nC5F9FwBAtZz7TSN+d0XW7BR5MnUZMC84MQZz3mcxOyZO/DXiiN28YsWy4+h41qhaFR+j9OliOoUIGDV6adZbLYbacvG05qkx3YkDRjRzG6WV0nCc+N3YtWSw3ZRIouEcbBGxdDpGiVaah2WgNVaUQ/TmzZhg23JpM9r8/FIdXtgnCV7/GwpjP2mO7KRs88wMMCKLm/VR5MWFTyy5JfZCVj+2wG7uGysymCNKW4/e+xRBhRJlQIErCr5tIv8+Zi12LsrZ/dQ/65zUavyg8kjd7lMm9MROw9W4YKxrYMDRz3lLork5wvn7sXi+fvsPisYEYqhY1ugeMlCHqVJkbRVgIDVVk+PU5sw/E8c2p/ExR/y+ixULW+/5ukq4aSrRTB4cm9kZVvYjQTc2FW8luoqPtvB9Pu8vdxROuHD1leHjGmJkmUiPC4XRdRWAQJWWz09Tm3MkNU4nntMbcSb8ahQ5ryitCb/9AoSDlfi4rBdSi93jnMbn5133bDmJJYtPAB2m4XwyR8egsFjWqCMhzdUuM2cAnikAAHrkWzaRxrRf4XtxoYx78xEmeL2J2Hc5bjnSCVMmv0KF6xwZBimfN9B8vgc+5ztdNr41wn8teIoUq4/OI7H5xGWP5jbyF+2Qs4eYnr8RwEC1k/qQnjFy4R+01E8yv4GB3dmZmVZ0XfC+7hxK2fJhQFXvVasLdrduxncdkQ2E31wX5LDDRJ8wNDQIAz86Cmw0zf0+J8CBKyf1MmAt35HctJNzprP+n+BqCLXFVs2d3krrPonZ2dTw8Zl8XS7ajh57Cr2JVzEwT0XuUPnzh524Lxxi4po80J1FC5CmyIUi69TBAJWJ6HdZdO3x0Jb93Tq4MkoXPBfd1EcPj+dWBwjv+qpKB47v9q0ZUU82746CkXQvmBF4vkgMAHrA9GlsuzdZT5u/ptzVnX6sIkID3McW8oxddCkd3DpqvuxJzvDykB9rHFZ5KMbIuRI6xdhCFi/qAagZ6d5uHc350aI70aNR3Cw8tshWNzf/mqK39c+KVmq6NgCaNDoIQ5SWlf1k4pXaAYBq1AwbwXv1mGObSJo1tjRsFizPcoqMTkKQ6a8zcVla7LsfCu7a6lmXHFaT/VIUf+KRMD6QX2w2xy6vfA/r1jyzsAnuZv36TGHAgSsH9TjvbsZ6NnpZ69YwmBl0NJjDgUIWD+ox1s376NX51+8YklISCC+mv0SgkPo6lGvCKxzogSszoJTdqSAGgUIWDXqUVxSQGcFCFidBafsSAE1ChCwatSjuKSAzgoQsDoLTtmRAmoUIGDVqEdxSQGdFSBgdRacsiMF1ChAwKpRj+KSAjorQMDqLDhlRwqoUYCAVaMexSUFdFaAgNVZcMqOFFCjAAGrRj2KSwrorAABq7PglB0poEYBAlaNehSXFNBZAZ8C2/m52Sk6l5eyIwUMrcBPi7sUBpAFgF2Byb6zq0mE31n52N/4K0tsV5fkvH3J/uH/xr7zP1tzfxZ+DwBgJWAN3XbIeB8oQMD6QHTKkhTwVAEC1lPlKB4p4AMFCFgfiE5ZkgKeKkDAeqocxSMFfKAAAesD0SlLUsBTBQhYT5XzUbyX/lMbkUXzI376VqTnvtyKvROndNnC2J+g7BWVrAgdu8Rh2z9nceak9Mu3ikblR/OnK2H/nks4tC/nhdNqn+c71uQuTV+y4IDapPJcfALWT6u8aauKaNS0PGbP3I6zpx7ANOnbFxAUZMW73RbYLB84qjmq1YzFL7N3Y+Xvh2SXqFK1KAwb3woJ289j8vj1XLwChfLhzu37YC97Zg8fZsGcPVgiekO77IxEAafGd8DdtHQM6r3E0yTybDwC1k+rfsCI5qhRKwa9u/6K27fuc1aGFwjB9J9exp6diZg0dq3N8kKFQ9F/WFOwF1ytXXUMP369TVapeg94AvUbPYSPh/2Bwwcuc3E+nf4cQsOCbP8QvAHsFz++yL34a2ifpbLspEAPFCBg/bA1sHe1Tv9fR5w9eQ1jhqy2WVijdiwGjnoKv/+yD7/9vNfOcnZReJ9BT6JmnRJYs+oYZrmBNqJwKCZ/9wISz6Vi2HvLubTYe2Gnft8Bu7aew9QJG7zmYb+a/TKuXb2NEe/n5EuPfAUIWPla6RayVt3i6D+8OX79XwKWCsZ57GXLL3epgynj12H39gsO9gQFB+CDkc1RqUoxjBq40um4lEVs/0ottO9YEzOnbcamtSe5tB5vUhZv9muEn3/cZetaa+1hLRbgu/mv4tSxqxj34R+6aWqWjAhYP6zJ//y3Hlq2qYJh7y3DudMPtlu/88GTePTxMuj7+kKkXJN+fyzrzlasUgz7dl90WrKQfIH47Ovnuc/f++9vyMgdr/Z89zE80bwCdmw+iyuXb3GfRxYNQ4MnyuLY4WScOHLFIc15s3YrUpBNYk2a+QJn32ej1yiKS4EBAtYPW8HEGc8hOrYgUq/fse3gZmYWKJgPgYFW25va5Zg+edw6B0/733cfw5PNK+CvFUcwe+YOLhnmnSfPbI+CEaFykrWF6dr+J2QreDPmw3HFuV7Av6lpeLf7AkVxFRlm0sAErJ9VbIGCIegzqLGDVeEFQ1CiVASuXrmNa8k53k/OwyagEs/fsAV9pEEp9BnchPt9xaKD4D0k8+jMsy9deADr/zhuC1+uYlGwyalVSw7hz+VHHbLkPbEcW1iYVm2r4LXX63HBRw9aiRNHr8qNSuFAHtYwjaBj1zpo3b46Ph+zBnt3Oe/uuioQm2gaN7Ut2D8FIbBsmejzb9rDGmBF/zcXgb3+kn/4MezCuXuweP5+1Xp1fas+t67LHvbP4defElSnmZcSIA9rgNq2WC3c7G1QUADe6TofmZkK+qCC8rH12hq1i2PDn8fRuEVFm4dt0boKOveshznf78DqpUfsFNEa2AlftkPhyFCkpqQhKwsY8i6txSppggSsErV8FLZW3RLoP7wZki7+iy1/n3Frxb5diTh5zL6rWaRYfkz+9gVs+OsEVv5+EBO+fM4GbOVqUXijb0NuIwM/ASX2sFpsnKhZpzjY+vK61cdw4VwqOvd81GFizW3h8ngAAtYADaDv4Mao26C0bEulPCWL3KNXA8yauR1R0eH45KsHwLLP2PbGG6l3HfLQclln0EdPoXqtWIz6YAUuJf6LafEdcPTQFZotll2zNIZVIJVvgrI9wmMmtYbFYkF2djbYrK+ziZpXutXhlmXEy0Fiy2NLFLQDNiDQitDQIMkCVqhSDO9/2JQbb0pte2Q28TuxXClUqkwEN36+cDYFQ/su44KyfyBNWlbEJyP+xEGN9in7ppb0y5U8rH5ae5TT+8OaofYjJfDttM14pXtd3Lp5j9uZdP/eg4khljADgoGdsDMRUz/O2Rfs7BEDy3e5PTEw5fod9O2x0G1UfhvktAnrsXPreS58dGwBDuKLF27Qrie3CuYEIGBlCuWLYGwDxPAJTyNhxwXOsz7epBze7Pc4Nm84jW+m/oPsrJzJJ7YRYsiYFmBLMMPfX253WEDKbjGwJUoVQrPcmVtx+IjIMNR7rDROHruCU8evOSR35046Fs7Z41Kep56tjC5vPIqdW89hWu6WRz5Cu5cexouv1casb7ZjzUrHZSNf6O7PeRKwflo7bCPDR589y3khNpOanJSz9vpG38fRqGk57gDAlxM3IiDAggHDm6Fi1SjM+3EXVsg4rSMG1pUEasew1WrGcBsl2FLR4HeWcLPDwofZP2ZyGzCbJo1dh/0Jni1Z+Wk1am6Wr4BlNygG0K2JzuuTeSTmmdiRNjZDyz9sLy77rPkzlXHqRI7HK1ehCJYvOohfZG4T1AvYqJhwjJr4LPKHB+Pryf9gy8bTkgUuX6koPhzXEukZWRg7ZDXOn6Hbb521jFxg+StOvXrNKbv2lIHKfxGwTmqldr2S3ETP9au3MbD3EofxKos28KOnUKNWLJcCa+AjB6xwWJJxVul6AFs0KpxbimLdbWez1kL72B7pXv2f4Dww2wF1/ar0XmnNXZbBEpQAloeWv5+Ylcije4lZRB5S/p5iAtZNA2GzsgNHNudCfTrqL4cZ4bIViuDV7nVRuXo07t1Nx+3b6YgsEoarybew+Nf9+HvNSWTljm19BWydR0uiZ5/HOc+qZIcUG0d3e6s+bqSmYcakTZrdcGEwJl2aKwNY8QXisi8SJ2AVtpRyFYuArVUGBAbg89FrbIfKWTKVqhZDyzZVUa9haW6JZ/vms5gbv5M7CP50u6po06EGtzSTnHSTOw+7ad0p3LzhuK7K0vKWh7VaLXi5cxyeeb4aV/Lf5+/HItG5XXeSsCOEL3WO4w4FsHO/i+fvowMCAtH0AFboZYUelt38n+quAvPS5x9/0Y6bZJr68TpuvzDbkti4eXluLFu6bCQnxbkzKfj5h104uNf+/iZ2tUv7jg/jiWblEZIviOses6tflv12EKdzx7q8lt4Alp0iGjS6BdiuKbb0NHPqP9zEmCcP89Bsci0sfzAO7LmIiaPX2mbEPUnPTHF+WtwlIvfVHKwrzH8JX9eh2sMSsDJbTKNm5XEvLR07tpyzxRg6riUHATs/umrxIbcbDNh5WAYtm5RiYI4evMrhHKs3gGUGs/O0sSUL4auJG3FN5Rg0KqYA+gxujL27EumAgL2H1QVY4YQT+5l/tw55WDcwxxQvANbVvHjhX5nYPwj2UPlIyVsnmOdq2Lgst157XOJQujAjNg5lS0aXLtzA5Us3XdrArqnJzMj0+HCCOHG2tMUug3M3JlcsjIEjCDwsmynmPatw4kkTDyvpZXt2+vkGuz2PHlKAFHCvQL7QIHw775VCoi6xuDvsEbAsd35mWPjdbgz7wduLUpIu3mR/o4cUIAXc97ayJs5oz79uUjyG5ZdyhEs6LEVZs8SugLV1j6d8vC5x19bzBaimSAFSwL0CdRuUutlvSNMSLiabhNDyCSoGlkXk3w1r1zVeufjA6rnxuxu6N5VCkAKkwKs96mx+5rkarSRe5Oxs04RiDyv2tMKXOlvPnbv04rTxW39wN5lBVUUK5HUF2HJfn6ENupcuHcte+eBsOcfhretKu8Qux7KtW7cOHjboy0PTP/87Jq9XCJWfFHClQK/+TySN/eSdasuXL2evgRACKzV2Fd4hJLtLLISV/9mha5yUlNRu/arEuWzzOj2kACngqAC7fK/J0yVejYmJYRdgiWeF+SUdvvsrvvBLMbBuJ6Bu3bozZtmCw/0IWmqupIC9AgzWNi9WnRIeHjbcydhVPNGkCFgeTj5XNskk/JvwEIDt58qVK1sTEhJGH9p3tR8700ljWmq2eV0BNmbt1K0uqtUsOiUuLm7E0aNHxd1g4WYJ4eSSZHdYDKZQXx5SKWil1mZtM8dJSUltIyOLjU3Ycb7c7m3nuT2wKdfTuFcT0kMKmFkBtimCXf/KTmPVqV8KcfVKnbp+/cqwmJgY9oo/qc0R7sauQojtvKZYR1fAOuse20BmE1Hx8fFtIiIi2gQGBtaxWq1sQirczJVFZSMFANzKyspKysjI2J2amrqsR48ey3InmMRgugLVaXdYiYcVd4ndQpu7S0oYzllXm2qaFDCqAlJdV/HBczWwyvawUjALvS7vTcXguvpd6T8Io1Yi2W1uBcQekC+tcP1U/LO738VpOPud2yvs7JH6TAytlAcVTlKJJ6xcQWvuaqbSmVkBuZ6W95guN0cIhHL456AUWGfdWleQSkFu5sqjsuVNBZxB6wxSpzPBngIrtwvrzOs6g1uqOl3948ib1U+l9lcFnHWJeTClusjOPhP/XVhmyXzkgOIsjLOZZHegysnTXyuL7CIFpBRwNbPrypO6Gw875CUHHndhXIEr10tTMyAFjKiAXOBcLtVIFNypF3cHI5+WnHDuJqmMWCFkMyngqQJS0LnqTou70pL5ygFRGFFueLnhlPxD8FQ4ikcKaKmAHOjcjkWVeFVPAFQbx1XXWEsxKS1SwJcKKIVZllfVAj4C0JfNgvI2iwKKAVfadXUllJZpmaVCqBykgCfdY6eqEWTUoEgBAylAwBqosshUUoCApTZAChhIAQLWQJVFppICBCy1AVLAQAr8H087vKPZkRcrAAAAAElFTkSuQmCC"

/***/ }),

/***/ "i+A6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j4ie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksc/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("TuEr")
}
var alert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (alert_Component.exports);


/***/ }),

/***/ "o0NM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vqWB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xBBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yy5e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b9ee5748229c0366a25b.js